import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Line } from "react-chartjs-2";
import "chartjs-adapter-date-fns";
import AccessibleTable from "../../Pages/Create-Investment/member-table";
import OtherDetails from "../../Pages/Create-Investment/Other-details";
import DocumentsSection from "./../../Pages/Create-Investment/DocumentSection";
import DropdownTest from "./../../Pages/Create-Investment/ndrop";
import DocumentPopup from "./view-application-popup";
import { FaPlus } from "react-icons/fa";
import PerformanceSection from "./../../Pages/Create-Investment/Performance-Graph";
import { useDispatch } from "react-redux";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { useToast } from "../../Utils/toastContext";
import { toast } from "react-toastify";
import {
  addSelectedUsers,
  resetSelectedUsers,
} from "../../Redux/store/selectedUserSlice";
import { addDocumentId } from "../../Redux/store/documentSlice";
import InvestorDetailPopup from "../../Pages/Investment-Request-List/investor-detail-popup";
import { resetDocumentId } from "../../Redux/store/documentSlice";
import { debounce } from "lodash";
import {
  svgLogoBase64,
  svgBookBase64,
  svgGraphBase64,
  svgDiagramBase64,
  svgInfoCircleBase64,
} from "../../Constants/config";
import { useSelector } from "react-redux";
import DownloadReportButton from "../../Components/DownloadButton/download-button";
import DOMPurify from "dompurify";

ChartJS.register(ArcElement, Tooltip, Legend);

const InvestmentDetailsByID = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const loggedInUserRole = useSelector((state) => state.user.roleName);
  const location = useLocation();
  const { showToast } = useToast();
  const { from, directView } = location.state || {};
  const investment_id = useSelector((state) => state.investment.investmentId);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const dispatch = useDispatch();
  const [addToDashboard, setaddToDashboard] = useState(false);
  const [addMember, setaddMember] = useState(false);
  const buttonRefs = useRef({});
  const [isOpenStatus, setisOpenStatus] = useState(false);
  const [status, setStatus] = useState("");
  const [tradingTab, setTradingTab] = useState(
    directView == "taa" ? "tta" : directView == "daa" ? "dda" : "rebalancing"
  );
  const [componentName, setComponentName] = useState(
    directView == "taa" || directView == "daa" ? "saa-taa" : ""
  );
  const [expandedCategory, setExpandedCategory] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const allFilteraStatus = [];
  const [latestId, setLatestId] = useState(1);
  const [dashboardFilter, setDashboardFilter] = useState("transaction");
  const [productData, setProductData] = useState([]);
  const [australianCashStockAllocation, setAustralianCashStockAllocation] =
    useState(0);
  const [newClientAccountData, setNewClientAccountData] = useState([]);
  const [clientUserId, setClientUserId] = useState(null);

  const [clientAccountId, setClientAccountId] = useState(null);
  const [clientAccountBalance, setClientAccountBalance] = useState(0);
  const [preSelectedClientAccount, setpreSelectedClientAccount] = useState({});
  const [rebalancingData, setRebalancingData] = useState([]);

  const handleContinue = () => {
    setLoading(true);
    downloadPDF();
  };
  const downloadExcelReport = async () => {
    const token = localStorage.getItem("jwtToken");

    try {
      const response = await fetch(
        `${BASE_URL}/v1/investment-portfolio/factsheet/${investment_id}/export/excel?period=${selectedFilter}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          // Example: redirect to login page
          // window.location.href = "/login";

          // Or throw a custom error
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const downloadExcelReportHistoricalPerformance = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const bodyData = {
        portfolio_id: investment_id,
        time_interval: selectedFilter,
      };
      const response = await fetch(
        `${BASE_URL}/v1/investment-portfolio/download-simulated-performance`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(bodyData),
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          // Example: redirect to login page
          // window.location.href = "/login";

          // Or throw a custom error
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const handleExcel = async () => {
    setLoading(true);
    try {
      const csvBlob = await downloadExcelReport();
      const url = window.URL.createObjectURL(csvBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Factsheet - Caprock Model Portfolio - ${investmentProductName}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setLoading(false); // Ensure `loading` is false first
      }, 100);
    }
  };

  allFilteraStatus.push({
    value: "approved",
    label: "Approved",
  });
  allFilteraStatus.push({
    value: "rejected",
    label: "Reject",
  });
  allFilteraStatus.push({
    value: "",
    label: "All",
  });
  const [filter, setFilter] = useState(
    directView == "taa" || directView == "daa" ? "trading" : "details"
  );
  const [loading, setLoading] = useState(false);

  const [selectedFilter, setSelectedFilter] = useState("10Y");
  const [refId, setRefId] = useState("12345");
  const [selectedRange, setSelectedRange] = useState("Select Date Range");
  const [selectedDates, setSelectedDates] = useState([]);
  const [quickFilter, setQuickFilter] = useState("");
  const DateCalendarRef = useRef();
  const [specificUsers, setSpecificUsers] = useState([]);
  const [strategyType, setstrategyType] = useState("test");
  const [riskProfile, setRiskProfile] = useState("60.40");
  const [investmentType, setinvestmentType] = useState("sma");
  const [investmentManagerId, setInvestmentManagerId] = useState(null);
  const [subAdvisorAccount, setsubAdvisorAccount] = useState(null);
  const [InvestmentManagerAccount, setInvestmentManagerAccount] =
    useState(null);
  const [subadvisorId, setSubadvisorId] = useState(null);
  const [assetManagerId, setAssetManagerId] = useState(null);
  const [platformId, setPlatformId] = useState(null);
  const [custodianId, setCustodianId] = useState(null);

  const [advisorId, setadvisorId] = useState(null);
  const [advisorAccount, setadvisorAccount] = useState(null);
  const [platformAccount, setplatformAccount] = useState(null);
  const [assetManagerAccount, setAssetManagerAccount] = useState(null);
  const [custodianAccount, setCustodianAccount] = useState(null);

  const [filterStatus, setFilterStatus] = useState("");

  const [fundObjectives, setFundObjectives] = useState("");
  const [investments, setInvestments] = useState(["ASX ETFs", "LICs"]);
  const [growth, setGrowth] = useState(0);
  const [defensive, setDefensive] = useState(0);
  const navigate = useNavigate();
  const [isOpenDownload, setisOpenDownload] = useState(false);
  const [isLoading, setIsLoading] = useState(
    directView == "taa" || directView == "daa" ? true : false
  );
  const [isLoadingGraph, setIsLoadingGraph] = useState(false);
  const [isAllLoaded, setIsAllLoaded] = useState(false);
  const [apiSuccess, setAPISuccess] = useState(false);

  const [isLoadingRebalacing, setIsLoadingRebalacing] = useState(false);

  const [filteredData, setfilteredData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [investmentManagerNamefromAPI, setInvestmentManagerNamefromAPI] =
    useState("");
  const [custodianNameFromAPI, setCustodianNameFromAPI] = useState("");
  const [custodianAccountFromAPI, setCustodianAccountFromAPI] = useState("");
  const [assetManagerNamefromAPI, setAssetManagerNamefromAPI] = useState("");
  const [assetManagerAccountfromAPI, setAssetManagerAccountfromAPI] =
    useState("");
  const [investmentManagerAccountfromAPI, setInvestmentManagerAccountfromAPI] =
    useState("");
  const [advisorIdfromAPI, setadvisorIdfromAPI] = useState("");
  const [advisorAccountfromAPI, setadvisorAccountfromAPI] = useState("");
  const [subadvisorIdfromAPI, setSubadvisorIdfromAPI] = useState("");
  const [subAdvisorAccountfromAPI, setsubAdvisorAccountfromAPI] = useState("");
  const [investmentProductName, setinvestmentProductName] = useState("");
  const [riskRating, setriskRating] = useState("");
  const [smaFees, setsmaFees] = useState(0);
  const [smaFeesUpdate, setsmaFeesUpdate] = useState(0);
  const [platformFees, setPlatformFees] = useState(0);

  const [advisorFeesUpdate, setadvisorFeesUpdate] = useState(0);
  const [managerFeesUpdate, setmanagerFeesUpdate] = useState(0);
  const [subadvisorFeesUpdate, setsubadvisorFeesUpdate] = useState(0);
  const [platformFeesUpdate, setplatformFeesUpdate] = useState(0);
  const [custodianFeesUpdate, setcustodianFeesUpdate] = useState(0);
  const [custodianFees, setcustodianFees] = useState(0);
  const [assetManagerFees, setassetManagerFees] = useState(0);
  const [assetManagerFeesUpdate, setassetManagerFeesUpdate] = useState(0);

  const [brokerageFeesUpdate, setbrokerageFeesUpdate] = useState(0);

  const [isNewChangeFees, setisNewChangeFees] = useState(true);

  const [managerFees, setmanagerFees] = useState(0);
  const [advisorFees, setadvisorFees] = useState(0);
  const [subadvisorFees, setsubadvisorFees] = useState(0);
  const [strategyDate, setstrategyDate] = useState("");
  const [minimumInvestedAmount, setminimumInvestedAmount] = useState(0);
  const [investmentManagerNameView, setinvestmentManagerNameView] = useState(0);
  const [dateCreated, setdateCreated] = useState(0);
  const [strategyTypeView, setstrategyTypeView] = useState(0);
  const [newCategories, setNewCategories] = useState([]);
  const [existingCategories, setExistingCategories] = useState([]);
  const [actualCategories, setActualCategories] = useState([]);

  const [preselectedManager, setPreselectedManager] = useState([]);
  const [preselectedCustodian, setpreselectedCustodian] = useState([]);

  const [preselectedAddToDashboard, setPreselectedAddToDashboard] = useState(
    []
  );
  const [preselectedAddUser, setPreselectedAddUser] = useState([]);

  const [totalCount, settotalCount] = useState(0);

  const [preselectedManagerAccount, setPreselectedManagerAccount] = useState(
    []
  );
  const [preselectedCustodianAccount, setPreselectedCustodianAccount] =
    useState([]);
  const [preselectedAdvisor, setPreselectedAdvisor] = useState([]);
  const [preSelectedAssetManager, setPreSelectedAssetManager] = useState([]);

  const [preselectedAdvisorAccount, setPreselectedAdvisorAccount] = useState(
    []
  );
  const [preselectedSubAdvisor, setPreselectedSubAdvisor] = useState([]);
  const [preselectedSubAdvisorAccount, setPreselectedSubAdvisorAccount] =
    useState([]);
  const [platformAccountfromAPI, setPlatformAccountfromAPI] = useState([]);
  const [platformIdfromAPI, setPlatformIdfromAPI] = useState([]);
  const [preselectedPlatform, setPreselectedPlatform] = useState([]);
  const [preselectedPlatformAccount, setPreselectedPlatformAccount] = useState(
    []
  );
  const [preselectedAssetManagerAccount, setPreselectedAssetManagerAccount] =
    useState([]);
  const [isNewChange, setisNewChange] = useState(true);
  const [stockPrices, setStockprices] = useState([]);
  const [combineIndex, setCombineIndex] = useState([]);

  const [totalPages, settotalPages] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenEdit, setisOpenEdit] = useState(false);
  const togglePopup = () => setIsOpen(!isOpen);
  const [isCurrentInvestorSelected, setIsCurrentInvestorSelected] =
    useState(true);
  const [clientId, setClientId] = useState("");
  const [isClientExist, setIsClientExist] = useState();
  const [clientName, setClientName] = useState("");
  const [creatorId, setCreatorId] = useState("");
  const [isCreatorExist, setIsCreatorExist] = useState();
  const [creatorName, setCreatorName] = useState("");
  const [investorClientFirstName, setInvestorClientFirstName] = useState("");
  const [investorClientLastName, setInvestorClientLastName] = useState("");
  const [investorClientEmail, setInvestorClientEmail] = useState("");
  const [investorClientPhone, setInvestorClientPhone] = useState("");
  const [investorClientAccountBalance, setInvestorClientAccountBalance] =
    useState("");
  const [investorClientAbn, setInvestorClientAbn] = useState("");
  const [isInvestorAvailable, setIsInvestorAvailable] = useState(false);
  const [investmentAmount, setInvestmentAmount] = useState(0);
  const [portfolioData, setPortfolioData] = useState([]);
  const [portfolioDataAvailable, setportfolioDataAvailable] = useState(false);
  const [isUserPopOpen, setisUserPopOpen] = useState(false);
  const [isDropdownOpenDate, setIsDropdownOpenDate] = useState(false);
  const [details, setDetails] = useState(null);
  const [stockpricesPpdf, setStockpricesPdf] = useState([]);
  const [setCombineIndexpdf, setCombineIndexPdf] = useState([]);

  const [rawDatapdf, setRawDatapdf] = useState([]);
  const [factSheetFileName, setfactsheetFileName] = useState("");
  const [rawDatahistory, setRawDatahistory] = useState([]);
  const chartRef = useRef(null);
  const [rawDatahistorypdf, setRawDatahistorypdf] = useState([]);
  const [popupDataTable, setPopupDataTable] = useState([]);
  const DownloadDocRef = useRef();
  const DownloadDocBreakdownRef = useRef();
  const handleExcelHistoricalPerformance = useCallback(
    debounce(async () => {
      try {
        const csvBlob = await downloadExcelReportHistoricalPerformance();
        const url = window.URL.createObjectURL(csvBlob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Historical Performance - ${formattedDate}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (err) {
        showToast(err.message, "error");
      } finally {
        setTimeout(function () {
          setLoading(false); // Ensure `loading` is false first
        }, 100);
      }
    }, 1000), // Debounce time
    [selectedFilter, investment_id] // Dependencies
  );
  const cleanAll = () => {
    setproductCode([]);
    setminimumInvestment(0);
    setExistingCategories([]);
    setActualCategories([]);
    setfilteredGraphdata([]);
    setStockprices([]);
    settotalPortfolio(0);
    setRawDatapdf([]);
    setChartImage(null);
    setCombineIndex([]);
    setCombineIndexPdf([]);
  };
  const [holdingValuationData, setholdingValuationData] = useState([]);

  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${today.getFullYear()}`;
  const filterOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ];
  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 10,
    label: "10",
  });
  const dropdownRef = useRef();
  const [openDropdown, setOpenDropdown] = useState(null);
  const toggleExpandCategory = (categoryId) => {
    setExpandedCategory((prev) => ({
      ...prev,
      [categoryId]: !prev[categoryId],
    }));
  };
  // table items
  const [dropdownStates, setDropdownStates] = useState({});
  const [stocks, setStocks] = useState([]);
  const [australianCashStockId, setAustralianCashStockId] = useState("");
  const [productCodes, setproductCode] = useState([]);
  const [categoryCodes, setcategoryCodes] = useState([]);
  let allocationErrors = [];
  let totalAllocationErrors = [];
  let allowedPercentErrors = [];
  let allowedPercentErrorsCategory = [];
  let twoPercentAllocationErrors = [];

  const [totalErrors, setTotalErrors] = useState({});
  const [allowedPercentError, setAllowedPercenErrors] = useState({});
  const [allowedPercentErrorCategory, setAllowedPercenErrorsCategory] =
    useState({});
  const [twoPercentErrors, setTwoPercentErrors] = useState({});

  const [errors, setErrors] = useState({});
  const [minimumInvestment, setminimumInvestment] = useState(0);
  const [totalPortfolio, settotalPortfolio] = useState(0);
  const [dropdownOpen, setDropdownOpen] = useState([]);
  const [isAnyDropdownOpen, setisAnyDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [securityCodes, setSecurityCodes] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [newStockCode, setNewStockCode] = useState("");
  const [newStockPrice, setNewStockPrice] = useState(0);

  const [stockName, setStockName] = useState("");
  const [productType, setProductType] = useState("");
  const [newStockExchange, setNewStockExchange] = useState("");
  const [volatility, setVolatility] = useState("");
  const [historyChartImage, setHistoryChartImage] = useState("");
  const [chartImage, setChartImage] = useState(null);
  const reportRef = useRef();
  const valuationRef = useRef();
  const [isHiddenTablePdf, setIsHiddenTablePdf] = useState(false); // Initially hidden
  const [isHiddenBreakdownPdf, setIsHiddenBreakdownPdf] = useState(false); // Initially hidden

  const [isHidden, setIsHidden] = useState(false); // Initially hidden
  const historyChartRef = useRef(null);
  const [isHiddenReport, setIsHiddenReport] = useState(false); // Initially hidden

  // Download factsheet code
  const downloadPDF = useCallback(
    debounce(() => {
      setIsHidden(true);
    }, 1000), // Debounce time
    [factSheetFileName] // Dependencies
  );

  useEffect(() => {
    if (isHidden == true) {
      handleDownloadPDF();
    }
  }, [isHidden]);
  // End here
  // Download valuation report
  const downloadExcelReportHoldingValuation = async (userId, portfolioId) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/my-investment/user-holding-graphs/export/excel`;
    const bodyData = {
      portfolio_id: portfolioId,
      user_id: Number(userId),
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.blob();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(error.message || "Something went wrong");
    }
  };
  const handleExcelHoldingReport = async (userId, portfolioId) => {
    setLoading(true);
    try {
      const csvBlob = await downloadExcelReportHoldingValuation(
        userId,
        portfolioId
      );
      const url = window.URL.createObjectURL(csvBlob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Holding Valuation-${formattedDate}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setLoading(false); // Ensure `loading` is false first
      }, 100);
    }
  };
  const downloadValuationReport = useCallback(
    debounce((type, userId, portfolioId) => {
      if (type == "pdf") {
        getHoldingValuationReportData(userId, portfolioId);
      } else {
        handleExcelHoldingReport(userId, portfolioId);
      }
    }, 1000), // Debounce time
    [factSheetFileName] // Dependencies
  );
  useEffect(() => {
    if (isHiddenReport == true && chartImage != null) {
      handleDownloadValuationPDF();

      // html2pdf()
      //   .set(pdfOptions)
      //   .from(valuationRef.current)
      //   .save("Holding Valuation-" + factSheetFileName + ".pdf")
      //   .then(() => {
      //     setIsHiddenReport(false);
      //     setLoading(false); // Ensure `loading` is false first
      //   });
    }
  }, [isHiddenReport, holdingValuationData, chartImage]);
  // End here
  useEffect(() => {
    if (
      filter == "trading" &&
      tradingTab == "tta" &&
      isLoading == false &&
      isAllLoaded == false &&
      apiSuccess == true
    ) {
      toast.success(
        <div className="flex items-center">
          {/* Custom Image Icon */}
          <div className="mr-3">
            <img
              src="/info-circle-yellow.svg" // Replace with your image URL
              alt="Success Icon"
              className="h-6 w-6"
            />
          </div>
          {/* Text Content */}
          <div>
            <h3 className="font-semibold text-md text-black">Information!</h3>
            <p className="text-sm text-black">Only ± 10% change is allowed</p>
          </div>
        </div>,
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          icon: false,
          closeButton: (
            <button
              className="text-black"
              onClick={() => toast.dismiss()}
              style={{
                backgroundColor: "transparent",
                border: "none",
                marginBottom: "2.813rem",
              }}
            >
              ✖
            </button>
          ), // Custom close button
          className: "info-toast text-sm rounded text-black",
        }
      );
      setAPISuccess(false);
    }
  }, [filter, tradingTab, isLoading, isAllLoaded, apiSuccess]);
  const riskProfileData = [];
  riskProfileData.push({
    value: 1,
    label: "BUY",
  });
  const dataTable = [
    {
      id: 1,
      date: "12/12/2023",
      time: "13:34:01",
      transactionId: "#8930967873726",
      accountName: "John Mayer 1 - USD",
      convertRate: "$1",
      debit: "AUD $50,000",
      credit: "AUD $20,000",
      balance: "$70,000",
      details: {
        from: "ABC Bank 5886 9554 28374",
        to: "Caprock 5886 9554 28374",
        description: "Lorem ipsum consectetur adipiscing elit.",
        initiatedBy: "John Mayer",
        signatories: [
          {
            name: "Mark Larenza",
            details: "IP:192.0.2.1 | 12/12/2023 | 13:34:01",
          },
          {
            name: "Nellin Mogan",
            details: "IP:192.0.2.1 | 12/12/2023 | 13:34:01",
          },
        ],
      },
    },
    {
      id: 2,
      date: "12/12/2023",
      time: "13:34:01",
      transactionId: "#8930967873726",
      accountName: "Anfas 1 - USD",
      convertRate: "$1",
      debit: "AUD $50,000",
      credit: "AUD $20,000",
      balance: "$70,000",
      details: {
        from: "Anfas Bank 5886 9554 28374",
        to: "Caprock 5886 9554 28374",
        description: "Lorem ipsum consectetur adipiscing elit.",
        initiatedBy: "John Mayer",
        signatories: [
          {
            name: "Mark Larenza",
            details: "IP:192.0.2.1 | 12/12/2023 | 13:34:01",
          },
          {
            name: "Nellin Mogan",
            details: "IP:192.0.2.1 | 12/12/2023 | 13:34:01",
          },
        ],
      },
    },
    // Add more rows as needed
  ];
  const toggleRowDetails = (id) => {
    setExpandedRow(expandedRow === id ? null : id);
  };

  const [TransactionOptions, setTransactionOptions] = useState(riskProfileData);
  const handleCodeChange = (
    itemIndex,
    subcategoryIndex,
    categoryIndex,
    newCode
  ) => {
    const selectedSecurity = securityCodes.find(
      (item) => item.stock.asx_code === newCode
    );
    let t = updateStock(
      selectedSecurity.productId,
      selectedSecurity.categoryId,
      itemIndex,
      selectedSecurity.stock
    );
    setStocks(t);
  };

  const deleteStock = (stockId, realId) => {
    const updatedStocks = stocks.filter((stock) => stock.id !== stockId);
    setStocks(updatedStocks);
    const totalportfolio = updatedStocks.reduce(
      (sum, item) => sum + parseFloat(Number(item.allocation).toFixed(2)),
      0
    );
    settotalPortfolio(totalportfolio);
    if (realId === 93) {
      setAustralianCashStockAllocation(0);
    }
    validateAllocation(updatedStocks, productCodes, categoryCodes);
  };
  const updateStock = (productId, categoryId, stockIndex, updatedStock) => {
    const productStocks = stocks.filter((stock) => stock.product === productId);
    if (productStocks.length > 0 && productStocks[stockIndex]) {
      const stockToUpdate = productStocks[stockIndex];
      stockToUpdate.code = updatedStock.asx_code || stockToUpdate.code;
      stockToUpdate.name = updatedStock.name || stockToUpdate.name;
      stockToUpdate.unitPrice =
        updatedStock.unit_price || stockToUpdate.unitPrice;
      stockToUpdate.allocation =
        stockToUpdate.stockId == 93 && stockToUpdate.allocation < 2
          ? 2
          : updatedStock.allocation || stockToUpdate.allocation;
      stockToUpdate.stockId = updatedStock.id || stockToUpdate.stockId;
      stockToUpdate.stockquantity =
        (stockToUpdate.allocation / 100) * minimumInvestment ||
        stockToUpdate.stockquantity;
      stockToUpdate.stockMarketPrice =
        (Number(stockToUpdate.allocation) * Number(minimumInvestment)) / 100 ||
        stockToUpdate.stockMarketPrice;
      const updatedStocks = [...stocks];
      const productIndex = updatedStocks.findIndex(
        (stock) => stock.id === stockToUpdate.id
      );
      updatedStocks[productIndex] = stockToUpdate;

      console.log("Updated Stocks:", updatedStocks);
      return updatedStocks;
    }

    return stocks;
  };
  const toggleDropdown = (itemIndex, subcategoryId) => {
    const key = `${subcategoryId}-${itemIndex}`;
    setDropdownOpen((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
    setisAnyDropdownOpen(!isAnyDropdownOpen);
    setSearchTerm("");
  };
  const getRelevantSecurityCodes = (categoryId, subcategoryId) => {
    let test = securityCodes.filter(
      (code) =>
        code.categoryId === categoryId && code.productId === subcategoryId
    );
    return test;
  };
  const handleScroll = (indexToRemove) => {
    console.log("I xan scroll");
    setDropdownOpen([]);
    setIsMenuOpen(null);
  };
  useEffect(() => {
    if (dropdownOpen != null) {
      console.log("Dropdown for create opened, adding scroll event listener.");
      window.addEventListener("scroll", handleScroll, { passive: true });
    } else {
      console.log(
        "Dropdown for create closed, removing scroll event listener."
      );
      window.removeEventListener("scroll", handleScroll);
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [dropdownOpen]);
  const isDropdownOpen = (categoryId, dropdownIndex) =>
    dropdownStates[`${categoryId}-${dropdownIndex}`] || false;
  const [selectedProductsByCategory, setSelectedProductsByCategory] = useState(
    {}
  );
  const [tooltipVisible, setTooltipVisible] = useState(null);
  const validateAllocation = (
    updatedStocks,
    updatedProductAllocations,
    updatedcCategoryAllocations
  ) => {
    totalAllocationErrors = [];
    allocationErrors = [];
    allowedPercentErrors = [];
    allowedPercentErrorsCategory = [];
    twoPercentAllocationErrors = [];

    const productTotalAllocations = updatedStocks.reduce((acc, stock) => {
      acc[stock.product] = (acc[stock.product] || 0) + Number(stock.allocation);
      return acc;
    }, {});
    for (const product of updatedProductAllocations) {
      if (
        product.productId != 9 &&
        (Number(product.allocation) > 0 ||
          Number(productTotalAllocations[product.productId]) > 0) &&
        Number(productTotalAllocations[product.productId]) !=
          Number(product.allocation)
      ) {
        allocationErrors[
          product.productId
        ] = `Total allocation exceeds the limit of ${product.allocation}%`;
      }
      if (product.productId == 9 && Number(product.allocation) < 2) {
        twoPercentAllocationErrors[
          product.productId
        ] = `Total allocation exceeds the limit of ${product.allocation}%`;
      }

      if (
        tradingTab == "tta" &&
        Math.abs(Number(product.allocation) - Number(product.saaPercent)) > 10
      ) {
        allowedPercentErrors[
          product.productId
        ] = `Total allocation exceeds the limit of ${product.allocation}%`;
      }
      if (
        tradingTab == "dda" &&
        growth == 100 &&
        Number(product.saaPercent) > 0 &&
        Math.abs(Number(product.allocation) - Number(product.saaPercent)) > 10
      ) {
        allowedPercentErrors[
          product.productId
        ] = `Total allocation exceeds the limit of ${product.allocation}%`;
      }
    }
    for (const category of updatedcCategoryAllocations) {
      if (
        strategyTypeId != 1 &&
        category.categoryId == 1 &&
        growth != 100 &&
        Math.abs(Number(category.allocation) - Number(growth)) > 10
      ) {
        allowedPercentErrorsCategory[
          category.categoryId
        ] = `Total allocation exceeds the limit of ${category.allocation}%`;
      }
      if (
        strategyTypeId != 1 &&
        category.categoryId == 2 &&
        growth != 100 &&
        Math.abs(Number(category.allocation) - Number(defensive)) > 10
      ) {
        allowedPercentErrorsCategory[
          category.categoryId
        ] = `Total allocation exceeds the limit of ${category.allocation}%`;
      }
      if (
        category.categoryId == 2 &&
        growth != 100 &&
        Math.abs(Number(category.allocation) - Number(defensive)) > 10
      ) {
        allowedPercentErrorsCategory[
          category.categoryId
        ] = `Total allocation exceeds the limit of ${category.allocation}%`;
      }
      if (
        category.categoryId == 1 &&
        growth == 100 &&
        Math.abs(
          Number(category.allocation) -
            Number(growth - australianCashStockAllocation)
        ) > 10
      ) {
        allowedPercentErrorsCategory[
          category.categoryId
        ] = `Total allocation exceeds the limit of ${category.allocation}%`;
      }

      // if (
      //   strategyTypeId != 1 &&
      //   category.categoryId == 1 &&
      //   growth != 100 &&
      //   (
      //     category.allocation < growth * 0.9 ||
      //     category.allocation > growth * 1.1
      //   )      ) {
      //   totalAllocationErrors[
      //     category.categoryId
      //   ] = `Total allocation exceeds the limit of ${growth}%`;
      // }
      // if (
      //   strategyTypeId != 1 &&
      //   category.categoryId == 2 &&
      //   growth != 100 &&
      //   category.allocation != defensive
      // ) {
      //   totalAllocationErrors[
      //     category.categoryId
      //   ] = `Total allocation exceeds the limit of ${defensive}%`;
      // }
      // if (
      //   category.categoryId == 1 &&
      //   growth == 100 &&
      //   category.allocation != growth - australianCashStockAllocation
      // ) {
      //   totalAllocationErrors[
      //     category.categoryId
      //   ] = `Total allocation exceeds the limit of ${growth}%`;
      // }
      // if (
      //   category.categoryId == 2 &&
      //   growth != 100 &&
      //   category.allocation != defensive
      // ) {
      //   totalAllocationErrors[
      //     category.categoryId
      //   ] = `Total allocation exceeds the limit of ${defensive}%`;
      // }
    }
    setTotalErrors(totalAllocationErrors);
    setErrors(allocationErrors);
    setAllowedPercenErrors(allowedPercentErrors);
    setAllowedPercenErrorsCategory(allowedPercentErrorsCategory);
    setTwoPercentErrors(twoPercentAllocationErrors);
  };
  const handleProductAllocationChange = (
    productId,
    fromuser,
    categoryId,
    isDelete
  ) => {
    let newAllocation = "";
    if (fromuser == "") {
      newAllocation = "0";
    } else {
      newAllocation = fromuser;
    }
    // if (isDelete == false && productId == 9 && newAllocation < 2) {
    //   showToast("Australian cash allocation must be atleast 2%", "error");
    //   return;
    // }
    //     const productToUpdate = productCodes.find(p => p.productId === productId);

    //     const previousAllocation = productToUpdate.allocation;
    // const diff = Math.abs(newAllocation - previousAllocation);

    // if (diff > 10) {
    //   showToast("Allocation change exceeds ±10 limit.", "error");
    //   return ; // Skip update
    // }
    if (productId == 9) {
      setAustralianCashStockAllocation(newAllocation);
      handleStockAllocationChange(australianCashStockId, newAllocation, 93);
    }
    const updatedProductAllocations = productCodes.map((product) => {
      if (product.productId === productId) {
        return {
          ...product,
          allocation: newAllocation,
        };
      }

      return product;
    });

    setproductCode(updatedProductAllocations);
    const totalAllocation = updatedProductAllocations
      .filter((code) => code.categoryId === categoryId)
      .reduce((sum, item) => sum + Number(item.allocation), 0);
    const updatedcCategoryAllocations = categoryCodes.map((product) =>
      product.categoryId === categoryId
        ? {
            ...product,
            allocation: parseFloat(Number(totalAllocation).toFixed(2)),
          }
        : product
    );
    // const totalportfolio = updatedProductAllocations.reduce(
    //   (sum, item) => sum + item.allocation,
    //   0
    // );
    setcategoryCodes(updatedcCategoryAllocations);
    // settotalPortfolio(totalportfolio);
    validateAllocation(
      stocks,
      updatedProductAllocations,
      updatedcCategoryAllocations
    );
  };
  useEffect(() => {
    // Run validation whenever relevant state changes
    validateAllocation(stocks, productCodes, categoryCodes);
  }, [growth, defensive, stocks, productCodes, categoryCodes]);
  const handleStockAllocationChange = (stockId, fromuser, stockIdReal) => {
    let newAllocation = "";
    if (fromuser == "") {
      newAllocation = "0";
    } else {
      newAllocation = fromuser;
    }
    if (stockIdReal == 93) {
      setAustralianCashStockAllocation(Number(newAllocation));
    }
    const updatedStocks = stocks.map((stock) => {
      if (stock.id !== stockId) return stock;

      const allocationPercent = Number(newAllocation);
      const investmentAmount =
        (allocationPercent / 100) * Number(minimumInvestment);
      const stockQuantity = investmentAmount / stock.unitPrice;
      const stockMarketPrice =
        (Number(newAllocation) * Number(minimumInvestment)) / 100;
      const taaPercent = allocationPercent; // simplified from your earlier formula

      return {
        ...stock,
        allocation: newAllocation,
        stockquantity: stockQuantity,
        stockMarketPrice: stockMarketPrice,
      };
    });

    setStocks(updatedStocks);
    const totalportfolio = updatedStocks.reduce(
      (sum, item) => sum + parseFloat(Number(item.allocation).toFixed(2)),
      0
    );
    settotalPortfolio(totalportfolio);

    validateAllocation(updatedStocks, productCodes, categoryCodes);
  };
  const toggleProduct = (categoryId, productId) => {
    if (
      productId != 9 &&
      selectedProductsByCategory[categoryId] != undefined &&
      selectedProductsByCategory[categoryId].length > 0 &&
      strategyTypeId == 1
    ) {
      showToast("You cannot add multiple asset category.", "error");
      return;
    }
    if (productId != 9 && growth == Number(100) && categoryId == 2) {
      showToast("You cannot other categories except Australian Cash.", "error");
      return;
    }
    if (productId != 9 && defensive == Number(100) && categoryId == 1) {
      showToast("You cannot add growth.", "error");
      return;
    }
    setSelectedProductsByCategory((prevState) => {
      const newState = { ...prevState };
      if (!newState[categoryId]) {
        newState[categoryId] = [];
      }

      if (newState[categoryId].includes(productId)) {
        newState[categoryId] = newState[categoryId].filter(
          (id) => id !== productId
        );
      } else {
        newState[categoryId] = [...newState[categoryId], productId];
      }

      return newState;
    });
    if (productId == 9) {
      const category = newCategories.find((cat) =>
        cat.products.some((product) => product.id === 9)
      );

      const product = category?.products.find((product) => product.id === 9);
      const stock = product?.stocks.find((stock) => stock.id === 93) || {};
      handleAddItem(
        9,
        2,
        [
          {
            id: stock.id || null,
            asx_code: stock.asx_code || "",
            name: stock.name || "",
            exchange: stock.exchange || "",
            unit_price: stock.unit_price || 0,
          },
        ],
        0
      );
    }
    const updatedCategories = addProductToExistingCategories(
      categoryId,
      productId
    );
    setExistingCategories(updatedCategories);
    let x = actualCategories;
    let c = existingCategories;
  };
  const updateProductCode = (productId, categoryId, newProduct) => {
    setproductCode((prevProductCodes) => {
      const updatedProductCodes = prevProductCodes.map((product) =>
        product.productId === productId
          ? {
              ...product,
              productName: newProduct.name,
              productColour: newProduct.color_code,
            }
          : product
      );

      // If productId doesn't exist, add a new entry
      const productExists = prevProductCodes.some(
        (product) => product.productId === productId
      );
      if (!productExists) {
        updatedProductCodes.push({
          productId,
          allocation: 0,
          categoryId,
          productName: newProduct.name,
          productColour: newProduct.color_code,
          saaPercent: 0,
          daaPercent: 0,
        });
      }

      return updatedProductCodes;
    });
  };

  // Example usage

  const addProductToExistingCategories = (categoryId, productId) => {
    // Clone existingCategories to avoid mutations
    const updatedCategories = existingCategories.map((category) => ({
      ...category,
      products: category.products.map((product) => ({
        ...product,
        stocks: product.stocks.map((stock) => ({ ...stock })), // Deep copy stocks
      })),
    }));
    // Find the corresponding category in existingCategories
    const categoryIndex = updatedCategories.findIndex(
      (cat) => cat.id === categoryId
    );

    if (categoryIndex !== -1) {
      const existingCategory = updatedCategories[categoryIndex];

      // Find the product in newCategories
      const newProduct = newCategories
        .find((cat) => cat.id === categoryId)
        ?.products.find((prod) => prod.id === productId);
      const productCodes = [];
      if (newProduct) {
        // Check if the product already exists in existingCategories
        const productExists = existingCategory.products.some(
          (prod) => prod.id === productId
        );

        if (!productExists) {
          updateProductCode(productId, categoryId, newProduct);

          // Add the new product to the category
          existingCategory.products.push({
            ...newProduct,
            allocation: 0,
            saa_percentage: 0,
            daa_percentage: 0, // Initialize allocation
            stocks: newProduct.stocks.map((stock) => ({
              ...stock,
              allocation: 0, // Initialize stock allocation
              quantity: 0,
              market_price: 0,
              saa_percentage: 0,
              daa_percentage: 0,
            })),
          });

          console.log("Updated Categories:", updatedCategories);
        }
      }
    }

    return updatedCategories;
  };

  const handleAddItem = (subcategory, categoryIndex, subcategoryIndex) => {
    const newStockId = latestId; // Use current ID
    setLatestId(latestId + 1);
    const match = securityCodes.find((sec) => sec.productId === subcategory);

    setStocks([
      ...stocks,
      {
        product: subcategory,
        category: categoryIndex,
        id: newStockId,
        code: match.stock.asx_code,
        name: match.stock.name,
        unitPrice: match.stock.unit_price,
        allocation: 0,
        stockId: match.stock.id,
        stockquantity: 0,
        stockMarketPrice: 0,
        productIndex: subcategoryIndex,
        saaPercent: 0,
        taaPercent: 0,
        daaPercent: 0,
      },
    ]);
    if (subcategory == 9) {
      setAustralianCashStockId(newStockId);
    }
  };

  const toggleCategoryDropdown = (categoryId, dropdownIndex) => {
    setDropdownStates((prevState) => ({
      ...prevState,
      [`${categoryId}-${dropdownIndex}`]:
        !prevState[`${categoryId}-${dropdownIndex}`],
    }));
  };
  const handleDropdownToggle = (id) => {
    // Toggle dropdown for the specific row
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if already open
    } else {
      setOpenDropdown(id); // Open the dropdown for the specific row
    }
  };
  const handleFilterChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const togglePopupEdit = () => setisOpenEdit(!isOpenEdit);
  const generateSecurityCodes = (categories) => {
    const securityCodes = [];
    let securityIndex = 1;
    const productCodes = [];
    const totalAllocationByCategory = [];

    categories.forEach((category) => {
      category.products.forEach((product) => {
        product.stocks.forEach((stock) => {
          securityCodes.push({
            stock: stock,
            categoryId: category.id,
            productId: product.id,
          });
        });
        productCodes.push({
          productId: product.id,
          allocation: 0,
          categoryId: category.id,

          productName: product.name,
          productColour: product.color_code,
        });
      });
      totalAllocationByCategory.push({
        categoryId: category.id,
        allocation: 0,
      });
    });
    setcategoryCodes(totalAllocationByCategory);
    setproductCode(productCodes);
    setSecurityCodes(securityCodes);
  };
  const generateSecurityCodesNew = (categories) => {
    const securityCodes = [];

    categories.forEach((category) => {
      category.products.forEach((product) => {
        product.stocks.forEach((stock) => {
          securityCodes.push({
            stock: stock,
            categoryId: category.id,
            productId: product.id,
          });
        });
      });
    });
    setSecurityCodes(securityCodes);
  };
  const headers = [
    { label: "Date & Time", key: "created_at" },
    { label: "Transaction ID", key: "status" },
    { label: "Account Name", key: "investor_name" },
    { label: "Convert Rate (AUD)", key: "product_name" },
    { label: "Debit", key: "amount" },
    { label: "Credit", key: "cash_account" },
    { label: "Running Balance", key: "cash_account" },
    { label: "Status", key: "" },
    { label: "", key: "" },
  ];
  const headersRequest = [
    { label: "Date & Time", key: "created_at" },
    { label: "Transaction ID", key: "status" },
    { label: "Account Name", key: "investor_name" },
    { label: "Convert Rate (AUD)", key: "product_name" },
    { label: "Debit", key: "amount" },
    { label: "Credit", key: "cash_account" },
    { label: "Running Balance", key: "cash_account" },
    { label: "Status", key: "" },
    { label: "", key: "" },
    { label: "", key: "" },
  ];
  const getAllCategories = async () => {
    setIsAllLoaded(true);
    try {
      const response = await GetAPIcalls(`/v1/stock/categories/products`);
      if (response.status == 200) {
        setNewCategories(response.data);
        generateSecurityCodesNew(response.data);
      } else {
        if (response.status === 401) {
          // Token expired or invalid
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        showToast(response.message, "error");
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsAllLoaded(false);
      }, 100);
    }
  };
  const secondheaders = [
    "Investment Manager",
    "Date",
    "Strategy",
    "Growth",
    "Defensive",
  ];

  const investorheaders = [
    { label: "Date", key: "created_at" },
    { label: "Status", key: "status" },
    { label: "Investor Name", key: "investor_name" },
    { label: "Investment Amount", key: "amount" },
    { label: "Cash Account", key: "cash_account" },
    { label: "", key: "" }, // No sorting for actions
    { label: "", key: "" }, // No sorting for actions
  ];

  const [users, setUsers] = useState([]);
  const [donutdataGraph, setDonutData] = useState({});

  const [SettlementAccountData, setSettlementAccountData] = useState([]);
  const [SubAdvisorAccountData, setSubAdvisorAccountData] = useState([]);
  const [showRecords, setShowRecords] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQueryForAccount, setSearchQueryForAccount] = useState("");

  const [pastPerformance, setpastPerformance] = useState("");
  const [disclaimer, setDisclaimer] = useState("");
  const [copyright, setCopyright] = useState("");

  const [selected, setSelected] = useState("Download Report");
  const [selectedInvestorReport, setselectedInvestorReport] =
    useState("Download Report");
  const [isOpenInvestorDropdown, setisOpenInvestorDropdown] = useState(false);
  const [allocationGraphData, setfilteredGraphdata] = useState([]);
  const [totalInvestors, setTotalInvestors] = useState(0);
  const [totalInvestedAmount, setTotalInvestedAmount] = useState(0);
  const [investortableData, setInvestortableData] = useState([]);
  const [rawData, setrawData] = useState([]);
  const [filterText, setFilterText] = useState("created_at");
  const [currentInvestmentId, setCurrentInvestmentId] = useState("");
  const [addtoDashboardFromAPI, setAddtoDashboardFromaAPI] = useState(false);
  const [addMemberFromAPI, setAddMemberFromAPI] = useState(false);
  const accountRef = useRef();
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [searchAccount, setSearchAccount] = useState("");
  const [strategyTypeId, setStrategyTypeId] = useState(null);
  const [isOpenEditStock, setisOpenEditStock] = useState(false);
  const inputRef = useRef(null);
  const [pdfData, setPdfData] = useState([]);
  const AllAccount = [];

  AllAccount.push({
    value: 1,
    label: "John Mayer 1 - USD",
  });
  AllAccount.push({
    value: "ALL",
    label: "ALL",
  });
  const AllStatus = [
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" },
  ];
  const options = [
    { value: "pdf", label: "PDF" },
    { value: "excel", label: "Excel" },
  ];
  const handleAccountListChange = (option) => {
    setSelectedAccounts((prev) => {
      if (option.value === "ALL") {
        // If "ALL" is selected, replace the array with only "ALL"
        return prev.includes("ALL") ? [] : ["ALL"];
      } else {
        // If a regular option is selected
        const updatedAccounts = prev.includes(option.value)
          ? prev.filter((item) => item !== option.value) // Remove if already selected
          : [...prev.filter((item) => item !== "ALL"), option.value]; // Add and remove "ALL" if necessary
        return updatedAccounts;
      }
    });
  };
  const updateTAAData = (taaData) => {
    const productCodes = [];
    const totalAllocationByCategory = [];
    let stockArray = [];
    let categoryProductMap = {};
    let newStockId = 1; // Use current ID
    taaData.forEach((category) => {
      category.products.forEach((product) => {
        product.stocks.forEach((stock) => {
          stockArray.push({
            product: product.id,
            category: category.id,
            id: newStockId++,
            code: stock.asx_code,
            name: stock.stock_name,
            unitPrice: stock.current_price,
            allocation: Number(stock.saa_percentage).toFixed(2),
            stockId: stock.stock_id,
            stockquantity: stock.quantity,
            stockMarketPrice: stock.market_value,
            productIndex: 0,
            saaPercent: stock.saa_percentage,
            taaPercent: stock.taa_percentage,
            daaPercent: stock.daa_percentage,
            difference: stock.difference,
          });
          if (product.id == 9) {
            setAustralianCashStockAllocation(Number(stock.saa_percentage));
            setAustralianCashStockId(newStockId - 1);
          }
        });

        productCodes.push({
          productId: product.id,
          allocation: Number(product.saa_percentage).toFixed(2),
          categoryId: category.id,
          productName: product.name,
          productColour: product.color_code,
          saaPercent: product.saa_percentage,
          taaPercent: product.taa_percentage,
          difference: product.difference,
          daaPercent: product.daa_percentage,
        });
      });

      totalAllocationByCategory.push({
        categoryId: category.id,
        allocation: Number(category.saa_percentage).toFixed(2),
        saaPercent: category.saa_percentage,
        taaPercent: category.taa_percentage,
        difference: category.difference,
        daaPercent: category.daa_percentage,
      });
    });
    categoryProductMap = taaData.reduce((acc, category) => {
      const categoryId = category.id;
      const productIds = category.products.map((product) => product.id);

      acc[categoryId] = productIds;
      return acc;
    }, {});
    setSelectedProductsByCategory(categoryProductMap);
    setStocks(stockArray);
    setLatestId(stockArray.length + 1);
    setcategoryCodes(totalAllocationByCategory);
    setproductCode(productCodes);
    const totalportfolio = stockArray.reduce(
      (sum, item) => sum + parseFloat(Number(item.allocation).toFixed(2)),
      0
    );
    settotalPortfolio(totalportfolio);
  };
  const handleSort = (key) => {
    setFilterText(key);
  };
  const DeleteProduct = (categoryId, productId) => {
    let x = stocks;
    setSelectedProductsByCategory((prevState) => {
      const newState = { ...prevState };

      if (!newState[categoryId]) {
        newState[categoryId] = [];
      }

      // Check if the product is being removed
      if (newState[categoryId].includes(productId)) {
        // Store the removed product in a state variable (so we can restore it)
        // setDeletedProduct({ categoryId, productId });

        // Remove the product from the list
        newState[categoryId] = newState[categoryId].filter(
          (id) => id !== productId
        );
      } else {
        // Add product to the category list
        newState[categoryId] = [...newState[categoryId], productId];
      }

      return newState;
    });

    handleProductAllocationChange(productId, 0, categoryId, true);
    const updatedStocks = stocks.filter((item) => item.product !== productId);
    setStocks(updatedStocks);
    const totalportfolio = updatedStocks.reduce(
      (sum, item) => sum + parseFloat(Number(item.allocation).toFixed(2)),
      0
    );
    settotalPortfolio(totalportfolio);
    if (productId == 9) {
      setAustralianCashStockAllocation(0);
    }
    validateAllocation(updatedStocks, productCodes, categoryCodes);
  };
  const handleSelect = (option) => {
    setSelected(option.label);
    setisOpenDownload(false);
  };
  const handleSelectInvestorReport = (option) => {
    setselectedInvestorReport(option.label);
    setisOpenInvestorDropdown(false);
  };
  const handleSelectPlatform = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setPlatformId(selectedOption.value);
    setPreselectedPlatform(selectedOption);
    setPreselectedPlatformAccount({});
    setplatformAccount(null);
    if (selectedOption.value == null) {
      setplatformFeesUpdate(0);
      setPlatformFees(0);
      setPlatformAccountfromAPI("");
      setPlatformIdfromAPI("");
      setSettlementAccountData([]);
    }
    setisNewChange(false);
  };
  const handleSelectAssetManager = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setAssetManagerId(selectedOption.value);
    setPreSelectedAssetManager(selectedOption);
    setPreselectedAssetManagerAccount({});
    setAssetManagerAccount(null);
    if (selectedOption.value == null) {
      setassetManagerFeesUpdate(0);
      setassetManagerFees(0);
      setAssetManagerAccountfromAPI("");
      setAssetManagerNamefromAPI("");
      setAssetManagerAccountData([]);
    }
    setisNewChange(false);
  };
  const handleSelectCustodian = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setCustodianId(selectedOption.value);
    setpreselectedCustodian(selectedOption);
    setPreselectedCustodianAccount({});
    setCustodianAccount(null);
    if (selectedOption.value == null) {
      setcustodianFeesUpdate(0);
      setcustodianFees(0);
      setCustodianAccountFromAPI("");
      setCustodianNameFromAPI("");
      setCustodianAccountData([]);
    }
    setisNewChange(false);
  };

  const handleStatusChange = async (e, option, rowId) => {
    e.preventDefault();

    try {
      const response = await UpdateStatusCall(option, rowId);
      if (response.status == 200) {
        setStatus(rowId + option.value);
        setisOpenStatus(false);
        showToast(response.message, "success");
      } else {
        showToast(response.message, "error");
      }
    } catch (err) {
      showToast(err.message, "error");
    }
  };
  const UpdateOtherDetailsCall = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };
    const apiUrl = `${BASE_URL}/v1/investment-portfolio/${investment_id}/update-user-access`;
    const bodyData = {
      add_to_dashboard: addToDashboard,
      accessible_to_specific_customer: addMember,
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const handleOtherDetailsChange = async () => {
    try {
      const response = await UpdateOtherDetailsCall();
      if (response.status == 200) {
        dispatch(resetSelectedUsers());
        dispatch(resetDocumentId());
        getInvestmentDetails();
      } else {
        showToast(response.message, "error");
      }
    } catch (err) {
      showToast(err.message, "error");
    }
  };
  const handleBlurClientId = () => {
    getClientName();
  };
  const handleBlurCreatorId = () => {
    getCreatorName();
  };
  const [InvestmentManagerAccountData, setInvestmentManagerAccountData] =
    useState([]);
  const [CustodianAccountData, setCustodianAccountData] = useState([]);
  const [AdvisorAccountData, setAdvisorAccountData] = useState([]);
  const [AssetManagerAccountData, setAssetManagerAccountData] = useState([]);
  const [showDownloadPopup, setShowDownloadPopup] = useState(false);
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
  const [selectedRow, setSelectedRow] = useState(null);
  useEffect(() => {
    if (advisorId != null) {
      getWalletAccountsByAdvisor();
    }
  }, [advisorId]);
  const handleSelectSubAdvisorAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setsubAdvisorAccount(selectedOption.value);
    setisNewChange(false);
  };
  const handleSelectSubAdvisor = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setSubadvisorId(selectedOption.value);
    setPreselectedSubAdvisor(selectedOption);
    setPreselectedSubAdvisorAccount({});
    setsubAdvisorAccount(null);
    if (selectedOption.value == null) {
      setsubadvisorFeesUpdate(0);
      setadvisorFees(0);
      setsubAdvisorAccountfromAPI("");
      setSubadvisorIdfromAPI("");
      setSubAdvisorAccountData([]);
    }
    setisNewChange(false);
  };
  const handleSelectSettlementAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setplatformAccount(selectedOption.value);
    setisNewChange(false);
  };
  const handleSelectAssetManagerAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setAssetManagerAccount(selectedOption.value);
    setisNewChange(false);
  };
  const handleSelectCustodianAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setCustodianAccount(selectedOption.value);
    setisNewChange(false);
  };
  const labelsLine =
    rawData.length > 0
      ? rawData.map((item) => {
          const date = new Date(item.date); // Parse the date
          return date; // Return Date object (Chart.js can parse Date objects)
        })
      : [];

  const optionsLine = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        mode: "index",
        intersect: false,
        backgroundColor: "#111827",
        titleColor: "#fff",
        borderColor: "#374151",
        borderWidth: 1,
        padding: 12,
        displayColors: false, // hoverRadiusHide colored dots
        callbacks: {
          title: (tooltipItems) => {
            const timestamp = tooltipItems[0].parsed.x; // <-- reliable timestamp
            const date = new Date(timestamp);

            if (selectedFilter === "1M" || selectedFilter === "3M") {
              const day = date.getDate().toString().padStart(2, "0");
              const month = date.toLocaleDateString("en-US", {
                month: "short",
              });
              const year = date.getFullYear();
              return `${day} ${month} ${year}`;
            } else {
              const month = String(date.getMonth() + 1).padStart(2, "0");
              const year = date.getFullYear();
              return `${month}/${year}`;
            }
          },
          label: (tooltipItem) => {
            const index = tooltipItem.dataIndex;
            const value = `$${tooltipItem.raw
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
            const isUpdated = rawData[index]?.version_changed;

            return isUpdated ? `${value} (SAA updated)` : value;
          },
          labelTextColor: function (context) {
            const index = context.datasetIndex;
            const index2 = context.dataIndex;
            const isUpdated = rawData[index2]?.version_changed;
            return isUpdated
              ? ["#0D9488", "#DC4646", "#34C046"][index]
              : ["#3047EC", "#DC4646", "#34C046"][index];
          },
        },
      },
      legend: { display: false },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
    elements: {
      point: {
        radius: 4, // 👈 size of the dots
        hoverRadius: 6, // size when hovered
        backgroundColor: "#111827", // default dot color
        borderWidth: 2,
        borderColor: "#fff", // outline to make dots stand out
      },
      line: {
        tension: 0.3, // keep smooth curves
      },
    },
    scales: {
      x: {
        type: "time",
        time: {
          unit:
            selectedFilter === "1M" || selectedFilter === "3M"
              ? "day"
              : "month",
          tooltipFormat:
            selectedFilter === "1M" || selectedFilter === "3M"
              ? "MMM d (EEE)"
              : "MMM yyyy",
        },
        ticks: {
          display: true,
          color: "black",
          callback: function (value) {
            const date = new Date(value);
            if (selectedFilter === "1M" || selectedFilter === "3M") {
              const day = date.getDate().toString().padStart(2, "0");
              const month = date.toLocaleDateString("en-US", {
                month: "short",
              });
              return [day, month];
            } else {
              const month = date.toLocaleDateString("en-US", {
                month: "short",
              });
              const year = date.getFullYear();
              return [month, year];
            }
          },
          font: { size: 12 },
          maxRotation: 0,
          minRotation: 0,
        },
        border: { color: "black" },
        afterFit: function (scale) {
          scale.height = 60;
        },
      },
      y: {
        ticks: {
          callback: (value) => `${value.toFixed(2)}`,
          color: "black",
          padding: 10,
        },
        grid: {
          color: "#e5e7eb",
          borderDash: [4, 4],
        },
        beginAtZero: false,
        min: 0,
        offset: true,
      },
    },
  };

  const dataLine = {
    labels: labelsLine,
    datasets: [
      {
        label: "Price",
        data: stockPrices,
        borderColor: "#3047EC",
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) {
            return null; // Wait until the chart is fully rendered
          }

          const gradient = ctx.createLinearGradient(
            0,
            chartArea.top,
            0,
            chartArea.bottom
          );
          gradient.addColorStop(0, "rgba(74, 144, 226, 0.1)"); // Light blue at the top
          gradient.addColorStop(1, "white"); // White at the bottom

          return gradient;
        },
        tension: 0.4,
        pointRadius: rawData.map((item) => (item.version_changed ? 7 : 4)),
        pointHoverRadius: rawData.map((item) => (item.version_changed ? 9 : 6)),
        pointBackgroundColor: rawData.map((item) =>
          item.version_changed ? "#ffffff" : "#3047EC"
        ),
        pointBorderColor: rawData.map((item) =>
          item.version_changed ? "#0D9488" : "#3047EC"
        ),
        pointBorderWidth: rawData.map((item) => (item.version_changed ? 6 : 3)),
        fill: false,
      },
      {
        label: "Combine indices",
        data: combineIndex,
        borderColor: "#DC4646",
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) {
            return null; // Wait until the chart is fully rendered
          }

          const gradient = ctx.createLinearGradient(
            0,
            chartArea.top,
            0,
            chartArea.bottom
          );
          gradient.addColorStop(0, "rgba(220, 70, 70, 0.3)"); // Light red (same as border, low opacity)
          gradient.addColorStop(1, "rgba(220, 70, 70, 0)");

          return gradient;
        },
        tension: 0.4,
        pointRadius: 4,
        pointHoverRadius: 6,
        pointBackgroundColor: "#DC4646",
        fill: true,
      },
    ],
  };

  const getWalletAccountsBySubAdvisor = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/account/user/${subadvisorId}/cash-accounts`
      );

      if (response.status == 200) {
        const SubAdvisorAccountData = [];
        response.data.cash_accounts.forEach((profile) => {
          SubAdvisorAccountData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setSubAdvisorAccountData(SubAdvisorAccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setSubAdvisorAccountData([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getWalletAccountsByAssetManager = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/account/user/${assetManagerId}/cash-accounts`
      );

      if (response.status == 200) {
        const SubAdvisorAccountData = [];
        response.data.cash_accounts.forEach((profile) => {
          SubAdvisorAccountData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setAssetManagerAccountData(SubAdvisorAccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setAssetManagerAccountData([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    if (subadvisorId != null) {
      getWalletAccountsBySubAdvisor();
    }
  }, [subadvisorId]);
  useEffect(() => {
    if (assetManagerId != null) {
      getWalletAccountsByAssetManager();
    }
  }, [assetManagerId]);
  const getWalletAccountsByAdvisor = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/account/user/${advisorId}/cash-accounts`
      );

      if (response.status == 200) {
        const AdvisorAccountData = [];
        response.data.cash_accounts.forEach((profile) => {
          AdvisorAccountData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setAdvisorAccountData(AdvisorAccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setAdvisorAccountData([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getClientName = async () => {
    if (clientId == "") {
      setIsClientExist(false);
      setClientName("");
      return;
    }
    if (clientId == creatorId) {
      setIsClientExist(false);
      setClientName("");
      setIsInvestorAvailable(false);
      showToast("Client ID and Creator Id cannot be same", "error");
      return;
    }
    try {
      const response = await GetAPIcalls(`/v1/user/client-id/${clientId}`);

      if (response.status == 200) {
        setIsClientExist(true);
        setClientName(response.data.first_name + " " + response.data.last_name);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setIsClientExist(false);
          setClientName("No Such Client Found");
          setIsInvestorAvailable(false);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };

  const getCreatorName = async () => {
    if (creatorId == "") {
      setIsCreatorExist(false);
      setCreatorName("");
      return;
    }
    if (clientId == creatorId) {
      setIsClientExist(false);
      setClientName("");
      setIsInvestorAvailable(false);
      showToast("Client ID and Creator Id cannot be same", "error");
      return;
    }
    try {
      const response = await GetAPIcalls(`/v1/user/client-id/${creatorId}`);

      if (response.status == 200) {
        setIsCreatorExist(true);
        setCreatorName(
          response.data.first_name + " " + response.data.last_name
        );
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setIsCreatorExist(false);
          setCreatorName("No Such Creator Found");
          setIsInvestorAvailable(false);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const UpdateStatusCall = async (option, rowId) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    const apiUrl = `${BASE_URL}/v1/investment-request/${rowId}/status`;
    const bodyData = {
      status: option.value,
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getPopData = async () => {
    setIsLoading(true);
    try {
      const response = await GetAPIcalls(`/v1/investment-request/76/pop-up`);
      if (response.status == 200) {
        setPopupDataTable(response.data.categories.portfolio_breakdown);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setPopupDataTable([]);
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const postHoldingDataAPI = async (userId, portfolioId) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/investment-portfolio/user-holding-graphs`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const bodyData = {
      portfolio_id: portfolioId,
      user_id: userId,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getHoldingValuationReportData = async (userId, portfolioId) => {
    let toastMessage = null;

    try {
      const response = await postHoldingDataAPI(userId, portfolioId);
      if (response.status == 200) {
        setholdingValuationData(response.data);
        setRawDatapdf(response.data.product_allocations);
        setIsHiddenReport(true);
      } else {
        setholdingValuationData([]);
        showToast(response.message, "error");
        setTimeout(function () {
          setLoading(false);
        }, 100);
      }
    } catch (err) {
      showToast(err.message, "error");
      setTimeout(function () {
        setLoading(false);
      }, 100);
    } finally {
    }
  };
  useEffect(() => {
    if (location.state?.fromViewHistory) {
      console.log("User came back from /view-history");
      // Do something here
      setFilter("trading");
      setTradingTab("tta");
      setComponentName("saa-taa");
    }
  }, [location]);
  useEffect(() => {
    if (filter === "view") {
      fetchViewData();
      getDetails();
      //  getPopData();
    }
    if (filter === "details") {
      dispatch(resetSelectedUsers());
      dispatch(resetDocumentId());
      getInvestmentDetails();
    }
    if (filter === "investors") {
      getInvestorDetails();
      getPopData();
    }

    if (filter === "trading" && tradingTab == "tta") {
      setTotalErrors([]);
      setErrors([]);
      setAPISuccess(false);

      getAllAllocations();
    }
    if (filter === "trading" && tradingTab == "dda") {
      setTotalErrors([]);
      setErrors([]);
      setSelectedProductsByCategory({});
      getDaaAllocations();
    }
    if (filter === "trading" && tradingTab == "rebalancing") {
      getRebalancingData();
    }
  }, [
    filter,
    filterStatus,
    tradingTab,
    status,
    currentPage,
    showRecords,
    searchQuery,
    isCurrentInvestorSelected,
  ]);
  useEffect(() => {
    if (filter === "view") {
      fetchHistoryViewData();
    }
  }, [filter, investment_id, selectedFilter]);
  useEffect(() => {
    if (
      addMember != addMemberFromAPI ||
      addToDashboard != addtoDashboardFromAPI
    ) {
      handleOtherDetailsChange();
    }
  }, [addMember, addToDashboard]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        DateCalendarRef.current &&
        !DateCalendarRef.current.contains(event.target)
      ) {
        setIsDropdownOpenDate(false);
      }
      if (
        DownloadDocRef.current &&
        !DownloadDocRef.current.contains(event.target)
      ) {
        setisOpenDownload(false);
      }
      if (
        DownloadDocBreakdownRef.current &&
        !DownloadDocBreakdownRef.current.contains(event.target)
      ) {
        setisOpenInvestorDropdown(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  useEffect(() => {
    if (selectedDates.length === 2) {
      const formattedRange = `${formatDate(
        selectedDates[0].toLocaleDateString()
      )} — ${formatDate(selectedDates[1].toLocaleDateString())}`;
      setSelectedRange(formattedRange);
    }
  }, [selectedDates]);

  // Handle quick filter selection
  const handleQuickFilter = (filter) => {
    const today = new Date();
    let startDate, endDate;
    setCurrentPage(1);

    if (filter === "this_week") {
      // Adjust to start from Monday
      const dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1; // Adjust for Monday as first day
      startDate = new Date(today.setDate(today.getDate() - dayOfWeek));
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6); // End of the week
    } else if (filter === "last_week") {
      const dayOfWeek = today.getDay() === 0 ? 6 : today.getDay() - 1; // Adjust for Monday as first day
      endDate = new Date(today.setDate(today.getDate() - dayOfWeek - 1)); // End of last week
      startDate = new Date(endDate);
      startDate.setDate(endDate.getDate() - 6); // Start of last week
    } else if (filter === "this_month") {
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    } else if (filter === "this_year") {
      startDate = new Date(today.getFullYear(), 0, 1);
      endDate = new Date(today.getFullYear(), 11, 31);
    } else if (filter === "last_year") {
      startDate = new Date(today.getFullYear() - 1, 0, 1);
      endDate = new Date(today.getFullYear() - 1, 11, 31);
    } else if (filter === "custom") {
      // Custom filter: enable calendar range selection and reset dates
      setSelectedDates([]);
      setSelectedRange("Select Date Range");
      setQuickFilter(filter);
      return;
    } else if (filter === "") {
      // Custom filter: enable calendar range selection and reset dates
      setSelectedDates([]);
      setSelectedRange("Select Date Range");
      setQuickFilter(filter);
      return;
    }
    setQuickFilter(filter);
    setSelectedDates([startDate, endDate]);
    setSelectedRange(
      `${startDate.toLocaleDateString()} — ${endDate.toLocaleDateString()}`
    );
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString); // Convert string to Date object
    const day = String(date.getDate()).padStart(2, "0"); // Get day with leading zero
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Get month (0-indexed) with leading zero
    const year = date.getFullYear(); // Get full year

    return `${day}/${month}/${year}`; // Format as DD/MM/YYYY
  };
  const formatDateList = (dateString) => {
    const [datePart] = dateString.split(" "); // Extract the date portion
    const [day, month, year] = datePart.split("/"); // Split into day, month, and year
    return `${day}/${month}/${year}`;
  };
  const downloadExcelReportInvestors = async () => {
    const token = localStorage.getItem("jwtToken");

    try {
      let apiUrl = `/v1/investment-portfolio/${investment_id}/investors/export/excel?size=100&search=${searchQuery}&status=${filterStatus}`;

      const response = await fetch(BASE_URL + apiUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          // Example: redirect to login page
          // window.location.href = "/login";

          // Or throw a custom error
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const downloadReports = useCallback(
    debounce(async (e, option) => {
      if (option.value == "excel") {
        setLoading(true);
        try {
          const csvBlob = await downloadExcelReportInvestors();
          const url = window.URL.createObjectURL(csvBlob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `Investors-${formattedDate}.xlsx`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          showToast(err.message, "error");
        } finally {
          setisOpenDownload(false);
          setTimeout(function () {
            setLoading(false); // Ensure `loading` is false first
          }, 100);
        }
      }
      if (option.value == "pdf") {
        try {
          const response = await GetAPIcalls(
            `/v1/investment-portfolio/${investment_id}/investors?size=100&search=${searchQuery}&status=${filterStatus}`
          );
          if (response.status == 200) {
            if (response.data.investors.length > 0) {
              setPdfData(response.data.investors);
              setIsHiddenTablePdf(true);
            } else {
              setPdfData([]);
              setIsHiddenTablePdf(false);
              showToast("No data available to generate the report.", "error");
            }
          } else {
            setPdfData([]);
            setIsHiddenTablePdf(false);
            console.log("I am wlslsk" + filteredData);
          }
        } catch (err) {
          setPdfData([]);
          showToast(err.message, "error");
        } finally {
          setisOpenDownload(false);
          setTimeout(function () {
            setLoading(false); // Ensure `loading` is false first
          }, 100);
        }
      }
    }, 1000), // Debounce time
    [investment_id, searchQuery, filterStatus, factSheetFileName] // Dependencies
  );

  const downloadReportsBreakdown = useCallback(
    debounce(async (e, option) => {
      // if (option.value == "csv") {
      //   try {
      //     const csvBlob = await GetCSV();
      //     const url = window.URL.createObjectURL(csvBlob);
      //     const a = document.createElement("a");
      //     a.href = url;
      //     a.download = `Investment Portfolios-${formattedDate}.csv`;
      //     document.body.appendChild(a);
      //     a.click();
      //     document.body.removeChild(a);
      //     window.URL.revokeObjectURL(url);
      //   } catch (err) {
      //     if (err.message.includes("401")) {
      //       localStorage.removeItem("jwtToken");
      //       navigate("/login");
      //     }
      //     if (err.message.includes("400")) {
      //       toast.error(
      //         <div className="flex items-center">
      //           <div className="mr-3">
      //             <img
      //               src="/tick-error.svg"
      //               alt="Success Icon"
      //               className="h-6 w-6"
      //             />
      //           </div>
      //           <div>
      //             <h3 className="font-semibold text-md text-black">Error!</h3>
      //             <p className="text-sm text-black">{err.message}</p>
      //           </div>
      //         </div>,
      //         {
      //           position: "top-right",
      //           autoClose: 5000,
      //           hideProgressBar: true,
      //           closeOnClick: true,
      //           pauseOnHover: true,
      //           draggable: true,
      //           icon: false,
      //           closeButton: (
      //             <button
      //               className="text-black "
      //               onClick={() => toast.dismiss()}
      //               style={{
      //                 backgroundColor: "transparent",
      //                 border: "none",
      //                 marginBottom: "2.813rem",
      //               }}
      //             >
      //               ✖
      //             </button>
      //           ),
      //           className: "error-toast text-md  rounded text-black",
      //         }
      //       );
      //     }
      //   } finally {
      //     setTimeout(function () {
      //       setLoading(false); // Ensure `loading` is false first
      //     }, 100);
      //   }
      // }
      if (option.value == "pdf") {
        setIsHiddenBreakdownPdf(true);
      }
    }, 1000), // Debounce time
    [portfolioData] // Dependencies
  );
  function createTableHeader(columns) {
    const thead = document.createElement("thead");

    // Create thead
    const headRow = document.createElement("tr");
    columns.forEach((col) => {
      const th = document.createElement("th");
      th.textContent = col.label;
      if (col.width) th.style.width = col.width;
      if (col.minWidth) th.style.minWidth = col.minWidth;
      headRow.appendChild(th);
    });
    thead.appendChild(headRow);
    return thead;
  }
  function createTableBody() {
    const body = document.createElement("tbody");

    pdfData.forEach((row) => {
      const tr = document.createElement("tr");
      tr.classList.add("tbody-tr");

      tr.innerHTML = `
          <td>${formatDateList(row.request_date)}</td>
          <td>${row.status.charAt(0).toUpperCase() + row.status.slice(1)}</td>
          <td>${row.investor_name}</td>
            <td>$${row.invested_amount
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
          <td>$${row.cash_account
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
        `;
      body.appendChild(tr);
    });
    return body;
  }
  const handleDownloadReport = async () => {
    const columns = [
      { label: "Date", key: "created_at" },
      { label: "Status", key: "status" },
      { label: "Investor Name", key: "investor_name" },
      { label: "Investment Amount", key: "amount" },
      { label: "Cash Account", key: "cash_account" },
    ];
    const date = new Date().toLocaleString();
    const tableHeadElement = createTableHeader(columns);
    const tableHeader = tableHeadElement.outerHTML;
    const tableBodyElement = createTableBody();
    const tableBody = tableBodyElement.outerHTML;

    const fullHtml = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8" />
          <style>
          @page {
    size: A4 landscape;
    margin: 0;
  }
    html, body {
            margin: 0;
            padding: 0;
                      font-family:sans-serif;
    overflow: auto;  /* Ensure content can overflow */
  
            height: 100%; /* Ensure the body fills the entire height */
          }        .pdf-container {
              max-width: 100% !important;
              margin: 20px;
            }
            tr {
              page-break-inside: avoid !important;
              break-inside: avoid !important;
            }
    
            .custom-header {
              position: relative;
              display: flex;
              justify-content: space-between;
              background-color: #ffffff;
              padding-top: 10px; /* Ensures no padding at the top */
            }
    
            .logo-container {
              display: flex;
              align-items: center;
            }
    
            .logo {
              width: 96px; /* Tailwind w-24 = 6rem = 96px */
              max-width: 150px;
              height: auto;
              object-fit: contain;
              margin-right: 1rem;
            }
    
            .title {
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              font-size: 1.125rem; /* Tailwind text-lg */
              font-weight: 500;    /* Tailwind font-medium */
              padding: 0;          /* Remove any padding */
              margin: 0;           /* Remove any margin */
            }
    
            .date {
              font-size: 0.875rem;  /* Tailwind text-sm */
              font-weight: 500;
              color: #000000;
              padding-bottom: 16px;
            }
  
    
  .page-break {
           page-break-before: always;
    break-before: page;
    display: block;
    height: 0; /* No extra space */
    width: 100%;
    content: "";}
        table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
      }
  
      thead {
        font-size: 10px;
        color: #6B7280; /* Tailwind text-labelColour equivalent */
      }
  
      th {
        border-bottom: 1px solid #000;
        padding: 8px;
        text-align: left;
      }
            td {
        padding: 6px;
        font-size: 10px;
        vertical-align: middle;
        text-align: left;
      }
        .tbody-tr{
                    background-color: #F9F9F9;
                    margin-bottom: 10px;
  
        }
      .positive {
        color: #34C046;
      }
      .negative {
        color: #FF5050;
      }
      .description {
        text-align: left;
      }
          </style>
        </head>
        <body>
       <div class="pdf-container">
          <div class="custom-header">
            <div class="logo-container">
              <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
            </div>
            <h2 class="title">Investors</h2>
            <div class="date">${date}</div>
          </div>
          
    <table id="dynamic-table">
    ${tableHeader}
      ${tableBody}
  
    </table>
      
        </div> 
  
             </body>
      </html>
    `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        // Token expired or invalid
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      // For other errors
      const errorData = await response.json().catch(() => ({
        message: "An error occurred",
      }));
      throw new Error(errorData.message || `Error ${response.status}`);
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Investors-${formattedDate}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHiddenTablePdf(false);
  };
  const handleDownloadReportBreakdown = async () => {
    const columns = [
      { label: "Date", key: "created_at" },
      { label: "Status", key: "status" },
      { label: "Investor Name", key: "investor_name" },
      { label: "Investment Amount", key: "amount" },
      { label: "Cash Account", key: "cash_account" },
    ];
    const date = new Date().toLocaleString();
    const tableBodyElement = populateTable(portfolioData);
    const tableBody = tableBodyElement.outerHTML;
    const fullHtml = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8" />
        <style>
                @page {
  size: A4 portrait;
  margin: 0;
}
  html, body {
          margin: 0;
          padding: 0;
                    font-family:sans-serif;
  overflow: auto;  /* Ensure content can overflow */

          height: 100%; /* Ensure the body fills the entire height */
        }        .pdf-container {
            max-width: 100% !important;
            margin: 20px;
          }
          tr {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
          }
  
          .custom-header {
            position: relative;
            display: flex;
            justify-content: space-between;
            background-color: #ffffff;
            padding-top: 10px; /* Ensures no padding at the top */
          }
  
          .logo-container {
            display: flex;
            align-items: center;
          }
  
          .logo {
            width: 96px; /* Tailwind w-24 = 6rem = 96px */
            max-width: 150px;
            height: auto;
            object-fit: contain;
            margin-right: 1rem;
          }
  
          .title {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-size: 1.125rem; /* Tailwind text-lg */
            font-weight: 500;    /* Tailwind font-medium */
            padding: 0;          /* Remove any padding */
            margin: 0;           /* Remove any margin */
          }
  
          .date {
            font-size: 0.875rem;  /* Tailwind text-sm */
            font-weight: 500;
            color: #000000;
            padding-bottom: 16px;
          }
                  .header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
      }
        .title-section {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
   flex-wrap: nowrap;
  width: 100%;
}

         .icon {
         width: 20px;
         height: 20px;
         }
.second-title {
  font-size: 1rem;
  font-weight: 600;
  padding-bottom: 16px;
  margin: 0;
  max-width: 100%;         /* Prevent exceeding container */
  white-space: normal;     /* Allow text to wrap */
}
      .label {
        font-size: 12px;
        color: #666666;
        font-weight: 500;
        margin: 0;
      }

      .value {
        font-size: 14px;
        font-weight: 500;
        color: #000000;
        margin: 0;
      }

      .section-title {
        font-size: 12px;
        color: #666666;
        font-weight: 500;
        margin-bottom: 0px;
      }

      .description {
        font-size: 12px;
        font-weight: 500;
        color: #000000;
        line-height: 1.6;
      }
              .form-container {
        background-color: #ffffff;
        border: 1px solid #000000;
        border-radius: 6px;
        margin-top: 0px;
      }

      .grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        border-collapse: collapse;
      }

      .cell {
        border-bottom: 1px solid #000000;
        border-right: 1px solid #000000;
        padding: 16px 12px;
      }
  .cell-last {
        border-right: 1px solid #000000;
        padding: 16px 12px;
      }
      .cell:nth-child(4n) {
        border-right: none;
      }
  .cell-last:nth-child(4n) {
        border-right: none;
      }

      .label {
        font-size: 12px;
        font-weight: 500;
        color: #666666;
        margin-bottom: 6px;
      }

      .value {
        font-size: 14px;
        font-weight: 500;
        color: #000000;
      }
      .allocation-container {
        border: 1px solid black;
        border-radius: 8px;
        padding: 16px;
        margin-top: 20px;
      }

      .allocation-header {
        display: flex;
        align-items: center;
        border-bottom: 1px solid black;
        padding-bottom: 8px;
        margin-bottom: 16px;
      }

      .allocation-header img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }

      .allocation-header h3 {
        font-size: 16px;
        font-weight: 500;
        margin: 0;
      }

      .allocation-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
      }

      .allocation-details {
        flex: 1 1 50%;
      }

      .allocation-items {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
        font-size: 12px;
      }

      .allocation-item {
        display: flex;
        flex-direction: column;
        word-break: break-word;
      }

      .allocation-item .product-name {
        font-size: 14px;
        font-weight: 500;
        color: #444;
      }

      .allocation-item .percentage {
        font-size: 14px;
        font-weight: 500;
        margin-top: 4px;
      }

      .chart-container {
        display: flex;
        justify-content: flex-end;
        margin-top: 16px;
      }

      .chart-container img {
        width: 160px;
        height: 160px;
      }
.page-break {
         page-break-before: always;
  break-before: page;
  display: block;
  height: 0; /* No extra space */
  width: 100%;
  content: "";}
      /* Responsive fallback (1 column on small screens) */
      @media print {
        .grid {
          grid-template-columns: repeat(4, 1fr);
        }
      }
            table {
      width: 100%;
      border-collapse: collapse;
      font-size: 10px;
      margin-top: 1rem;
    }

    th, td {
      border: 1px solid #ffffff;
      padding: 0.5rem 1rem;
    }

    /* Header row styling */
    th {
      background-color: #6AA7D3;
      color: white;
      font-weight: bold;
    }

    /* Specific styles for 'Market Price' column header */
    .market-price {
      background-color: #F4D580;
    }

    /* Optional styling for overflow if required */
    .overflow-x-auto {
      overflow-x: auto;
    }
              .bg-light-blue {
            background-color: #92C5EA;
        }
         .bg-product-blue {
            background-color: #C6DFF1;
        }
                .bg-stock-blue {
            background-color: #E6F3FC;
        }
            .bg-summary{
                        background-color: #EAEAEA;

            }
             .bg-product-green {
            background-color: #C0E2C1;
        }
             .bg-stock-green {
            background-color: #E7F5E8;
        }

        .bg-light-green {
            background-color: #A9D4AB;
        }


        .bg-off-white {
            background-color: #EAEAEA;
        }

        .text-bold {
            font-weight: bold;
        }
        .text-product{
                    font-weight: bold;
color: #005A9C;
        }

        .text-center {
            text-align: center;
        }

        .text-right {
            text-align: right;
        }

        .font-small {
            font-size: 12px;
        }

        .page-break {
            page-break-before: always;
        }
        </style>
      </head>
      <body>
     <div class="pdf-container">
        <div class="custom-header">
          <div class="logo-container">
            <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
          </div>
          <h2 class="title">Breakdown</h2>
          <div class="date">${date}</div>
        </div>
                  <div class="header">
      <!-- Title Section with Icon -->
      <div class="title-section">
        <img src="${svgBookBase64}"  alt="Portfolio Icon" class="icon" />
          <h2 class="second-title">${factSheetFileName}</h2>
      </div>
    </div> 
  <div class="overflow-x-auto">
    <table>
      <thead>
        <tr>
          <th>No</th>
          <th>Strategic Asset Allocation</th>
          <th>Code</th>
          <th>SAA</th>
          <th>Capital</th>
          <th class="market-price">Market Price</th>
          <th>Shares</th>
          <th>Value ($)</th>
          <th>Brokerage</th>
        </tr>
      </thead>
                    ${tableBody}


    </table>
  </div>
    </div>

           </body>
    </html>
  `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        // Token expired or invalid
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      // For other errors
      const errorData = await response.json().catch(() => ({
        message: "An error occurred",
      }));
      throw new Error(errorData.message || `Error ${response.status}`);
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Breakdown-${formattedDate}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHiddenBreakdownPdf(false);
  };
  useEffect(() => {
    if (isHiddenTablePdf == true) {
      handleDownloadReport();
    }
  }, [isHiddenTablePdf]);

  useEffect(() => {
    if (isHiddenBreakdownPdf == true) {
      handleDownloadReportBreakdown();
    }
  }, [isHiddenBreakdownPdf]);
  function generateAllocationItems(details) {
    return details.product_allocations
      .map((item) => {
        return `
          <div class="allocation-item">
            <span class="label">${item.product.name}</span>
            <span class="percentage" style="color: #${item.product.color};">
              ${item.allocation}%
            </span>
          </div>
        `;
      })
      .join("");
  }
  function populateTable(data) {
    const tableBody = document.createElement("tbody");

    data.forEach((categoryData) => {
      // Create category row
      const categoryRow = document.createElement("tr");
      if (categoryData.category.name.toUpperCase() == "GROWTH") {
        categoryRow.classList.add("bg-light-blue", "text-bold");
      } else {
        categoryRow.classList.add("bg-light-green", "text-bold");
      }
      categoryRow.innerHTML = `
                  <td colspan="1"></td>
            <td colspan="1">${categoryData.category.name.toUpperCase()}</td>
                              <td colspan="1"></td>
                  <td colspan="1"></td>
                  <td colspan="1"></td>
    <td colspan="1" class=""></td>
                <td colspan="1" class=""></td>
                                  <td colspan="1"></td>
                  <td colspan="1"></td>
        `;
      tableBody.appendChild(categoryRow);

      // Loop through each product in the category
      categoryData.category.products.forEach((product, productIndex) => {
        const productRow = document.createElement("tr");
        if (categoryData.category.name.toUpperCase() == "GROWTH") {
          productRow.classList.add("bg-product-blue", "text-product");
        } else {
          productRow.classList.add("bg-product-green", "text-product");
        }
        productRow.innerHTML = `
                <td>${(productIndex + 1).toString().padStart(2, "0")}</td>
                <td>${product.name}</td>
                <td></td>
                <td>${product.allocation
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%</td>
                <td>${
                  product.capital
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                }</td>
                <td class=""></td>
                <td class=""></td>
                <td></td>
                                <td></td>



            `;
        tableBody.appendChild(productRow);

        // Loop through each stock in the product
        product.stocks.forEach((stock) => {
          const stockRow = document.createElement("tr");
          if (categoryData.category.name.toUpperCase() == "GROWTH") {
            stockRow.classList.add("bg-stock-blue");
          } else {
            stockRow.classList.add("bg-stock-green");
          }
          stockRow.innerHTML = `
                    <td></td>
                    <td>${stock.name}</td>
                    <td>${stock.asx_code}</td>
                    <td class="">${stock.allocation.toFixed(2)}%
                    ${!stock.allocation ? "-" : ""}</td>
                    <td class="">${
                      stock.capital
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                    }</td>
                    <td class=" text-right">${
                      stock.market_value
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                    }</td>
                    <td class=" text-right">${
                      !stock.quantity
                        ? "00"
                        : stock.quantity
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }</td>
                                                 <td class="text-right">${
                                                   stock.market_value
                                                     .toFixed(2)
                                                     .toString()
                                                     .replace(
                                                       /\B(?=(\d{3})+(?!\d))/g,
                                                       ","
                                                     ) || "-"
                                                 }</td>
                    <td class="text-right">${
                      !stock.brokerage_fee
                        ? "-"
                        : stock.brokerage_fee.toFixed(2)
                    }</td>


                `;
          tableBody.appendChild(stockRow);
        });
      });
      const subTotalRow = document.createElement("tr");
      if (categoryData.category.name.toUpperCase() == "GROWTH") {
        subTotalRow.classList.add("bg-light-blue", "text-bold");
      } else {
        subTotalRow.classList.add("bg-light-green", "text-bold");
      }
      subTotalRow.innerHTML = `
                    <td class=""></td>
              <td colspan="2">SUB-TOTAL ${categoryData.category.name}</td>
              <td>${categoryData.category.allocation.toFixed(2)}%</td>
              <td>${
                categoryData.category.capital
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
              }</td>
              <td class=""></td>
              <td class=""></td>
              <td class="text-right">${
                categoryData.category.market_value
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
              }</td>
                                                <td class=""></td>


          `;
      tableBody.appendChild(subTotalRow);
    });
    const summaryHeadingRow = document.createElement("tr");
    summaryHeadingRow.classList.add("bg-summary", "text-bold");
    summaryHeadingRow.innerHTML = `
                  <td class=""></td>
            <td colspan="2">Summary</td>
                    <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>


        `;
    tableBody.appendChild(summaryHeadingRow);
    const summaryGrowthRow = document.createElement("tr");
    summaryGrowthRow.classList.add("bg-light-blue", "text-bold");
    summaryGrowthRow.innerHTML = `
                  <td class=""></td>
            <td colspan="2">${data[0].category.name}</td>
                    <td class="">${data[0].category.allocation.toFixed(2)}%</td>
                  <td class="">${
                    data[0].category.capital
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                  }</td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class="">${
                    data[0].category.market_value
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                  }</td>
                  <td class="">${
                    data[0].category.category_brokerage_fee || "-"
                  }</td>
        `;
    tableBody.appendChild(summaryGrowthRow);
    const summaryDefensiveRow = document.createElement("tr");
    summaryDefensiveRow.classList.add("bg-light-green", "text-bold");
    summaryDefensiveRow.innerHTML = `
                  <td class=""></td>
            <td colspan="2">${data[1].category.name}</td>
                    <td class="">${data[1].category.allocation.toFixed(2)}%</td>
                  <td class="">${
                    data[1].category.capital
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                  }</td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class="">${
                    data[1].category.market_value
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                  }</td>
                  <td class="">${
                    data[1].category.category_brokerage_fee || "-"
                  }</td>
        `;
    tableBody.appendChild(summaryDefensiveRow);
    const summaryTotalRow = document.createElement("tr");
    summaryTotalRow.classList.add("bg-summary", "text-bold");
    summaryTotalRow.innerHTML = `
                  <td class=""></td>
            <td colspan="2">TOTAL PORTFOLIO</td>
                    <td class="">${
                      (
                        data[0].category.allocation +
                        data[1].category.allocation
                      ).toFixed(2) + "%" || "-"
                    }</td>
                  <td class="">${
                    (data[0].category.capital + data[1].category.capital)
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                  }</td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class="">${
                    (
                      data[0].category.market_value +
                      data[1].category.market_value
                    )
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                  }</td>
                  <td class="">${
                    (
                      data[0].category.category_brokerage_fee +
                      data[1].category.category_brokerage_fee
                    ).toFixed(2) || "-"
                  }</td>
        `;
    tableBody.appendChild(summaryTotalRow);
    // Optional page break for large content
    const pageBreakRow = document.createElement("tr");
    pageBreakRow.classList.add("page-break");
    pageBreakRow.innerHTML = "<td colspan='11'></td>";
    tableBody.appendChild(pageBreakRow);
    return tableBody;
  }
  function populateTableHolding(data) {
    const tableBody = document.createElement("tbody");
    if (data.length > 0) {
      data.forEach((categoryData) => {
        // Create category row
        const categoryRow = document.createElement("tr");
        if (categoryData.name.toUpperCase() == "GROWTH") {
          categoryRow.classList.add("bg-light-blue", "text-bold");
        } else {
          categoryRow.classList.add("bg-light-green", "text-bold");
        }
        categoryRow.innerHTML = `
                  <td colspan="1"></td>
            <td colspan="1">${categoryData.name.toUpperCase()}</td>
                              <td colspan="1"></td>
                  <td colspan="1"></td>
                  <td colspan="1"></td>
    <td colspan="1" class=""></td>
                <td colspan="1" class=""></td>
                                  <td colspan="1"></td>
                  <td colspan="1"></td>
                                    <td colspan="1"></td>
                                                                        <td colspan="1"></td>



        `;
        tableBody.appendChild(categoryRow);

        // Loop through each product in the category
        categoryData.products.forEach((product, productIndex) => {
          const productRow = document.createElement("tr");
          if (categoryData.name.toUpperCase() == "GROWTH") {
            productRow.classList.add("bg-product-blue", "text-product");
          } else {
            productRow.classList.add("bg-product-green", "text-product");
          }
          productRow.innerHTML = `
                <td>${(productIndex + 1).toString().padStart(2, "0")}</td>
                <td>${product.name}</td>
                <td></td>
                <td></td>
                <td></td>
                <td class="text-right">${product.current_value
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                <td class="text-right">${product.current_percentage.toFixed(
                  2
                )}%</</td>
                <td></td>
                                <td class="text-right">${product.target_value
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                                <td class="t">${product.difference_percentage.toFixed(
                                                  2
                                                )}</td>
                                                                                                <td class="">${product.target_percentage.toFixed(
                                                                                                  2
                                                                                                )}%</td>



            `;
          tableBody.appendChild(productRow);

          // Loop through each stock in the product
          product.stocks.forEach((stock) => {
            const stockRow = document.createElement("tr");
            if (categoryData.name.toUpperCase() == "GROWTH") {
              stockRow.classList.add("bg-stock-blue");
            } else {
              stockRow.classList.add("bg-stock-green");
            }
            stockRow.innerHTML = `
                    <td></td>
                    <td>${stock.name}</td>
                    <td>${stock.code}</td>
                    <td class="">${stock.holdings_quantity
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    ${!stock.holdings_quantity ? "-" : ""}</td>
                    <td class="">${
                      stock.cost_base
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"
                    }</td>
                    <td class=" text-right">${stock.value
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                    <td class=" text-right">${stock.target_weight.toFixed(
                      2
                    )}%</td>
                                                 <td class="text-right">${
                                                   stock.market_price
                                                     .toFixed(2)
                                                     .toString()
                                                     .replace(
                                                       /\B(?=(\d{3})+(?!\d))/g,
                                                       ","
                                                     ) || "-"
                                                 }</td>
                    <td class="text-right">${stock.value
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                    <td class="">${
                                      stock.profit_loss
                                        .toFixed(2)
                                        .toString()
                                        .replace(
                                          /\B(?=(\d{3})+(?!\d))/g,
                                          ","
                                        ) || "-"
                                    }</td>
                                                                                    <td class="">
                                                                                    ${stock.current_weight.toFixed(
                                                                                      2
                                                                                    )}%</td>


                `;
            tableBody.appendChild(stockRow);
          });
        });
        const subTotalRow = document.createElement("tr");
        if (categoryData.name.toUpperCase() == "GROWTH") {
          subTotalRow.classList.add("bg-light-blue", "text-bold");
        } else {
          subTotalRow.classList.add("bg-light-green", "text-bold");
        }
        subTotalRow.innerHTML = `
                    <td class=""></td>
              <td colspan="1">SUB-TOTAL ${categoryData.name}</td>
              <td></td>
              <td></td>
              <td class=""></td>
              <td class="">${categoryData.current_value
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
              <td class="text-right">${categoryData.current_percentage.toFixed(
                2
              )}%</td>
                                                <td class=""></td>
                                                                <td class="">${categoryData.target_value
                                                                  .toFixed(2)
                                                                  .toString()
                                                                  .replace(
                                                                    /\B(?=(\d{3})+(?!\d))/g,
                                                                    ","
                                                                  )}</td>
                                                <td class="">${categoryData.difference_percentage.toFixed(
                                                  2
                                                )}</td>
                                                                                                <td class="">${categoryData.target_percentage.toFixed(
                                                                                                  2
                                                                                                )}%</td>



          `;
        tableBody.appendChild(subTotalRow);
      });
      const summaryHeadingRow = document.createElement("tr");
      summaryHeadingRow.classList.add("bg-summary", "text-bold");
      summaryHeadingRow.innerHTML = `
                  <td class=""></td>
            <td colspan="1">Summary</td>
                    <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                                  <td class=""></td>
                                                <td class=""></td>
                                                                                                <td class=""></td>



        `;
      tableBody.appendChild(summaryHeadingRow);
      const summaryGrowthRow = document.createElement("tr");
      summaryGrowthRow.classList.add("bg-light-blue", "text-bold");
      summaryGrowthRow.innerHTML = `
                  <td class=""></td>
            <td colspan="1">${data[0].name}</td>
                    <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class="">${data[0].current_value
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                  <td class="">${data[0].current_percentage.toFixed(2)}%</td>
                  <td class=""></td>
                                  <td class="">${data[0].target_value
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                                <td class="">${data[0].difference_percentage.toFixed(
                                                  2
                                                )}</td>
                                                                                                <td class="">${data[0].target_percentage.toFixed(
                                                                                                  2
                                                                                                )}%</td>



        `;
      tableBody.appendChild(summaryGrowthRow);
      const summaryDefensiveRow = document.createElement("tr");
      summaryDefensiveRow.classList.add("bg-light-green", "text-bold");
      summaryDefensiveRow.innerHTML = `
                  <td class=""></td>
            <td colspan="1">${data[1].name}</td>
                    <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class="">${data[1].current_value
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                  <td class="">${data[1].current_percentage.toFixed(2)}%</td>
                  <td class=""></td>
                                  <td class="">${data[1].target_value
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                                <td class="">${data[1].difference_percentage.toFixed(
                                                  2
                                                )}</td>
                                                                                                <td class="">${data[1].target_percentage.toFixed(
                                                                                                  2
                                                                                                )}%</td>



        `;
      tableBody.appendChild(summaryDefensiveRow);
      const summaryTotalRow = document.createElement("tr");
      summaryTotalRow.classList.add("bg-summary", "text-bold");
      summaryTotalRow.innerHTML = `
                             <td class=""></td>
            <td colspan="1">TOTAL PORTFOLIO</td>
                    <td class=""></td>
                  <td class=""></td>
                  <td class=""></td>
                  <td class="">${(data[0].current_value + data[1].current_value)
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                  <td class="">${(
                    data[0].current_percentage + data[1].current_percentage
                  ).toFixed(2)}%</td>
                  <td class=""></td>
                                  <td class="">${(
                                    data[0].target_value + data[1].target_value
                                  )
                                    .toFixed(2)
                                    .toString()
                                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                                <td class="">${(
                                                  data[0]
                                                    .difference_percentage +
                                                  data[1].difference_percentage
                                                ).toFixed(2)}</td>
                                                                                                <td class="">${(
                                                                                                  data[0]
                                                                                                    .target_percentage +
                                                                                                  data[1]
                                                                                                    .target_percentage
                                                                                                ).toFixed(
                                                                                                  2
                                                                                                )}%</td>



        `;
      tableBody.appendChild(summaryTotalRow);
      return tableBody;
    } else {
      // ✅ Handle undefined, null, or empty data
      if (!Array.isArray(data) || data.length === 0) {
        const emptyRow = document.createElement("tr");
        emptyRow.innerHTML = `
      <td colspan="11" class="text-center py-4 text-gray-500">
        No holdings available to display.
      </td>`;
        tableBody.appendChild(emptyRow);
        return tableBody;
      }

      // ✅ Proceed with the rest of your logic as-is...
      data.forEach((categoryData) => {
        // your existing loop logic here
      });

      // ✅ Check data[0] and data[1] before using them
      if (data[0]) {
        const summaryGrowthRow = document.createElement("tr");
        summaryGrowthRow.classList.add("bg-light-blue", "text-bold");
        summaryGrowthRow.innerHTML = `...`; // your existing logic for data[0]
        tableBody.appendChild(summaryGrowthRow);
      }

      if (data[1]) {
        const summaryDefensiveRow = document.createElement("tr");
        summaryDefensiveRow.classList.add("bg-light-green", "text-bold");
        summaryDefensiveRow.innerHTML = `...`; // your existing logic for data[1]
        tableBody.appendChild(summaryDefensiveRow);
      }

      if (data[0] && data[1]) {
        const summaryTotalRow = document.createElement("tr");
        summaryTotalRow.classList.add("bg-summary", "text-bold");
        summaryTotalRow.innerHTML = `...`; // your existing logic for totals
        tableBody.appendChild(summaryTotalRow);
      }

      return tableBody;
    }
  }
  const handleDownloadPDF = async () => {
    const date = new Date().toLocaleString();
    const allocationItemsHTML = generateAllocationItems(details);

    const fullHtml = `
  <!DOCTYPE html>
<html>
   <head>
      <meta charset="utf-8" />
      <style>
         @page {
         size: A4 portrait;
         margin: 0;
         }
         html, body {
         margin: 0;
         padding: 0;
         font-family:sans-serif;
         overflow: auto;  /* Ensure content can overflow */
         height: 100%; /* Ensure the body fills the entire height */
         }        .pdf-container {
         max-width: 100% !important;
         margin: 20px;
         }
         tr {
         page-break-inside: avoid !important;
         break-inside: avoid !important;
         }
         .custom-header {
         position: relative;
         display: flex;
         justify-content: space-between;
         background-color: #ffffff;
         padding-top: 10px; /* Ensures no padding at the top */
         }
         .logo-container {
         display: flex;
         align-items: center;
         }
         .logo {
         width: 96px; /* Tailwind w-24 = 6rem = 96px */
         max-width: 150px;
         height: auto;
         object-fit: contain;
         margin-right: 1rem;
         }
         .title {
         position: absolute;
         left: 50%;
         transform: translateX(-50%);
         font-size: 1.125rem; /* Tailwind text-lg */
         font-weight: 500;    /* Tailwind font-medium */
         padding: 0;          /* Remove any padding */
         margin: 0;           /* Remove any margin */
         }
         .date {
         font-size: 0.875rem;  /* Tailwind text-sm */
         font-weight: 500;
         color: #000000;
         padding-bottom: 16px;
         }
         .header {
         display: flex;
         justify-content: space-between;
         align-items: flex-start;
         flex-wrap: wrap;
         }
         .title-section {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
   flex-wrap: nowrap;
  width: 100%;
}

         .icon {
         width: 20px;
         height: 20px;
         }
.second-title {
  font-size: 1rem;
  font-weight: 600;
  padding-bottom: 16px;
  margin: 0;
  max-width: 100%;         /* Prevent exceeding container */
  white-space: normal;     /* Allow text to wrap */
}
         .content {
         display: flex;
         gap: 20px;
         margin-top: 8px;
         padding-right: 16px;
         }
         .left-column {
         width: 40%;
         padding-right: 16px;
         border-right: 1px solid black;
         }
         .right-column {
         width: 60%;
         padding-left: 10px;
         padding-left: 10px;
         }
         .info-block {
         margin-bottom: 24px;
         }
         .label {
         font-size: 12px;
         color: #666666;
         font-weight: 500;
         margin: 0;
         }
         .value {
         font-size: 14px;
         font-weight: 500;
         color: #000000;
         margin: 0;
         }
         .section-title {
         font-size: 12px;
         color: #666666;
         font-weight: 500;
         margin-bottom: 0px;
         }
         .description {
         font-size: 12px;
         font-weight: 500;
         color: #000000;
         line-height: 1.6;
         }
         .form-container {
         background-color: #ffffff;
         border: 1px solid #000000;
         border-radius: 6px;
         margin-top: 20px;
         }
         .grid {
         display: grid;
         grid-template-columns: repeat(4, 1fr);
         border-collapse: collapse;
         }
         .cell {
         border-bottom: 1px solid #000000;
         border-right: 1px solid #000000;
         padding: 16px 12px;
         }
         .cell-last {
         border-right: 1px solid #000000;
         padding: 16px 12px;
         }
         .cell:nth-child(4n) {
         border-right: none;
         }
         .cell-last:nth-child(4n) {
         border-right: none;
         }
         .label {
         font-size: 12px;
         font-weight: 500;
         color: #666666;
         margin-bottom: 6px;
         }
         .value {
         font-size: 14px;
         font-weight: 500;
         color: #000000;
         }
         .allocation-container {
         border: 1px solid black;
         border-radius: 8px;
         padding: 16px;
         margin-top: 20px;
         }
         .allocation-header {
         display: flex;
         align-items: center;
         border-bottom: 1px solid black;
         padding-bottom: 8px;
         margin-bottom: 16px;
         }
         .allocation-header img {
         width: 16px;
         height: 16px;
         margin-right: 8px;
         }
         .allocation-header h3 {
         font-size: 16px;
         font-weight: 500;
         margin: 0;
         }
         .allocation-grid {
         display: flex;
         flex-wrap: wrap;
         gap: 20px;
         }
         .allocation-details {
         flex: 1 1 50%;
         }
         .allocation-items {
         display: grid;
         grid-template-columns: repeat(3, 1fr);
         gap: 16px;
         font-size: 12px;
         }
         .allocation-item {
         display: flex;
         flex-direction: column;
         word-break: break-word;
         }
         .allocation-item .product-name {
         font-size: 14px;
         font-weight: 500;
         color: #444;
         }
         .allocation-item .percentage {
         font-size: 14px;
         font-weight: 500;
         margin-top: 4px;
         }
         .chart-container {
         display: flex;
         justify-content: flex-end;
         margin-top: 16px;
         }
         .chart-container img {
         width: 160px;
         height: 160px;
         }
         .page-break {
         page-break-before: always;
         break-before: page;
         display: block;
         height: 0; /* No extra space */
         width: 100%;
         content: "";}
         /* Responsive fallback (1 column on small screens) */
         @media print {
         .grid {
         grid-template-columns: repeat(4, 1fr);
         }
         }
      </style>
   </head>
   <body>
      <div class="pdf-container">
         <div class="custom-header">
            <div class="logo-container">
               <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
            </div>
            <h2 class="title">Factsheet</h2>
            <div class="date">${date}</div>
         </div>
         <div class="header">
            <!-- Title Section with Icon -->
            <div class="title-section">
               <img src="${svgBookBase64}"  alt="Portfolio Icon" class="icon" />
                  <h2 class="second-title">Caprock Model Portfolio - ${
                    details.basic_details.name
                  }</h2>
            </div>
         </div>
         <!-- Content Section -->
         <div class="content">
            <!-- Left Column -->
            <div class="left-column">
               <div class="info-block">
                  <p class="label">Strategy</p>
                  <p class="value">${details.basic_details.name}</p>
               </div>
               <div class="info-block">
                  <p class="label">Type</p>
                  <p class="value">${details.basic_details.strategy_type}</p>
               </div>
               <div class="info-block">
                  <p class="label">Growth</p>
                  <p class="value">${
                    details.basic_details.growth_percentage
                  }</p>
               </div>
               <div class="info-block">
                  <p class="label">Defensive</p>
                  <p class="value">${
                    details.basic_details.defensice_percentage
                  }</p>
               </div>
            </div>
            <!-- Right Column -->
            <div class="right-column">
               <div class="info-block">
                  <p class="label">FUND OBJECTIVE & PROCESS</p>
                  <p class="description">
                     ${details.basic_details.fund_objective_and_process}        
               </div>
               </p>
            </div>
         </div>
         <div class="form-container">
            <div class="grid">
               <!-- Cell -->
               <div class="cell">
                  <div class="label">Platform</div>
                  <div class="value">${details.details.platform.name}</div>
               </div>
               <div class="cell">
                  <div class="label">Code</div>
                  <div class="value">${details.details.code}</div>
               </div>
               <div class="cell">
                  <div class="label">Min investment</div>
                  <div class="value">
                     $${details.details.minimum_investment
                       .toFixed(2)
                       .toString()
                       .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </div>
               </div>
               <div class="cell">
                  <div class="label">Investment Manager</div>
                  <div class="value">${
                    details.details.investment_manager.name
                  }</div>
               </div>
               <div class="cell">
                  <div class="label">Sub Advisor</div>
                  <div class="value">${
                    details.details.sub_advisor
                      ? details.details.sub_advisor.name
                      : ""
                  }
                  </div>
               </div>
               <div class="cell">
                  <div class="label">Risk profile</div>
                  <div class="value">${details.details.risk_profile}</div>
               </div>
               <div class="cell">
                  <div class="label">Risk rating</div>
                  <div class="value">${details.details.risk_rating}</div>
               </div>
               <div class="cell">
                  <div class="label">Strategy inception date</div>
                  <div class="value">${formatDateList(
                    details.details.strategy_date_creation
                  )}
                  </div>
               </div>
               <div class="cell-last">
                  <div class="label">Investments</div>
                  <div class="value">${details.details.investment_tags.join(
                    ", "
                  )}</div>
               </div>
               <div class="cell-last">
                  <div class="label">SMA Fees</div>
                  <div class="value">${details.details.sma_fee} (+ GST)</div>
               </div>
               <div class="cell-last">
                  <div class="label">Investment Manager Fees</div>
                  <div class="value">${
                    details.details.investment_manager_fee
                  }% + GST
                  </div>
               </div>
               <div class="cell-last" style="border-right: none;">
                  <div class="label">Sub Advisor Fees</div>
                  <div class="value">${
                    details.details.sub_advisor_fee
                  }% + GST</div>
               </div>
            </div>
         </div>
         <div class="allocation-container">
            <div class="allocation-header">
               <img src="${svgGraphBase64}" alt="Icon" />
               <h3>Current Target Allocation</h3>
            </div>
            <div class="allocation-grid">
               <div class="allocation-details">
                  <div class="allocation-items" id="allocation-items">
                     ${allocationItemsHTML}
                  </div>
               </div>
               <div class="chart-container">
                  <img src="${chartImage}" alt="Doughnut Chart" />
               </div>
            </div>
         </div>
      </div>
      <div class="page-break"></div>
      <div class="pdf-container">
         <div style="background-color: #ffffff; margin-bottom: 1rem; padding: 0.5rem; border-radius: 6px;">
            <!-- Header -->
            <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; width: 100%; border-bottom: 1px solid #000; padding-bottom: 0.5rem;">
               <h3 style="display: flex; align-items: center; font-size: 1rem; font-weight: 500; color: #000; margin: 0;">
                  <img src="${svgDiagramBase64}" alt="Portfolio Icon" style="width: 20px; height: 20px; margin-right: 0.5rem;" />
                  <span>Historical Performance</span>
               </h3>
               <div style="display: flex; align-items: center; gap: 0.2rem; font-size: 0.875rem; margin-bottom: 0.5rem;">
                  <span style="color: #555; white-space: nowrap;">Caprock Growth:</span>
                  <span style="font-weight: 500; color: #000; white-space: nowrap;">${
                    details.details.risk_profile
                  }</span>
               </div>
            </div>
            <!-- Chart -->
            <div style="margin-top: 0.5rem;">
               <img src="${historyChartImage}" alt="history Chart" style="width: 100%; max-height: 200px; object-fit: contain;" />
            </div>
            <!-- Note -->
            <div style="font-size: 0.875rem; color: #000; line-height: 1.6; margin-top: 1rem;">
               <p style="font-weight: bold; margin-bottom: 0.25rem;">
                  *Past performance is not a guide to future performance.
               </p>
               <p style="font-weight: 500;">
${pastPerformance}
               </p>
            </div>
            <!-- Disclaimer -->
            <div style="margin-top: 1.5rem; border-bottom: 1px solid #000; padding-bottom: 0.5rem;">
               <h3 style="display: flex; align-items: center; font-size: 1rem; font-weight: 500; color: #000; margin: 0;">
                  <img src="${svgInfoCircleBase64}" alt="Info Icon" style="width: 20px; height: 20px; margin-right: 0.5rem;" />
                  <span>Disclaimer</span>
               </h3>
               <p style="font-size: 0.875rem; color: #000; font-weight: 500; line-height: 1.6; margin-top: 0.5rem;">
${disclaimer}
               </p>
            </div>
            <!-- Copyright -->
            <div style="margin-top: 1.5rem; border-bottom: 1px solid #000; padding-bottom: 0.5rem;">
               <h3 style="display: flex; align-items: center; font-size: 1rem; font-weight: 500; color: #000; margin: 0;">
                  <img src="${svgInfoCircleBase64}" alt="Info Icon" style="width: 20px; height: 20px; margin-right: 0.5rem;" />
                  <span>Copyright</span>
               </h3>
               <p style="font-size: 0.875rem; color: #000; font-weight: 500; line-height: 1.6; margin-top: 0.5rem;">
                  ${copyright}               </p>
            </div>
         </div>
      </div>
   </body>
</html>
  `;
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        // Token expired or invalid
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }

      // For other errors
      const errorData = await response.json().catch(() => ({
        message: "An error occurred",
      }));
      throw new Error(errorData.message || `Error ${response.status}`);
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Factsheet - Caprock Model Portfolio - ${factSheetFileName}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHidden(false);
  };
  const handleDownloadValuationPDF = async () => {
    const date = new Date().toLocaleString();
    const allocationItemsHTML = generateAllocationItems(holdingValuationData);
    const tableBodyElement = populateTableHolding(
      holdingValuationData.holdings_breakdown.categories.length > 0
        ? holdingValuationData.holdings_breakdown.categories
        : []
    );
    const tableBody = tableBodyElement.outerHTML;
    const fullHtml = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8" />
        <style>
                @page {
  size: A4 landscape;
  margin: 0;
}
  html, body {
          margin: 0;
          padding: 0;
                    font-family:sans-serif;
  overflow: auto;  /* Ensure content can overflow */

          height: 100%; /* Ensure the body fills the entire height */
        }        .pdf-container {
            max-width: 100% !important;
            margin: 20px;
          }
          tr {
            page-break-inside: avoid !important;
            break-inside: avoid !important;
          }
  
          .custom-header {
            position: relative;
            display: flex;
            justify-content: space-between;
            background-color: #ffffff;
            padding-top: 10px; /* Ensures no padding at the top */
          }
  
          .logo-container {
            display: flex;
            align-items: center;
          }
  
          .logo {
            width: 96px; /* Tailwind w-24 = 6rem = 96px */
            max-width: 150px;
            height: auto;
            object-fit: contain;
            margin-right: 1rem;
          }
  
          .title {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            font-size: 1.125rem; /* Tailwind text-lg */
            font-weight: 500;    /* Tailwind font-medium */
            padding: 0;          /* Remove any padding */
            margin: 0;           /* Remove any margin */
          }
  
          .date {
            font-size: 0.875rem;  /* Tailwind text-sm */
            font-weight: 500;
            color: #000000;
            padding-bottom: 16px;
          }
                  .header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
      }
        .title-section {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
   flex-wrap: nowrap;
  width: 100%;
}

         .icon {
         width: 20px;
         height: 20px;
         }
.second-title {
  font-size: 1rem;
  font-weight: 600;
  padding-bottom: 16px;
  margin: 0;
  max-width: 100%;         /* Prevent exceeding container */
  white-space: normal;     /* Allow text to wrap */
}
      .label {
        font-size: 12px;
        color: #666666;
        font-weight: 500;
        margin: 0;
      }

      .value {
        font-size: 14px;
        font-weight: 500;
        color: #000000;
        margin: 0;
      }

      .section-title {
        font-size: 12px;
        color: #666666;
        font-weight: 500;
        margin-bottom: 0px;
      }

      .description {
        font-size: 12px;
        font-weight: 500;
        color: #000000;
        line-height: 1.6;
      }
              .form-container {
        background-color: #ffffff;
        border: 1px solid #000000;
        border-radius: 6px;
        margin-top: 0px;
      }

      .grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        border-collapse: collapse;
      }

      .cell {
        border-bottom: 1px solid #000000;
        border-right: 1px solid #000000;
        padding: 16px 12px;
      }
  .cell-last {
        border-right: 1px solid #000000;
        padding: 16px 12px;
      }
      .cell:nth-child(4n) {
        border-right: none;
      }
  .cell-last:nth-child(4n) {
        border-right: none;
      }

      .label {
        font-size: 12px;
        font-weight: 500;
        color: #666666;
        margin-bottom: 6px;
      }

      .value {
        font-size: 14px;
        font-weight: 500;
        color: #000000;
      }
      .allocation-container {
        border: 1px solid black;
        border-radius: 8px;
        padding: 16px;
        margin-top: 20px;
      }

      .allocation-header {
        display: flex;
        align-items: center;
        border-bottom: 1px solid black;
        padding-bottom: 8px;
        margin-bottom: 16px;
      }

      .allocation-header img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }

      .allocation-header h3 {
        font-size: 16px;
        font-weight: 500;
        margin: 0;
      }

      .allocation-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
      }

      .allocation-details {
        flex: 1 1 50%;
      }

      .allocation-items {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
        font-size: 12px;
      }

      .allocation-item {
        display: flex;
        flex-direction: column;
        word-break: break-word;
      }

      .allocation-item .product-name {
        font-size: 14px;
        font-weight: 500;
        color: #444;
      }

      .allocation-item .percentage {
        font-size: 14px;
        font-weight: 500;
        margin-top: 4px;
      }

      .chart-container {
        display: flex;
        justify-content: flex-end;
        margin-top: 16px;
      }

      .chart-container img {
        width: 160px;
        height: 160px;
      }
.page-break {
         page-break-before: always;
  break-before: page;
  display: block;
  height: 0; /* No extra space */
  width: 100%;
  content: "";}
      /* Responsive fallback (1 column on small screens) */
      @media print {
        .grid {
          grid-template-columns: repeat(4, 1fr);
        }
      }
            table {
      width: 100%;
      border-collapse: collapse;
      font-size: 10px;
      margin-top: 1rem;
    }

    th, td {
      border: 1px solid #ffffff;
      padding: 0.5rem 1rem;
    }

    /* Header row styling */
    th {
      background-color: #6AA7D3;
      color: white;
      font-weight: bold;
    }

    /* Specific styles for 'Market Price' column header */
    .market-price {
      background-color: #F4D580;
    }

    /* Optional styling for overflow if required */
    .overflow-x-auto {
      overflow-x: auto;
    }
              .bg-light-blue {
            background-color: #92C5EA;
        }
         .bg-product-blue {
            background-color: #C6DFF1;
        }
                .bg-stock-blue {
            background-color: #E6F3FC;
        }
            .bg-summary{
                        background-color: #EAEAEA;

            }
             .bg-product-green {
            background-color: #C0E2C1;
        }
             .bg-stock-green {
            background-color: #E7F5E8;
        }

        .bg-light-green {
            background-color: #A9D4AB;
        }

        .bg-off-white {
            background-color: #EAEAEA;
        }

        .text-bold {
            font-weight: bold;
        }
        .text-product{
                    font-weight: bold;
color: #005A9C;
        }

        .text-center {
            text-align: center;
        }

        .text-right {
            text-align: right;
        }

        .font-small {
            font-size: 12px;
        }

        .page-break {
            page-break-before: always;
        }
        </style>
      </head>
      <body>
     <div class="pdf-container">
        <div class="custom-header">
          <div class="logo-container">
            <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
          </div>
          <h2 class="title">Holding Valuation Report</h2>
          <div class="date">${date}</div>
        </div>
                  <div class="header">
      <!-- Title Section with Icon -->
      <div class="title-section">
        <img src="${svgBookBase64}"  alt="Portfolio Icon" class="icon" />
          <h2 class="second-title">Caprock Model Portfolio - ${
            holdingValuationData.strategy_name
          }</h2>
      </div>
    </div>
        <div class="form-container">
      <div class="grid">
        <!-- Cell -->
        <div class="cell">
          <div class="label">Client Id</div>
          <div class="value">${
            holdingValuationData.client_details.client_id == null
              ? "Not Found"
              : holdingValuationData.client_details.client_id
          }</div>
        </div>
        <div class="cell">
          <div class="label"> Broker Id</div>
          <div class="value">${
            holdingValuationData.client_details.broker_id == null
              ? "Not Found"
              : holdingValuationData.client_details.broker_id
          }</div>
        </div>
        <div class="cell">
          <div class="label">Hin</div>
          <div class="value">
          ${
            holdingValuationData.client_details.bd_hin_number == null
              ? "Not Found"
              : holdingValuationData.client_details.bd_hin_number
          }</div>
        </div>
        <div class="cell">
          <div class="label">Risk profile</div>
          <div class="value">${holdingValuationData.client_details.risk_profile}
</div>
        </div>

        <div class="cell-last">
          <div class="label">Type</div>
          <div class="value">${
            holdingValuationData.client_details.strategy_type
          }</div>
        </div>
        <div class="cell-last">
          <div class="label">Investment Date</div>
          <div class="value">${formatDateList(
            holdingValuationData.strategy_creation_date
          )}</div>
        </div>
        <div class="cell-last">
          <div class="label">Growth</div>
          <div class="value">${
            holdingValuationData.client_details.growth_percentage
          }</div>
        </div>
        <div class="cell-last">
          <div class="label">Defensive</div>
          <div class="value">${
            holdingValuationData.client_details.defensive_percentage
          }</div>
        </div>
        </div>
      </div>
        <div class="allocation-container">
      <div class="allocation-header">
        <img src="${svgGraphBase64}" alt="Icon" />
        <h3>Current Target Allocation</h3>
      </div>

      <div class="allocation-grid">
        <div class="allocation-details">
          <div class="allocation-items" id="allocation-items">
               ${allocationItemsHTML}
          </div>
        </div>

        <div class="chart-container">
          <img src="${chartImage}" alt="Doughnut Chart" />
        </div>
      </div>
    </div>
    
  <div class="overflow-x-auto">
    <table>
      <thead>
        <tr>
          <th>No</th>
          <th>Strategic Asset Allocation</th>
          <th>Code</th>
          <th>Holdings</th>
          <th>Cost Base</th>
          <th>Value($)</th>
          <th>Weight(%)</th>
          <th>Market Price</th>
          <th>Value ($)</th>
          <th>P/L</th>
                    <th>Weight(%)</th>

        </tr>
      </thead>
                    ${tableBody}


    </table>
  </div>
        <!-- Disclaimer -->
      <div style="margin-top: 2rem;margin-left: 0rem; margin-right: 0rem; border-bottom: 1px solid #000; padding-bottom: 0.5rem;">
         <h3 style="display: flex; align-items: center; font-size: 1rem; font-weight: 500; color: #000; margin: 0;">
            <img src="${svgInfoCircleBase64}" alt="Info Icon" style="width: 20px; height: 20px; margin-right: 0.5rem;" />
            <span>Disclaimer</span>
         </h3>
         <p style="font-size: 0.775rem; color: #000; font-weight: 500; line-height: 1.6; margin-top: 0.5rem;">
            ${disclaimer}         </p>
      </div>
         <div style="margin-top: 2rem;margin-left: 0rem; margin-right: 0rem; border-bottom: 1px solid #000; padding-bottom: 0.5rem;">
         <h3 style="display: flex; align-items: center; font-size: 1rem; font-weight: 500; color: #000; margin: 0;">
            <img src="${svgInfoCircleBase64}" alt="Info Icon" style="width: 20px; height: 20px; margin-right: 0.5rem;" />
            <span>Copyright</span>
         </h3>
         <p style="font-size: 0.775rem; color: #000; font-weight: 500; line-height: 1.6; margin-top: 0.5rem;">
            ${copyright}         </p>
      </div>
    </div>

           </body>
    </html>
  `;
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        // Token expired or invalid
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }

      // For other errors
      const errorData = await response.json().catch(() => ({
        message: "An error occurred",
      }));
      throw new Error(errorData.message || `Error ${response.status}`);
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Holding Valuation-${formattedDate}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHiddenReport(false);
  };
  const fetchViewData = async () => {
    setIsLoading(true);
    try {
      const response = await GetAPIcalls(
        `/v1/investment-portfolio/get/${investment_id}/view?period=${selectedFilter.toLocaleLowerCase()}`
      );

      if (response.status == 200) {
        setinvestmentManagerNameView(
          response.data.fact_sheet.investment_manager
        );
        setdateCreated(formatDateList(response.data.fact_sheet.date_created));
        setstrategyTypeView(response.data.fact_sheet.strategy_type);
        setGrowth(response.data.fact_sheet.growth_percentage);
        setDefensive(response.data.fact_sheet.defensive_percentage);
        const cleanHTML = DOMPurify.sanitize(
          response.data.fact_sheet.fund_objective_and_process,
          {
            ALLOWED_TAGS: [
              "b",
              "i",
              "strong",
              "em",
              "u",
              "ol",
              "ul",
              "li",
              "br",
              "p",
              "span",
            ],
            ALLOWED_ATTR: [],
          }
        );
        setFundObjectives(cleanHTML);
        //investment details
        setinvestmentProductName(
          response.data.investment_details.investment_product_name
        );
        setriskRating(response.data.investment_details.risk_rating);
        setRiskProfile(response.data.risk_profile);
        setGrowth(response.data.investment_details.growth_percentage);
        setDefensive(response.data.investment_details.defensive_percentage);
        setInvestments(response.data.investment_details.tags);
        setmanagerFees(response.data.investment_details.manager_fee_percentage);
        setadvisorFees(response.data.investment_details.advisor_fee_percentage);
        setsmaFees(response.data.investment_details.sma_fee_percentage);
        setsubadvisorFees(
          response.data.investment_details.sub_advisor_fee_percentage
        );
        setminimumInvestedAmount(
          response.data.investment_details.minimum_investment
        );
        setpastPerformance(response.data.past_performance);
        setCopyright(response.data.copy_rights);
        setDisclaimer(response.data.disclaimer);
        // current allocation
        setExistingCategories(response.data.current_target_allocation);

        //allocation graph
        setfilteredGraphdata(response.data.product_percentage_allocation);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const getAllAllocations = async () => {
    setIsLoading(true);
    try {
      const response = await GetAPIcalls(
        `/v1/investment-portfolio/get/${investment_id}/tactical-asset-allocation`
      );

      if (response.status == 200) {
        const growthCategory = response.data.categories.find(
          (category) => category.id === 1
        );
        const defensiveCategory = response.data.categories.find(
          (category) => category.id === 2
        );

        if (growthCategory) {
          setGrowth(growthCategory.saa_percentage);
        }
        if (defensiveCategory) {
          setDefensive(defensiveCategory.saa_percentage);
        }

        getAllCategories();
        setminimumInvestment(response.data.total_portfolio_value);
        setinvestmentProductName(response.data.portfolio_name);
        setStrategyTypeId(response.data.strategy.id);
        // current allocation
        setExistingCategories(response.data.categories);
        setActualCategories(response.data.categories);
        //Code taa and daa
        updateTAAData(response.data.categories);
        // end here
        //allocation graph
        setfilteredGraphdata(response.data.products);
        setAPISuccess(true);
        // setrawData(response.data.historic_prices);
        // const stockPrices = response.data.historic_prices.map(
        //   (item) => item.price
        // );
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        setAPISuccess(false);
      }
    } catch (err) {
      showToast(err.message, "error");
      setAPISuccess(false);
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const getDaaAllocations = async () => {
    setIsLoading(true);
    try {
      const response = await GetAPIcalls(
        `/v1/investment-portfolio/get/${investment_id}/dynamic-asset-allocation`
      );

      if (response.status == 200) {
        const growthCategory = response.data.categories.find(
          (category) => category.id === 1
        );
        const defensiveCategory = response.data.categories.find(
          (category) => category.id === 2
        );

        if (growthCategory) {
          setGrowth(growthCategory.saa_percentage);
        }
        if (defensiveCategory) {
          setDefensive(defensiveCategory.saa_percentage);
        }

        getAllCategories();
        setminimumInvestment(response.data.total_portfolio_value);
        setinvestmentProductName(response.data.portfolio_name);
        setStrategyTypeId(response.data.strategy.id);
        // current allocation
        setExistingCategories(response.data.categories);
        setActualCategories(response.data.categories);
        //Code taa and daa
        updateTAAData(response.data.categories);
        // end here
        //allocation graph
        setfilteredGraphdata(response.data.products);
        // setrawData(response.data.historic_prices);
        // const stockPrices = response.data.historic_prices.map(
        //   (item) => item.price
        // );
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };

  const getRebalancingData = async () => {
    setIsLoadingRebalacing(true);
    try {
      const response = await GetAPIcalls(
        `/v1/investment-portfolio/get/${investment_id}/rebalancing-details`
      );
      if (response.status == 200) {
        if (response.data.categories.length > 0) {
          setRebalancingData(response.data.categories);
          setinvestmentProductName(response.data.portfolio_name);
        } else {
          showToast(response.message, "error");
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoadingRebalacing(false);
      }, 100);
    }
  };
  const getInvestmentDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/investment-portfolio/get/${investment_id}/details`
      );

      if (response.status == 200) {
        setRefId(response.data.basic_details.reference_id);
        // setinvestmentProductName(
        //   response.data.investment_details.investment_product_name
        // );
        setfactsheetFileName(
          response.data.investment_details.investment_product_name
        );
        setstrategyType(response.data.basic_details.strategy_type);
        setRiskProfile(response.data.basic_details.risk_profile);
        setinvestmentType(response.data.basic_details.investment_type);
        // Manager details
        if (response.data.basic_details.manager != null) {
          setInvestmentManagerNamefromAPI(
            response.data.basic_details.manager.name
          );
          setInvestmentManagerId(response.data.basic_details.manager.id);
          setPreselectedManager({
            label: response.data.basic_details.manager.name,
            value: response.data.basic_details.manager.id,
          });
          setPreselectedManagerAccount({
            label: response.data.basic_details.manager.account.account_name,
            value: response.data.basic_details.manager.account.id,
          });
          setInvestmentManagerAccount(
            response.data.basic_details.manager.account.id
          );
          setInvestmentManagerAccountfromAPI(
            response.data.basic_details.manager.account.account_name
          );
          setmanagerFees(
            response.data.basic_details.manager.account.fee_percentage
          );
          setmanagerFeesUpdate(
            response.data.basic_details.manager.account.fee_percentage
          );
        }
        // custodian
        if (response.data.basic_details.custodian != null) {
          setCustodianNameFromAPI(response.data.basic_details.custodian.name);
          setCustodianId(response.data.basic_details.custodian.id);
          setpreselectedCustodian({
            label: response.data.basic_details.custodian.name,
            value: response.data.basic_details.custodian.id,
          });
          setPreselectedCustodianAccount({
            label: response.data.basic_details.custodian.account.account_name,
            value: response.data.basic_details.custodian.account.id,
          });
          setCustodianAccount(response.data.basic_details.custodian.account.id);
          setCustodianAccountFromAPI(
            response.data.basic_details.custodian.account.account_name
          );
          setcustodianFees(
            response.data.basic_details.custodian.account.fee_percentage
          );
          setcustodianFeesUpdate(
            response.data.basic_details.custodian.account.fee_percentage
          );
        }
        //asset manager
        if (response.data.basic_details.asset_manager != null) {
          setAssetManagerNamefromAPI(
            response.data.basic_details.asset_manager.name
          );
          setAssetManagerId(response.data.basic_details.asset_manager.id);
          setPreSelectedAssetManager({
            label: response.data.basic_details.asset_manager.name,
            value: response.data.basic_details.asset_manager.id,
          });
          setPreselectedAssetManagerAccount({
            label:
              response.data.basic_details.asset_manager.account.account_name,
            value: response.data.basic_details.asset_manager.account.id,
          });
          setAssetManagerAccount(
            response.data.basic_details.asset_manager.account.id
          );
          setAssetManagerAccountfromAPI(
            response.data.basic_details.asset_manager.account.account_name
          );
          setassetManagerFees(
            response.data.basic_details.asset_manager.account.fee_percentage
          );
          setassetManagerFeesUpdate(
            response.data.basic_details.asset_manager.account.fee_percentage
          );
        }
        //Advisor
        if (response.data.basic_details.advisor != null) {
          setadvisorIdfromAPI(response.data.basic_details.advisor.name);
          setPreselectedAdvisor({
            label: response.data.basic_details.advisor.name,
            value: response.data.basic_details.advisor.id,
          });
          setPreselectedAdvisorAccount({
            label: response.data.basic_details.advisor.account.account_name,
            value: response.data.basic_details.advisor.account.id,
          });
          setadvisorAccountfromAPI(
            response.data.basic_details.advisor.account.account_name
          );
          setadvisorId(response.data.basic_details.advisor.id);
          setadvisorAccount(response.data.basic_details.advisor.account.id);
          setadvisorFeesUpdate(
            response.data.basic_details.advisor.account.fee_percentage
          );
          setadvisorFees(
            response.data.basic_details.advisor.account.fee_percentage
          );
        }
        //subadvisor
        if (response.data.basic_details.sub_advisor != null) {
          setSubadvisorIdfromAPI(response.data.basic_details.sub_advisor.name);
          setPreselectedSubAdvisor({
            label: response.data.basic_details.sub_advisor.name,
            value: response.data.basic_details.sub_advisor.id,
          });
          setPreselectedSubAdvisorAccount({
            label: response.data.basic_details.sub_advisor.account.account_name,
            value: response.data.basic_details.sub_advisor.account.id,
          });
          setsubAdvisorAccountfromAPI(
            response.data.basic_details.sub_advisor.account.account_name
          );
          setSubadvisorId(response.data.basic_details.sub_advisor.id);
          setsubAdvisorAccount(
            response.data.basic_details.sub_advisor.account.id
          );
          setsubadvisorFees(
            response.data.basic_details.sub_advisor.account.fee_percentage
          );
          setsubadvisorFeesUpdate(
            response.data.basic_details.sub_advisor.account.fee_percentage
          );
        }
        // Platform details
        if (response.data.basic_details.platform != null) {
          setPlatformIdfromAPI(response.data.basic_details.platform.name);
          setPlatformId(response.data.basic_details.platform.id);
          setplatformAccount(response.data.basic_details.platform.account.id);
          setPlatformAccountfromAPI(
            response.data.basic_details.platform.account.account_name
          );
          setPreselectedPlatform({
            label: response.data.basic_details.platform.name,
            value: response.data.basic_details.platform.id,
          });
          setPreselectedPlatformAccount({
            label: response.data.basic_details.platform.account.account_name,
            value: response.data.basic_details.platform.account.id,
          });
          setPlatformFees(
            response.data.basic_details.platform.account.fee_percentage
          );
          setplatformFeesUpdate(
            response.data.basic_details.platform.account.fee_percentage
          );
        }
        const cleanHTML = DOMPurify.sanitize(
          response.data.basic_details.fund_objective_and_process,
          {
            ALLOWED_TAGS: [
              "b",
              "i",
              "strong",
              "em",
              "u",
              "ol",
              "ul",
              "li",
              "br",
              "p",
              "span",
            ],
            ALLOWED_ATTR: [],
          }
        );
        setFundObjectives(cleanHTML);

        setinvestmentProductName(
          response.data.investment_details.investment_product_name
        );
        setriskRating(response.data.investment_details.risk_rating);
        setGrowth(response.data.investment_details.growth_percentage);
        setDefensive(response.data.investment_details.defensive_percentage);
        setInvestments(response.data.investment_details.tags);
        setminimumInvestedAmount(
          response.data.investment_details.minimum_investment
        );
        setaddToDashboard(response.data.add_to_dashboard);
        setaddMember(response.data.accessible_to_specific_customer);
        setAddMemberFromAPI(response.data.accessible_to_specific_customer);
        setAddtoDashboardFromaAPI(response.data.add_to_dashboard);
        setPreselectedAddToDashboard({
          label: response.data.add_to_dashboard == true ? "Yes" : "No",
          value: response.data.add_to_dashboard,
        });

        setPreselectedAddUser({
          label:
            response.data.accessible_to_specific_customer == true
              ? "Yes"
              : "No",
          value: response.data.accessible_to_specific_customer,
        });
        setstrategyDate(
          formatDate(response.data.investment_details.strategy_creation_date)
        );

        setsmaFees(response.data.investment_details.sma_fee_percentage);
        setsmaFeesUpdate(response.data.investment_details.sma_fee_percentage);
        setSpecificUsers(response.data.specific_investors_ids);
        for (let i = 0; i < response.data.specific_investors_ids.length; i++) {
          dispatch(addSelectedUsers(response.data.specific_investors_ids[i]));
        }
        for (let i = 0; i < response.data.document_ids.length; i++) {
          dispatch(addDocumentId(response.data.document_ids[i]));
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getInvestorDetails = async () => {
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(
        `/v1/investment-portfolio/${investment_id}/investors?page=${currentPage}&size=${showRecords}&search=${searchQuery}&status=${filterStatus}`
      );

      if (response.status == 200) {
        setTotalInvestors(response.data.total_unique_investors);
        setTotalInvestedAmount(response.data.total_invested_amount);
        setInvestortableData(response.data.investors);
        settotalPages(response.data.total_pages);
        setCurrentPage(response.data.page);
        settotalCount(response.data.total_count);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click happened outside all dropdowns
      const isOutside = !Object.values(buttonRefs.current).some((ref) =>
        ref?.contains(event.target)
      );

      if (isOutside) {
        setOpenDropdown(null); // Close dropdown if clicked outside
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  const handleSelectInvestmentManagerAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setInvestmentManagerAccount(selectedOption.value);
    setisNewChange(false);
  };
  const handleSelectClientAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setClientAccountId(selectedOption.value);
    setClientAccountBalance(selectedOption.balance);
  };
  const handleSelectInvestmentManager = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setInvestmentManagerId(selectedOption.value);
    setPreselectedManager(selectedOption);
    setPreselectedManagerAccount({});
    setInvestmentManagerAccount(null);
    if (selectedOption.value == null) {
      setmanagerFeesUpdate(0);
      setmanagerFees(0);
      setInvestmentManagerNamefromAPI("");
      setInvestmentManagerAccountfromAPI("");
      setInvestmentManagerAccountData([]);
    }
    setisNewChange(false);
  };
  const handleSelectAdvisor = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setadvisorId(selectedOption.value);
    setPreselectedAdvisor(selectedOption);
    setPreselectedAdvisorAccount({});
    setadvisorAccount(null);
    if (selectedOption.value == null) {
      setadvisorFeesUpdate(0);
      setadvisorFees(0);
      setadvisorAccountfromAPI("");
      setadvisorIdfromAPI("");
      setAdvisorAccountData([]);
    }
    setisNewChange(false);
  };
  const handleSelectAdvisorAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setadvisorAccount(selectedOption.value);
    setisNewChange(false);
  };
  const postPurchaseAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/investment-request/create`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const bodyData = {
      user_id: clientUserId,
      investment_portfolio_id: investment_id,
      amount: Number(investmentAmount),
      cash_account_id: clientAccountId,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Token expired or invalid
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }

        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };

  const handleSubmit = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await postPurchaseAPI();
        if (response.status === 200) {
          setIsCurrentInvestorSelected(true);
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [clientUserId, investment_id, investmentAmount, clientAccountId] // Dependencies
  );
  const postFetchHistory = async () => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/investment-portfolio/simulated-historic-performance`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const bodyData = {
      portfolio_id: investment_id,
      time_interval: selectedFilter,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Token expired or invalid
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }

        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const fetchHistoryViewData = useCallback(
    debounce(async (e) => {
      setIsLoadingGraph(true);
      let toastMessage = null;
      try {
        const response = await postFetchHistory();
        if (response.status === 200) {
          setrawData(response.data.performance_data);
          const stockPrices = response.data.performance_data.map(
            (item) => item.value
          );
          const combineIndices = response.data.combined_index_graph.map(
            (item) => item.value
          );
          setCombineIndex(combineIndices);
          setStockprices(stockPrices);
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
      } finally {
        // Show toast after loading is false
        setIsLoadingGraph(false);
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [selectedFilter] // Dependencies
  );
  useEffect(() => {
    if (filter == "details") getUsers();
  }, [filter]);
  const createInvestor = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/investment/get/investors-details`;
    const bodyData = {
      client_id: clientId,
      creator_id: creatorId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getWalletAccountsByClient = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/account/user/${clientUserId}/cash-accounts`
      );

      if (response.status == 200) {
        const InvestmentManagerAccountData = [];
        response.data.cash_accounts.forEach((profile) => {
          InvestmentManagerAccountData.push({
            value: profile.id,
            label: profile.name,
            balance: profile.balance,
          });
        });
        setNewClientAccountData(InvestmentManagerAccountData);
        setpreSelectedClientAccount(InvestmentManagerAccountData[0]);
        handleSelectClientAccount(InvestmentManagerAccountData[0]);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setNewClientAccountData([]);
          setpreSelectedClientAccount({});
          handleSelectClientAccount({});
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };

  const formatNumber = (value) => {
    if (!value) return "";
    // Remove non-numeric characters except dot
    const number = value.replace(/,/g, "");
    return Number(number).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  const unformatNumber = (value) => {
    // Remove commas from the formatted number
    return value.replace(/,/g, "");
  };

  const handleInputChange = (e) => {
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setInvestmentAmount(rawValue); // Store raw value without commas

      // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
        }
      }, 0);
    }
    if (rawValue > 0) {
      setportfolioDataAvailable(false);
    }
  };

  const handleBlur = () => {
    if (investmentAmount) {
      setInvestmentAmount(Number(investmentAmount).toFixed(2)); // Ensure two decimal places are retained
    }
  };
  const viewBrekdownAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/investment-portfolio/${investment_id}/portfolio-breakdown`;
    const bodyData = {
      amount: Number(investmentAmount),
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const addInvestorDetail = async (e) => {
    e.preventDefault();
    if (clientName == "" || clientId == "" || isClientExist == false) {
      showToast("Please choose the valid client", "error");
      return;
    }
    if (creatorName == "" || creatorId == "" || isCreatorExist == false) {
      showToast("Please choose the valid creator", "error");
      return;
    }
    try {
      const response = await createInvestor();

      if (response.status == 200) {
        setInvestorClientFirstName(response.data.client.first_name);
        setInvestorClientLastName(response.data.client.last_name);
        setInvestorClientEmail(response.data.client.email);
        setInvestorClientPhone(response.data.client.phone);
        setInvestorClientAccountBalance(
          response.data.client.cash_account_balance
        );
        setInvestorClientAbn(response.data.client.abn);
        setIsInvestorAvailable(true);
        setClientUserId(response.data.client.user_id);
      } else {
        showToast(response.message, "error");
      }
    } catch (err) {
      showToast(err.message, "error");
    }
  };
  const viewBrekdown = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await viewBrekdownAPI();
        if (response.status == 200) {
          setPortfolioData(response.data.portfolio_breakdown);
          setportfolioDataAvailable(true);
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [investmentAmount] // Dependencies
  );
  const autoBalanceAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/investment-portfolio/create-rebalancing-orders/${investment_id}`;
    const bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };

  const postAutoBalanced = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await autoBalanceAPI();
        if (response.status == 200) {
          toastMessage = {
            message: "Rebalancing order created successfully",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [investment_id] // Dependencies
  );
  const saveTaaAsSaaAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/investment-portfolio/taa/save-as-saa/${investment_id}`;
    const bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const saveTaaAsSaa = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await saveTaaAsSaaAPI();
        if (response.status == 200) {
          if (response.data.already_saa == false) {
            getAllAllocations();
          }
          toastMessage = {
            message: response.message,
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [investment_id] // Dependencies
  );
  const resetBackToSaaAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/investment-portfolio/revert-back-to-last-saa/${investment_id}`;
    const bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const resetBackToSaa = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await resetBackToSaaAPI();
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: "success",
          };
          getAllAllocations();
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [investment_id] // Dependencies
  );
  const updateTaaAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const investment_stocks = [];
    stocks.forEach((profile) => {
      investment_stocks.push({
        category_id: profile.category,
        product_id: profile.product,
        stock_id: profile.stockId,
        allocated_percentage: Number(profile.allocation),
        stock_quantity: Math.round(profile.stockquantity),
        stock_unit_price: profile.unitPrice,
        stocks_market_price: profile.stockMarketPrice,
      });
    });
    const apiUrl = `${BASE_URL}/v1/investment-portfolio/perform-taa-allocation-change/${investment_id}`;
    const bodyData = {
      stock_allocations: investment_stocks,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const updateTAA = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updateTaaAPI();
        if (response.status == 200) {
          toastMessage = {
            message: "TAA updated successfully. Fetching latest details",
            type: "success",
          };
          getAllAllocations();
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [investment_id, stocks] // Dependencies
  );
  const updateDaaAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const investment_stocks = [];
    stocks.forEach((profile) => {
      investment_stocks.push({
        category_id: profile.category,
        product_id: profile.product,
        stock_id: profile.stockId,
        allocated_percentage: Number(profile.allocation),
        stock_quantity: Math.round(profile.stockquantity),
        stock_unit_price: profile.unitPrice,
        stocks_market_price: profile.stockMarketPrice,
      });
    });
    const apiUrl = `${BASE_URL}/v1/investment-portfolio/perform-daa-allocation-change/${investment_id}`;
    const bodyData = {
      stock_allocations: investment_stocks,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const updateDAA = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updateDaaAPI();
        if (response.status == 200) {
          toastMessage = {
            message: "DAA updated successfully. Fetching latest details",
            type: "success",
          };
          getDaaAllocations();
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [investment_id, stocks] // Dependencies
  );
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const handleViewApplications = async (e, investment_request_id) => {
    try {
      const response = await GetAPIcalls(
        `/v1/document/investment-portfolio/${investment_request_id}`
      );

      if (response.status == 200) {
        if (response.data == null) {
          setSelectedFiles([]);
          setShowPopup(false);
          showToast(response.message, "error");
          return;
        } else {
          setSelectedFiles(response.data);
          setShowPopup(true);
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setSelectedFiles([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const handleUserClick = (investmentID) => {
    setCurrentInvestmentId(investmentID);
    setisUserPopOpen(true);
  };
  const createNewStock = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/stock/create`;
    const bodyData = {
      name: stockName,
      asx_code: newStockCode,
      exchange: newStockExchange,
      volatility: volatility,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const LinkStockProduct = async (stockId) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/stock/products/add-stock`;
    const bodyData = {
      product_id: productType,
      stock_id: stockId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };

  useEffect(() => {
    if (investmentManagerId != null) {
      getWalletAccountsByManager();
    }
  }, [investmentManagerId]);
  useEffect(() => {
    if (clientUserId != null) {
      getWalletAccountsByClient();
    }
  }, [clientUserId]);
  const getWalletAccountsByManager = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/account/user/${investmentManagerId}/cash-accounts`
      );

      if (response.status == 200) {
        const InvestmentManagerAccountData = [];
        response.data.cash_accounts.forEach((profile) => {
          InvestmentManagerAccountData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setInvestmentManagerAccountData(InvestmentManagerAccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setInvestmentManagerAccountData([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getWalletAccountsByCustodian = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/account/user/${custodianId}/cash-accounts`
      );

      if (response.status == 200) {
        const InvestmentManagerAccountData = [];
        response.data.cash_accounts.forEach((profile) => {
          InvestmentManagerAccountData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setCustodianAccountData(InvestmentManagerAccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setCustodianAccountData([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const getWalletAccountsByPlatform = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/account/user/${platformId}/cash-accounts`
      );

      if (response.status == 200) {
        const SettlementAccountData = [];
        response.data.cash_accounts.forEach((profile) => {
          SettlementAccountData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setSettlementAccountData(SettlementAccountData);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setSettlementAccountData([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    if (platformId != null) {
      getWalletAccountsByPlatform();
    }
  }, [platformId]);
  useEffect(() => {
    if (custodianId != null) {
      getWalletAccountsByCustodian();
    }
  }, [custodianId]);
  const getUsers = async () => {
    try {
      const response = await GetAPIcalls(
        loggedInUserRole == "advisor"
          ? `/v1/advisor/user/customers`
          : "/v1/user/admin/users?customers=False"
      );

      if (response.status == 200) {
        const users = [];
        users.push({
          value: null,
          label: "N/A",
        });
        response.data.users.forEach((profile) => {
          users.push({
            value: profile.id,
            label: profile.first_name + " " + profile.last_name,
          });
        });
        setUsers(users);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };

  const UpdateInvestment = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/investment-portfolio/${investment_id}/basic-details`;
    const bodyData = {
      manager_id: investmentManagerId,
      manager_fee_percentage: Number(managerFeesUpdate),
      manager_sub_account_id: InvestmentManagerAccount,
      advisor_id: advisorId,
      advisor_fee_percentage: Number(advisorFeesUpdate),
      advisor_sub_account_id: advisorAccount,
      sub_advisor_id: subadvisorId,
      sub_advisor_sub_account_id: subAdvisorAccount,
      sub_advisor_fee_percentage: Number(subadvisorFeesUpdate),
      platform_id: platformId,
      platform_sub_account_id: platformAccount,
      platform_fee_percentage: Number(platformFeesUpdate),
      sma_fee_percentage: Number(smaFeesUpdate),
      asset_manager_id: assetManagerId,
      asset_manager_sub_account_id: assetManagerAccount,
      asset_manager_fee_percentage: Number(assetManagerFeesUpdate),
      custodian_id: custodianId,
      custodian_sub_account_id: custodianAccount,
      custodian_fee_percentage: Number(custodianFeesUpdate),
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const handleCreateInvestment = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await UpdateInvestment();
        if (response.status == 200) {
          setisNewChange(true);
          getInvestmentDetails();
          setIsOpen(false);
          togglePopupEdit(false);
          setisNewChangeFees(true);
          setisOpenEdit(false);
          toastMessage = {
            message: "Investment Portfolio Details Updated Successfully",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      managerFeesUpdate,
      advisorFeesUpdate,
      subadvisorFeesUpdate,
      platformFeesUpdate,
      smaFeesUpdate,
      assetManagerFeesUpdate,
      custodianFeesUpdate,
      assetManagerId,
      assetManagerAccount,
      custodianId,
      custodianAccount,
      subadvisorId,
      subAdvisorAccount,
      advisorId,
      advisorAccount,
      platformAccount,
      platformId,
      InvestmentManagerAccount,
      investmentManagerId,
    ] // Dependencies
  );
  //Graphs
  const filteredDataGraph = allocationGraphData.filter(
    (item) => item.allocation > 0
  );

  // Prepare labels and allocations for the donut chart
  let labels = filteredDataGraph.map((item) => item.name);
  let allocations = filteredDataGraph.map((item) => item.allocation);

  // Dynamic colors for each slice
  let colors = filteredDataGraph.map((item) => "#" + item.color_code);

  // Donut chart data configuration
  let donutData = {
    labels: labels, // Product names
    datasets: [
      {
        label: "Allocation (%)",
        data: allocations, // Allocation values
        backgroundColor: colors, // Dynamic colors
        borderWidth: 0,
      },
    ],
  };

  // Donut chart options
  const donutOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // Disable legend on the donut chart
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem) => {
            const value = tooltipItem.raw;
            return `${tooltipItem.label}: ${value}%`;
          },
        },
      },
    },
    cutout: "65%", // Creates the hole in the center for the donut chart
  };
  const getDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/investment-portfolio/get/${investment_id}/report-data`
      );
      if (response.status == 200) {
        setDetails(response.data);
        setfactsheetFileName(response.data.basic_details.name);
        setRawDatapdf(response.data.product_allocations);
        setRawDatahistorypdf(response.data.performance_graph.data);
        const stockPrices = response.data.performance_graph.data.map(
          (item) => item.value
        );
        // const combineIndices = response.data.combined_index_graph.map(
        //   (item) => item.value
        // );
        // setCombineIndexPdf(combineIndices)
        setStockpricesPdf(stockPrices);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
      }
      showToast(err.message, "error");
    } finally {
    }
  };
  const optionshide = {
    cutout: "70%", // Creates the donut hole
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
  };
  const dataset = {
    labels: rawDatapdf.map((item) => item.product.name), // Extract names
    datasets: [
      {
        data: rawDatapdf.map((item) => parseFloat(item.allocation)), // Convert allocation to numbers
        backgroundColor: rawDatapdf.map((item) => `#${item.product.color}`), // Ensure # prefix
        hoverBackgroundColor: rawDatapdf.map(
          (item) => `#${item.product.color}`
        ), // Same for hover
        borderWidth: 1,
      },
    ],
  };
  useEffect(() => {
    if (chartRef.current && dataset?.datasets?.length > 0) {
      setTimeout(() => {
        const chartInstance = chartRef.current;
        if (chartInstance?.toBase64Image) {
          setChartImage(chartInstance.toBase64Image());
        }
      }, 1000); // Ensures the chart fully renders before conversion
    }
  }, [dataset]);

  useEffect(() => {
    if (historyChartRef.current && dataLine?.datasets?.[0]?.data?.length > 0) {
      setTimeout(() => {
        const chartInstance = historyChartRef.current;
        if (chartInstance?.toBase64Image) {
          setHistoryChartImage(chartInstance.toBase64Image());
        }
      }, 1000); // Ensures chart is fully rendered
    }
  }, [dataLine]);
  return (
    <div className="">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="">
        <div className="pt-6 pr-4 flex-wrap pt-4  text-xs md:text-sm overflow-x-auto items-center">
          <div className="flex mb-2">
            <button
              onClick={() => setFilter("details")}
              className={`px-4 py-2 lg: rounded-l-xl border-r border-gray-100 ${
                filter === "details"
                  ? "bg-black text-white"
                  : "bg-white text-black"
              }`}
            >
              Details
            </button>
            <button
              onClick={() => {
                cleanAll();
                setFilter("investors");
              }}
              className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
                filter === "investors"
                  ? "bg-black text-white"
                  : "bg-white text-black"
              }`}
            >
              Investors
            </button>
            <button
              onClick={() => {
                cleanAll();
                setFilter("view");
              }}
              className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
                filter === "view"
                  ? "bg-black text-white"
                  : "bg-white text-black"
              }`}
            >
              View
            </button>
            <button
              onClick={() => {
                setFilter("trading");
                cleanAll();
                setTradingTab("rebalancing");
              }}
              className={`px-4 py-2 rounded-r-xl ${
                filter === "trading"
                  ? "bg-black text-white"
                  : "bg-white text-black"
              }`}
            >
              Trading
            </button>
          </div>
        </div>
        {filter == "view" && (
          <div className="lg:min-w-[78vw] lg:max-w-[80vw] pt-4 p-2">
            {isLoading ? (
              <div className="shimmer-container-list mb-4 ">
                {/* Creating 5 rows of shimmer effect */}
                {[...Array(2)].map((_, rowIndex) => (
                  <div key={rowIndex} className="shimmer-row-list">
                    {/* Creating 7 cells in each row for shimmer */}
                    {[...Array(2)].map((_, colIndex) => (
                      <div key={colIndex} className="shimmer-cell-list h-20">
                        <div className="shimmer-loader"></div>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            ) : (
              <div>
                <div className="w-full  p-4 bg-white rounded-lg shadow-lg">
                  <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
                    <h1 className="text-lg font-medium mb-2">
                      Fact Sheet:
                      <span className="text-[#888888]">
                        {" "}
                        Caprock Model Portfolio - {investmentProductName}
                      </span>
                    </h1>
                  </div>
                  <div className="overflow-x-auto border-b mb-4">
                    <table className="w-full h-full border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2 ">
                      {/* Table Header */}
                      <thead className="text-[#8C8C8C]  rounded-md mb-2 text-sm">
                        <tr className="border border-[#EDEDED]">
                          {secondheaders.map((header, index) => (
                            <th
                              key={header}
                              className={`
                            cursor-pointer w-40   font-medium px-4 py-2 mb-5  text-left
                            ${
                              index === 0
                                ? "border-t rounded-tl-md rounded-bl-md border-b border-l border-[#EDEDED]" // Center column: Top and Bottom border only
                                : ""
                            }
                                ${
                                  index === 1 || index === 2 || index === 3
                                    ? "border-t border-b  border-[#EDEDED]" // Center column: Top and Bottom border only
                                    : ""
                                }
                              ${
                                index === 4
                                  ? "border-t border-b rounded-tr-md rounded-br-md border-r  border-[#EDEDED]" // Center column: Top and Bottom border only
                                  : ""
                              }
                          `}
                            >
                              <div class="flex items-center">
                                <span>{header}</span>
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>

                      {/* Table Body */}
                      <tbody className="text-sm mt-6  font-medium text-black">
                        <tr className="mb-2 bg-[#F9F9F9]">
                          <td className="px-4 py-4 w-1/2 text-ellipsis  overflow-hidden whitespace-nowrap">
                            {investmentManagerNameView}
                          </td>

                          {/* Dropdown Button */}
                          <td className="px-4 py-4 relative">{dateCreated}</td>

                          <td className="px-4 py-4 text-ellipsis  overflow-hidden whitespace-nowrap">
                            {strategyTypeView}
                          </td>

                          <td className="px-4 py-4 text-left text-ellipsis  overflow-hidden whitespace-nowrap">
                            {growth}
                          </td>

                          <td className="px-4 py-4 text-left">{defensive}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="mt-6 mb-4 px-4">
                    <label
                      htmlFor="fundObjective"
                      className="block mb-1 text-md font-semibold text-black"
                    >
                      Fund Objective & Process
                    </label>
                    <div
                      dangerouslySetInnerHTML={{ __html: fundObjectives }}
                      className=" overflow-y-auto max-h-[400px] prose prose-sm sm:prose-base dark:prose-invert max-w-none text-sm leading-relaxed list-decimal list-inside"
                    ></div>
                    <style jsx>{`
                      ol {
                        list-style-type: decimal;
                        padding-left: 1.25rem;
                      }

                      ul {
                        list-style-type: disc;
                        padding-left: 1.25rem;
                      }
                    `}</style>
                  </div>
                </div>
                <div className="bg-white mt-6 p-6 px-8 shadow-md rounded-md">
                  {/* Header */}
                  <h2 className="text-lg font-semibold font-semibold mb-4">
                    Current Target Allocation
                  </h2>

                  {/* Table Header */}
                  <div className="overflow-x-auto ml-4 mb-4">
                    <table className=" w-full table-auto border-collapse">
                      <thead>
                        <tr className="pl-14">
                          <th className="py-2 px-6 text-sm font-medium text-[#8C8C8C] border-b">
                            No
                          </th>
                          <th className="py-2 px-4 text-sm w-30 font-medium text-[#8C8C8C] border-b">
                            Security (Code)
                          </th>
                          <th className="py-2 px-2 text-sm w-60 font-medium text-[#8C8C8C] border-b">
                            Name
                          </th>
                          <th className="py-2 pl-10  text-sm font-medium text-[#8C8C8C] border-b">
                            Allocation (%)
                          </th>
                          <th className="py-2 px-4 text-sm font-medium text-[#8C8C8C] border-b">
                            Market Price (AUD)
                          </th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                  {existingCategories.map((category, categoryIndex) => (
                    <div key={category.category.name} className="mb-6">
                      <div
                        className={`flex items-center flex-wrap justify-between p-4  rounded-md ${
                          category.category.name === "Defensive"
                            ? "bg-[#A9D4AB]"
                            : "bg-[#92C5EA]"
                        }`}
                      >
                        <div className="flex items-center flex-grow cursor-pointer">
                          <span className="text-sm md:text-lg font-bold text-black">
                            {category.category.name}
                          </span>
                        </div>
                      </div>

                      {/* Subcategories */}
                      <div
                        className={`ml-4 md:ml-6 border-l-2 ${
                          category.category.name === "Defensive"
                            ? "border-[#A9D4AB]"
                            : "border-[#92C5EA]"
                        }`}
                      >
                        {category.category.products.map(
                          (subcategory, subcategoryIndex) => (
                            <div
                              key={subcategory.name}
                              className="relative mb-2 pt-1 text-left"
                            >
                              {/* Subcategory Header */}
                              <div className="flex items-center justify-start  rounded-md cursor-pointer">
                                {category.category.name === "Defensive" ? (
                                  <img
                                    src="/green-arrow.svg"
                                    alt="Arrow"
                                    className="w-5 h-5"
                                  />
                                ) : (
                                  <img
                                    src="/arrow-hierarchy.svg"
                                    alt="Arrow"
                                    className="w-5 h-5"
                                  />
                                )}

                                <div
                                  className={`flex items-center justify-start p-4 w-full  rounded-md cursor-pointer ${
                                    category.category.name === "Defensive"
                                      ? "bg-[#C0E2C1]"
                                      : "bg-[#C6DFF1] "
                                  }`}
                                >
                                  <div
                                    key={category.category.name}
                                    className="flex items-center justify-between w-full space-x-6"
                                  >
                                    <div className="text-sm md:text-md w-1/3 mr-[1.5rem] font-bold text-black">
                                      {`${subcategoryIndex + 1}. ${
                                        subcategory.name
                                      }`}
                                    </div>

                                    <div className="text-sm md:text-md  w-50 font-bold text-black">
                                      <div className="relative">
                                        <input
                                          type="number"
                                          step="0.01"
                                          min="0"
                                          max="100"
                                          disabled={true}
                                          value={subcategory.allocation.toFixed(
                                            2
                                          )}
                                          className="lg:w-30 w-30 text-sm bg-white px-3 py-3 rounded-xl text-black bg-white border shadow-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black"
                                        />
                                        <span className="absolute inset-y-0 right-3 flex items-center text-sm font-medium text-[#8C8C8C]">
                                          %
                                        </span>
                                      </div>
                                    </div>
                                    <div className="text-sm md:text-md font-bold text-black"></div>
                                  </div>
                                  {/* <span className="text-sm md:text-lg w-60 mr-7 font-semibold text-black">
                              {`${subcategoryIndex + 1}. ${subcategory.name}`}
                            </span>

                            <div className="relative w-20 mr-0 md:ml-80  lg:ml-80 ">
                              <input
                                type="number"
                                step="0.01"
                                min="0"
                                max="100"
                                disabled={true}
                                value={subcategory.allocation.toFixed(2)}
                                className="lg:w-20 w-20 text-sm bg-white px-3 py-3 rounded-xl text-black bg-white border shadow-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black"
                              />
                              <span className="absolute inset-y-0 right-3 flex items-center text-sm font-medium text-[#8C8C8C]">
                                %
                              </span>
                            </div> */}
                                </div>
                              </div>
                              {/* Table of Items */}
                              <div
                                className="ml-6 pl-0"
                                style={{ height: "50%" }}
                              >
                                <div className="relative overflow-x-auto">
                                  <table className="min-w-full h-full table-fixed ">
                                    <tbody className="rounded-md">
                                      {subcategory.stocks.map(
                                        (item, itemIndex, filteredStocks) => (
                                          <tr
                                            key={itemIndex}
                                            className="text-left w-full mt-3  rounded-xl"
                                          >
                                            {itemIndex >= 0 && (
                                              <td
                                                className={`w-3 px-1 md:px-0 lg:px-1 relative
                                ${
                                  itemIndex === subcategory.stocks.length - 1
                                    ? ""
                                    : ""
                                }`}
                                              >
                                                {itemIndex ===
                                                subcategory.stocks.length -
                                                  1 ? (
                                                  <div
                                                    className={`absolute left-0 top-0  w-[2px]  ${
                                                      category.name ===
                                                      "Defensive"
                                                        ? "bg-[#C0E2C1]"
                                                        : "bg-[#C6DFF1]"
                                                    }`}
                                                    style={{
                                                      height: "60%", // 60% of the parent height
                                                    }}
                                                  ></div>
                                                ) : (
                                                  <div
                                                    className={`absolute left-0 top-0 h-full w-[2px] ${
                                                      category.category.name ===
                                                      "Defensive"
                                                        ? "bg-[#C0E2C1]"
                                                        : "bg-[#C6DFF1]"
                                                    }`}
                                                  ></div>
                                                )}
                                                {category.category.name ===
                                                "Defensive" ? (
                                                  <img
                                                    src="/green-arrow.svg"
                                                    alt="Arrow"
                                                    className="absolute left-0 w-3 h-3 mx-auto"
                                                  />
                                                ) : (
                                                  <img
                                                    src="/arrow-hierarchy.svg"
                                                    alt="Arrow"
                                                    className="absolute left-0 w-3 h-3 mx-auto"
                                                  />
                                                )}
                                              </td>
                                            )}
                                            <td
                                              className={`py-2 h-full w-10 py-2 border-t-4 border-white rounded-l-lg mt-2 px-2 ${
                                                category.category.name ===
                                                "Defensive"
                                                  ? "bg-[#E7F5E8]"
                                                  : "bg-[#E6F3FC]"
                                              }`}
                                            >
                                              {`${String.fromCharCode(
                                                97 + itemIndex
                                              )}`}
                                              . {/* Item Number (a, b, c) */}
                                            </td>
                                            <td
                                              className={`pt-2 w-20 border-t-4 border-white py-2 px-4 ${
                                                category.category.name ===
                                                "Defensive"
                                                  ? "bg-[#E7F5E8]"
                                                  : "bg-[#E6F3FC]"
                                              }`}
                                            >
                                              <div className="">
                                                <button className="flex rounded-xl justify-between  w-20 px-2 py-2 text-left text-sm font-medium bg-white border rounded-md shadow-sm hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-black">
                                                  {item.asx_code}
                                                </button>
                                              </div>
                                            </td>
                                            <td
                                              className={`py-2 border-t-4 border-white px-4 w-2/3 ${
                                                category.category.name ===
                                                "Defensive"
                                                  ? "bg-[#E7F5E8]"
                                                  : "bg-[#E6F3FC]"
                                              }`}
                                            >
                                              <span className="block md:break-words text-ellipsis  overflow-hidden whitespace-nowrap break-normal md:truncate lg:whitespace-normal w-full">
                                                {item.name}
                                              </span>
                                            </td>
                                            <td
                                              className={`py-2 border-t-4 border-white relative w-50 px-4 ${
                                                category.category.name ===
                                                "Defensive"
                                                  ? "bg-[#E7F5E8]"
                                                  : "bg-[#E6F3FC]"
                                              }`}
                                            >
                                              <div className="relative">
                                                <input
                                                  type="number"
                                                  step="0.01"
                                                  min="0"
                                                  max="100"
                                                  value={item.allocation}
                                                  onChange={(e) =>
                                                    handleStockAllocationChange(
                                                      item.id,
                                                      e.target.value,
                                                      item.stockId
                                                    )
                                                  }
                                                  onBlur={(e) => {
                                                    const value = parseFloat(
                                                      e.target.value
                                                    );
                                                    if (!isNaN(value)) {
                                                      handleStockAllocationChange(
                                                        item.id,
                                                        value.toFixed(2),
                                                        item.stockId
                                                      );
                                                    }
                                                  }}
                                                  className="lg:w-20 w-20 text-sm bg-white px-3 py-3 rounded-xl text-black bg-white border shadow-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black"
                                                />
                                                <span className="absolute inset-y-0 right-3 flex items-center text-sm font-medium text-[#8C8C8C]">
                                                  %
                                                </span>
                                              </div>
                                            </td>
                                            <td
                                              className={`py-4 border-t-4 border-white rounded-r-lg px-4 w-full font-semibold text-md text-black ${
                                                category.category.name ===
                                                "Defensive"
                                                  ? "bg-[#E7F5E8]"
                                                  : "bg-[#E6F3FC]"
                                              }`}
                                            >
                                              <span className="">
                                                {item.market_value
                                                  ? Number(
                                                      item.market_value
                                                    ).toFixed(2)
                                                  : "0"}
                                              </span>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                      <div
                        className={`flex items-center p-4 mt-4 border rounded-md ${
                          category.category.name === "Defensive"
                            ? "border-[#A9D4AB]"
                            : "border-[#92C5EA]"
                        }`}
                      >
                        <div
                          key={category.category.name}
                          className="flex items-center justify-between w-full space-x-4"
                        >
                          <div className="text-sm md:text-md font-bold text-black">
                            SUB-TOTAL {category.category.name}
                          </div>
                          <div className="text-sm md:text-md font-bold text-black"></div>

                          <div className="text-sm md:text-md  font-bold text-black">
                            {category.category.allocation.toFixed(2)} %
                          </div>
                          <div className="text-sm md:text-md font-bold text-black"></div>
                        </div>
                      </div>
                    </div>
                  ))}
                  <div className="flex items-center p-4 border rounded-md border-black">
                    <div className="flex items-center justify-between w-full space-x-4">
                      <div className="text-sm md:text-md font-bold text-black">
                        TOTAL PORTFOLIO
                      </div>
                      <div className="text-sm md:text-md font-bold text-black"></div>

                      <div className="text-sm md:text-md font-bold text-black">
                        100%
                      </div>
                      <div className="text-sm md:text-md font-bold text-black"></div>
                    </div>
                  </div>
                </div>
                <div className="bg-white mt-6 p-6 px-8 shadow-md rounded-md">
                  {/* Header */}
                  <h2 className="text-lg font-semibold font-semibold mb-4">
                    Caprock Funds Management {riskProfile}
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <div className="space-y-4">
                      <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-3 gap-4 text-sm">
                        {allocationGraphData.map((item, index) => (
                          <div
                            key={item.name}
                            className="flex flex-col items-start break-words whitespace-normal"
                          >
                            {/* Product Name */}
                            <span className="font-medium text-sm text-[#A6A6A6] w-full break-words">
                              {item.name}
                            </span>

                            {/* Allocation Percentage */}
                            <span
                              className="text-md font-medium mt-1 break-words"
                              style={{ color: `#${item.color_code}` }}
                            >
                              {item.allocation}%
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Donut Chart */}
                    <div className="flex justify-end">
                      <div className="w-full md:w-2/3 lg:w-1/2">
                        <Doughnut data={donutData} options={donutOptions} />
                      </div>
                    </div>
                  </div>
                  <div className="py-6 px-4 bg-white">
                    <div className="mb-4 flex flex-wrap justify-between items-center">
                      <span>
                        <h3 className="text-lg font-semibold text-gray-800 w-full md:w-auto">
                          Historical Performance
                        </h3>

                        <p className="text-sm font-normal text-[#868686] w-full md:w-auto">
                          Caprock {riskProfile}
                        </p>
                      </span>{" "}
                      <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-2  md:mt-0">
                        {/* Generate Graph Button */}
                        <button
                          onClick={() => {
                            setLoading(true);
                            handleExcelHistoricalPerformance();
                          }}
                          className="bg-white text-black pl-2 pr-6 py-1 h-10 whitespace-nowrap border-black border rounded-full flex items-center text-sm w-full md:w-full"
                        >
                          <img
                            src="/document-download.svg"
                            alt="document-download"
                            className="w-4 h-4 mr-2"
                          />
                          Export Historical Data
                        </button>
                      </div>
                    </div>

                    <div className=" flex w-full justify-between flex-wrap">
                      <div className="pr-4 flex-wrap items-center">
                        <div className="flex">
                          {["10Y", "5Y", "1Y", "3M", "1M"].map(
                            (filter, index) => (
                              <button
                                key={filter}
                                className={`px-3 py-1 shadow-md ${
                                  filter === "1M" ? "rounded-r-xl" : ""
                                }
            ${filter === "10Y" ? "rounded-l-xl" : ""}
             
               ${
                 selectedFilter === filter
                   ? "bg-black text-white"
                   : "bg-white text-black"
               }`}
                                onClick={() => setSelectedFilter(filter)}
                              >
                                {filter}
                              </button>
                            )
                          )}
                        </div>
                      </div>
                      {/* Flex container for image and performance text */}
                      <div className="flex flex-row mt-8 md:mt-0   md:flex-row items-start ml-auto space-x-0 space-y-0">
                        <div className="flex items-center">
                          <img src="/blue-taa.svg" alt="taa" className="mr-1" />
                          <span className="text-xs text-black">
                            Total Price
                          </span>
                        </div>
                        <div className="flex items-center pl-2">
                          <img
                            src="/red-saa.svg"
                            alt="income-orange"
                            className="mr-1"
                          />
                          <span className="text-xs text-black">
                            Combined Indices
                          </span>
                        </div>
                        <div className="flex items-center pl-2">
                          <img
                            src="/saa-icon.svg"
                            alt="income-orange"
                            className="mr-1"
                          />
                          <span className="text-xs text-black">SAA Update</span>
                        </div>
                      </div>
                    </div>
                    {isLoadingGraph ? (
                      <div className="shimmer-container-list mb-4 ">
                        {/* Creating 5 rows of shimmer effect */}
                        {[...Array(2)].map((_, rowIndex) => (
                          <div key={rowIndex} className="shimmer-row-list">
                            {/* Creating 7 cells in each row for shimmer */}
                            {[...Array(2)].map((_, colIndex) => (
                              <div
                                key={colIndex}
                                className="shimmer-cell-list h-20"
                              >
                                <div className="shimmer-loader"></div>
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div style={{ width: "100%", height: "400px" }}>
                        <Line data={dataLine} options={optionsLine} />
                      </div>
                    )}
                  </div>
                </div>
                <div className="w-full p-6  mt-6 bg-white px-8  rounded-md shadow-sm">
                  <div className="space-y-4 pt-4">
                    {/* Historical Performance Note */}
                    <div>
                      <label
                        htmlFor="historical-performance"
                        className="block text-sm font-medium text-[#A6A6A6]"
                      >
                        Past Performance
                      </label>
                      <div className="w-full mt-2 p-3 text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                        {pastPerformance}
                      </div>
                    </div>

                    {/* Disclaimer */}
                    <div>
                      <label
                        htmlFor="disclaimer"
                        className="block text-sm font-medium text-[#A6A6A6]"
                      >
                        Disclaimer
                      </label>
                      <div className="w-full text-sm mt-2 p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                        {disclaimer}
                      </div>
                    </div>

                    {/* Copyright */}
                    <div>
                      <label
                        htmlFor="copyright"
                        className="block text-sm font-medium text-[#A6A6A6]"
                      >
                        Copyright
                      </label>
                      <div className="w-full mt-2 text-sm p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                        {copyright}{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {filter == "view" && details != null && (
          <div className=" pdf-only">
            <div className="fixed -top-[9999px] -left-[9999px] w-[800px] h-[200px] pointer-events-none -z-10">
              <Line
                ref={historyChartRef}
                data={dataLine}
                options={optionsLine}
              />
            </div>
            <div className="w-60 h-60 pdf-only">
              <Doughnut
                ref={chartRef}
                data={dataset}
                options={optionshide}
                // plugins={[plugin]} // Ensures percentages are displayed in the donut center
              />
            </div>
          </div>
        )}
        {filter == "investors" && rawDatapdf.length > 0 && (
          <div className=" pdf-only">
            <div className="w-60 h-60 pdf-only">
              <Doughnut
                ref={chartRef}
                data={dataset}
                options={optionshide}
                // plugins={[plugin]} // Ensures percentages are displayed in the donut center
              />
            </div>
          </div>
        )}

        {filter == "trading" && (
          <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
            {/* Top Navigation */}
            <div className="bg-white p-6 shadow rounded-lg ">
              <div className="flex flex-wrap justify-center md:justify-start items-center space-x-2 md:space-x-4 mb-6 text-sm md:text-base">
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    cleanAll();
                    setTradingTab("rebalancing");
                  }}
                  className={`cursor-pointer px-2 pb-1 font-medium transition-all duration-200 ${
                    tradingTab === "rebalancing"
                      ? "border-black text-black border-b-2"
                      : "text-gray-500 hover:text-black"
                  }`}
                >
                  Rebalancing
                </span>
                <span className="hidden md:block text-[#B2B2B2]">|</span>

                <span
                  onClick={(e) => {
                    {
                      e.preventDefault();
                      cleanAll();
                      setTradingTab("tta");
                      setComponentName("saa-taa");
                    }
                  }}
                  className={`cursor-pointer px-2 pb-1 font-medium transition-all duration-200 ${
                    tradingTab === "tta"
                      ? "border-black text-black border-b-2"
                      : "text-gray-500 hover:text-black"
                  }`}
                >
                  Tactical Asset Allocation (TAA)
                </span>
                <span className="hidden md:block text-[#B2B2B2]">|</span>

                <span
                  onClick={(e) => {
                    e.preventDefault();
                    cleanAll();
                    setTradingTab("dda");
                    setComponentName("saa-taa");
                  }}
                  className={`cursor-pointer px-2 pb-1 font-medium transition-all duration-200 ${
                    tradingTab === "dda"
                      ? "border-black text-black border-b-2"
                      : "text-gray-500 hover:text-black"
                  }`}
                >
                  Dynamic Asset Allocation (DAA)
                </span>
              </div>

              {tradingTab == "tta" && (
                <div className="pt-4 p-2">
                  {isLoading || isAllLoaded ? (
                    <div className="shimmer-container-list mb-4 ">
                      {/* Creating 5 rows of shimmer effect */}
                      {[...Array(2)].map((_, rowIndex) => (
                        <div key={rowIndex} className="shimmer-row-list">
                          {/* Creating 7 cells in each row for shimmer */}
                          {[...Array(2)].map((_, colIndex) => (
                            <div
                              key={colIndex}
                              className="shimmer-cell-list h-20"
                            >
                              <div className="shimmer-loader"></div>
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="">
                      <div className="flex items-center justify-between border-b border-colour-custom pt-2 px-4">
                        <h1 className="text-lg font-medium mb-2 text-black text-center">
                          Current Target Allocation
                        </h1>
                        {/* <img
                          onClick={togglePopupEditStock}
                          src="/edit-details.svg" // Replace with the actual path to your edit icon
                          alt="Edit Icon"
                          className="w-4 h-4 cursor-pointer"
                        /> */}
                      </div>
                      <div className="bg-white mt-2 px-2 py-4  ">
                        {/* Table Header */}
                        <div className="overflow-x-auto ml-4 mb-4">
                          <table className=" w-full md:table-fixed border-collapse">
                            <thead>
                              <tr className="pl-14">
                                <th className="py-2 px-6 text-sm font-medium text-[#8C8C8C] border-b">
                                  No
                                </th>
                                <th className="py-2 px-4 text-sm w-30 font-medium text-[#8C8C8C] border-b">
                                  Security (Code)
                                </th>
                                <th className="py-2 px-2 text-sm text-left custom-width font-medium text-[#8C8C8C] border-b">
                                  Name
                                </th>
                                <th className="py-2 px-4 text-sm md:w-30 font-medium text-[#8C8C8C] border-b">
                                  SAA (%)
                                </th>
                                <th className="py-2 px-4  md:text-left  text-sm md:w-30 font-medium text-[#8C8C8C] border-b">
                                  Current w(%)
                                </th>
                                <th className="py-2 px-4 text-sm md:w-30 font-medium text-[#8C8C8C] border-b">
                                  TAA (%)
                                </th>
                                <th className="py-2 md:text-left  md:w-30   text-sm font-medium text-[#8C8C8C] border-b">
                                  Target(%)
                                </th>
                                <th className="py-2 px-4 md:text-left  md:w-30  text-sm font-medium text-[#8C8C8C] border-b">
                                  Market Price (AUD)
                                </th>
                                <th className="py-2 px-4 text-sm font-medium text-[#8C8C8C] border-b"></th>
                              </tr>
                            </thead>
                          </table>
                        </div>
                        <div className="max-h-[90vh]  overflow-y-auto pr-4">
                          {/* Categories */}
                          {existingCategories.map((category, categoryIndex) => (
                            <div key={category.id} className="mb-6">
                              <div
                                className={`flex items-center flex-wrap justify-between p-4  rounded-md ${
                                  category.id === 2
                                    ? "bg-[#A9D4AB]"
                                    : "bg-[#92C5EA]"
                                }`}
                              >
                                <div
                                  className="flex items-center flex-grow cursor-pointer"
                                  onClick={() =>
                                    toggleExpandCategory(category.id)
                                  }
                                >
                                  <span className="text-sm md:text-lg font-bold text-black">
                                    {category.name}{" "}
                                    <span className="font-medium">
                                      {category.id === 2
                                        ? `(${defensive.toFixed(2)}%)`
                                        : `(${growth.toFixed(2)}%)`}
                                    </span>
                                  </span>
                                </div>
                                <div className="flex items-center gap-2">
                                  <span
                                    className="cursor-pointer lg:ml-4 ml-0"
                                    onClick={() =>
                                      toggleExpandCategory(category.id)
                                    }
                                  >
                                    {expandedCategory[category.id] ? (
                                      <img
                                        src="/export-arrow.svg"
                                        alt="Success Icon"
                                        className="h-4 w-4"
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </span>
                                </div>
                              </div>

                              {/* Subcategories */}
                              <div
                                className={`ml-4 md:ml-6 border-l-2 ${
                                  category.id === 2
                                    ? "border-[#A9D4AB]"
                                    : "border-[#92C5EA]"
                                }`}
                              >
                                {category.products.map(
                                  (subcategory, subcategoryIndex) => (
                                    <div
                                      key={subcategory.name}
                                      className="relative mb-2 pt-2 text-left"
                                    >
                                      {/* Subcategory Header */}
                                      <div className="flex items-center justify-start  rounded-md cursor-pointer">
                                        {category.id === 2 ? (
                                          <img
                                            src="/green-arrow.svg"
                                            alt="Arrow"
                                            className="w-5 h-5"
                                          />
                                        ) : (
                                          <img
                                            src="/arrow-hierarchy.svg"
                                            alt="Arrow"
                                            className="w-5 h-5"
                                          />
                                        )}

                                        <div
                                          className={`flex flex-col md:flex-row items-center justify-between p-4 w-full rounded-md cursor-pointer ${
                                            category.id === 2
                                              ? "bg-[#C0E2C1]"
                                              : "bg-[#C6DFF1]"
                                          }`}
                                        >
                                          {/* Left Side: Subcategory Name */}
                                          <div className="flex flex-col md:flex-row items-center w-full space-y-2 md:space-y-0 md:space-x-4">
                                            <div className="text-sm md:text-lg w-full md:w-1/3 md:mr-[2vw] custom-margin font-bold text-black text-center md:text-left">
                                              {`${subcategoryIndex + 1}. ${
                                                subcategory.name
                                              }`}
                                            </div>

                                            {/* Middle: 30 30 30 Spans + Input */}
                                            <div className="flex items-center justify-center md:justify-end space-x-2 md:space-x-10">
                                              {/* Allocation Input (kept close to spans) */}
                                              {productCodes
                                                .filter(
                                                  (item) =>
                                                    subcategory.id ===
                                                    item.productId
                                                )
                                                .map((item) => (
                                                  <div className="flex items-center justify-center md:justify-end space-x-2 md:space-x-10">
                                                    <span className="text-xs md:text-sm">
                                                      {Number(
                                                        item.saaPercent
                                                      ).toFixed(2)}
                                                      %
                                                    </span>
                                                    <span className="text-xs md:text-sm">
                                                      {Number(
                                                        item.taaPercent
                                                      ).toFixed(2)}
                                                      %
                                                    </span>
                                                    <span className="text-xs md:text-sm">
                                                      {Number(
                                                        item.taaPercent
                                                      ).toFixed(2)}
                                                      %
                                                    </span>
                                                    <div className="relative w-[60px] md:w-[90px]">
                                                      <input
                                                        type="number"
                                                        step="0.01"
                                                        min="0"
                                                        max="100"
                                                        value={item.allocation}
                                                        onChange={(e) =>
                                                          handleProductAllocationChange(
                                                            item.productId,
                                                            e.target.value,
                                                            category.id,
                                                            false
                                                          )
                                                        }
                                                        onBlur={(e) => {
                                                          const value =
                                                            parseFloat(
                                                              e.target.value
                                                            );

                                                          if (!isNaN(value)) {
                                                            handleProductAllocationChange(
                                                              item.productId,
                                                              value.toFixed(2),
                                                              category.id,
                                                              false
                                                            );
                                                          }
                                                        }}
                                                        className={`w-full text-sm px-2 py-1 md:py-2 rounded-lg  shadow-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black ${
                                                          errors[subcategory.id]
                                                            ? "border-[#FF5050] border-2"
                                                            : "border"
                                                        }`}
                                                      />
                                                      <span className="absolute inset-y-0 right-2 flex items-center text-xs font-medium text-gray-500">
                                                        %
                                                      </span>
                                                    </div>
                                                  </div>
                                                ))}
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      {errors[subcategory.id] && (
                                        <div>
                                          {productCodes
                                            .filter(
                                              (item) =>
                                                item.productId !== 10 &&
                                                subcategory.id ===
                                                  item.productId
                                            )
                                            .map(
                                              (
                                                item,
                                                itemIndex,
                                                filteredStocks
                                              ) => (
                                                <div className=" flex ml-5 mt-2 text-center items-center justify-center  rounded-md px-4 py-2 text-red-500 bg-red-100 border border-red-500">
                                                  <div className="flex  items-center">
                                                    <img
                                                      src="/danger.svg"
                                                      alt="Arrow"
                                                      className=" left-0 w-5 h-5 mr-2"
                                                    />{" "}
                                                    Product Sub Allocation
                                                    should be equal to{" "}
                                                    {Number(
                                                      item.allocation
                                                    ).toFixed(2)}
                                                    %
                                                  </div>
                                                </div>
                                              )
                                            )}
                                        </div>
                                      )}
                                      {twoPercentErrors[subcategory.id] && (
                                        <div>
                                          {productCodes
                                            .filter(
                                              (item) =>
                                                subcategory.id ===
                                                item.productId
                                            )
                                            .map(
                                              (
                                                item,
                                                itemIndex,
                                                filteredStocks
                                              ) => (
                                                <div className=" flex ml-5 mt-2 text-center items-center justify-center  rounded-md px-4 py-2 text-red-500 bg-red-100 border border-red-500">
                                                  <div className="flex  items-center">
                                                    <img
                                                      src="/danger.svg"
                                                      alt="Arrow"
                                                      className=" left-0 w-5 h-5 mr-2"
                                                    />{" "}
                                                    Australian Cash should be
                                                    atleast 2%
                                                  </div>
                                                </div>
                                              )
                                            )}
                                        </div>
                                      )}
                                      {/* Table of Items */}
                                      <div
                                        className="ml-6 pl-0"
                                        style={{ height: "50%" }}
                                      >
                                        <div className="relative overflow-x-auto">
                                          <table className="min-w-full h-full table-auto border-collapse">
                                            <tbody className="rounded-md">
                                              {stocks
                                                .filter(
                                                  (item) => item.product !== 9
                                                )
                                                .filter(
                                                  (item) =>
                                                    subcategory.id ===
                                                    item.product
                                                )
                                                .map(
                                                  (
                                                    item,
                                                    itemIndex,
                                                    filteredStocks
                                                  ) => (
                                                    <tr
                                                      key={itemIndex}
                                                      className="text-left w-full mt-3  rounded-xl"
                                                    >
                                                      {itemIndex >= 0 && (
                                                        <td
                                                          className={`w-3 px-1 md:px-0 lg:px-1 relative
                                ${
                                  itemIndex === subcategory.stocks.length - 1
                                    ? ""
                                    : ""
                                }`}
                                                        >
                                                          {itemIndex ===
                                                          filteredStocks.length -
                                                            1 ? (
                                                            <div
                                                              className={`absolute left-0 top-0  w-[2px]  ${
                                                                category.id ===
                                                                2
                                                                  ? "bg-[#C0E2C1]"
                                                                  : "bg-[#C6DFF1]"
                                                              }`}
                                                              style={{
                                                                height: "60%", // 60% of the parent height
                                                              }}
                                                            ></div>
                                                          ) : (
                                                            <div
                                                              className={`absolute left-0 top-0 h-full w-[2px] ${
                                                                category.id ===
                                                                2
                                                                  ? "bg-[#C0E2C1]"
                                                                  : "bg-[#C6DFF1]"
                                                              }`}
                                                            ></div>
                                                          )}
                                                          {category.id === 2 ? (
                                                            <img
                                                              src="/green-arrow.svg"
                                                              alt="Arrow"
                                                              className="absolute left-0 w-3 h-3 mx-auto"
                                                            />
                                                          ) : (
                                                            <img
                                                              src="/arrow-hierarchy.svg"
                                                              alt="Arrow"
                                                              className="absolute left-0 w-3 h-3 mx-auto"
                                                            />
                                                          )}
                                                        </td>
                                                      )}
                                                      <div className="mt-2">
                                                        <td
                                                          className={`py-2 h-full w-40 py-2 rounded-l-lg mt-2 px-2 ${
                                                            category.id === 2
                                                              ? "bg-[#E7F5E8]"
                                                              : "bg-[#E6F3FC]"
                                                          }`}
                                                        >
                                                          {`${String.fromCharCode(
                                                            97 + itemIndex
                                                          )}`}
                                                          .{" "}
                                                          {/* Item Number (a, b, c) */}
                                                        </td>
                                                        <td
                                                          className={`pt-2 relative w-50 py-2 px-4 ${
                                                            category.id === 2
                                                              ? "bg-[#E7F5E8]"
                                                              : "bg-[#E6F3FC]"
                                                          }`}
                                                        >
                                                          <button
                                                            ref={(el) =>
                                                              (buttonRefs.current[
                                                                `${subcategory.id}-${itemIndex}`
                                                              ] = el)
                                                            } // Assign unique ref
                                                            onClick={() => {
                                                              toggleDropdown(
                                                                itemIndex,
                                                                subcategory.id
                                                              );
                                                            }}
                                                            className="px-4 py-2 text-sm font-medium rounded-xl   bg-white border flex items-center justify-start gap-2 focus:outline-none focus:ring-2 focus:ring-black"
                                                          >
                                                            <span className="w-20">
                                                              {item.code}
                                                            </span>
                                                            <img
                                                              src="/cross-grey.svg" // Replace with the correct path to your cross image
                                                              alt="Close"
                                                              className="w-2 h-2 ml-4"
                                                            />
                                                          </button>
                                                          <DropdownTest
                                                            isOpen={
                                                              dropdownOpen[
                                                                `${subcategory.id}-${itemIndex}`
                                                              ]
                                                            }
                                                            buttonRef={
                                                              buttonRefs
                                                                .current[
                                                                `${subcategory.id}-${itemIndex}`
                                                              ]
                                                            } // Pass unique ref to the dropdown
                                                          >
                                                            <div className="absolute z-50 mt-2 w-30 bg-white rounded-md shadow-lg">
                                                              <div className="p-2">
                                                                <input
                                                                  type="text"
                                                                  value={
                                                                    searchTerm
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    setSearchTerm(
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                  placeholder="Search..."
                                                                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                                                                />
                                                              </div>
                                                              <div className="p-4  w-40 overflow-y-auto max-h-40">
                                                                <ul className="space-y-2">
                                                                  {getRelevantSecurityCodes(
                                                                    category.id,
                                                                    subcategory.id
                                                                  )
                                                                    .filter(
                                                                      (
                                                                        option
                                                                      ) =>
                                                                        option.stock.asx_code
                                                                          .toLowerCase()
                                                                          .includes(
                                                                            searchTerm.toLowerCase()
                                                                          )
                                                                    )
                                                                    .map(
                                                                      (
                                                                        option,
                                                                        optionIndex
                                                                      ) => (
                                                                        <li
                                                                          onClick={() => {
                                                                            handleCodeChange(
                                                                              itemIndex,
                                                                              subcategoryIndex,
                                                                              categoryIndex,
                                                                              option
                                                                                .stock
                                                                                .asx_code
                                                                            );
                                                                            setDropdownOpen(
                                                                              (
                                                                                prevState
                                                                              ) => ({
                                                                                ...prevState,
                                                                                [`${subcategory.id}-${itemIndex}`]:
                                                                                  !prevState[
                                                                                    `${subcategory.id}-${itemIndex}`
                                                                                  ],
                                                                              })
                                                                            );
                                                                            setSearchTerm(
                                                                              ""
                                                                            );
                                                                            setisAnyDropdownOpen(
                                                                              !isAnyDropdownOpen
                                                                            );
                                                                          }}
                                                                          key={
                                                                            optionIndex
                                                                          }
                                                                          className="flex justify-between items-center  px-4 py-2 text-sm text-black rounded-lg hover:bg-black hover:text-white  cursor-pointer"
                                                                        >
                                                                          {
                                                                            option
                                                                              .stock
                                                                              .asx_code
                                                                          }
                                                                        </li>
                                                                      )
                                                                    )}
                                                                </ul>
                                                              </div>
                                                            </div>
                                                          </DropdownTest>
                                                        </td>
                                                        <td
                                                          className={`py-2 px-4 w-3/4  ${
                                                            category.id === 2
                                                              ? "bg-[#E7F5E8]"
                                                              : "bg-[#E6F3FC]"
                                                          }`}
                                                        >
                                                          <span className="block md:break-words text-ellipsis  overflow-hidden whitespace-nowrap break-normal md:truncate lg:whitespace-normal w-full">
                                                            {item.name}
                                                          </span>
                                                        </td>
                                                        <td
                                                          className={`py-2 px-4  ${
                                                            category.id === 2
                                                              ? "bg-[#E7F5E8]"
                                                              : "bg-[#E6F3FC]"
                                                          }`}
                                                        >
                                                          <span className="text-sm">
                                                            {Number(
                                                              item.saaPercent
                                                            ).toFixed(2)}
                                                            %
                                                          </span>
                                                        </td>
                                                        <td
                                                          className={`py-2 px-4  ${
                                                            category.id === 2
                                                              ? "bg-[#E7F5E8]"
                                                              : "bg-[#E6F3FC]"
                                                          }`}
                                                        >
                                                          <span className="text-sm pl-4">
                                                            {Number(
                                                              item.taaPercent
                                                            ).toFixed(2)}
                                                            %
                                                          </span>
                                                        </td>
                                                        <td
                                                          className={`py-2 px-4  ${
                                                            category.id === 2
                                                              ? "bg-[#E7F5E8]"
                                                              : "bg-[#E6F3FC]"
                                                          }`}
                                                        >
                                                          <span className="text-sm pl-10">
                                                            {Number(
                                                              item.taaPercent
                                                            ).toFixed(2)}
                                                            %
                                                          </span>
                                                        </td>
                                                        <td
                                                          className={`py-2 relative w-50 px-4 ${
                                                            category.id === 2
                                                              ? "bg-[#E7F5E8]"
                                                              : "bg-[#E6F3FC]"
                                                          }`}
                                                        >
                                                          <div className="relative ml-2">
                                                            <input
                                                              type="number"
                                                              step="0.01"
                                                              min="0"
                                                              max="100"
                                                              disabled={
                                                                item.product ==
                                                                10
                                                                  ? true
                                                                  : false
                                                              }
                                                              value={
                                                                item.allocation
                                                              }
                                                              onChange={(e) =>
                                                                handleStockAllocationChange(
                                                                  item.id,
                                                                  e.target
                                                                    .value,
                                                                  item.stockId
                                                                )
                                                              }
                                                              onBlur={(e) => {
                                                                const value =
                                                                  parseFloat(
                                                                    e.target
                                                                      .value
                                                                  );
                                                                if (
                                                                  !isNaN(value)
                                                                ) {
                                                                  handleStockAllocationChange(
                                                                    item.id,
                                                                    value.toFixed(
                                                                      2
                                                                    ),
                                                                    item.stockId
                                                                  );
                                                                }
                                                              }}
                                                              className="lg:w-20 w-20 text-sm bg-white px-3 py-3 rounded-xl text-black bg-white border shadow-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black"
                                                            />
                                                            <span className="absolute inset-y-0 right-3 flex items-center text-sm font-medium text-[#8C8C8C]">
                                                              %
                                                            </span>
                                                          </div>
                                                        </td>
                                                        <td
                                                          className={`py-4 px-4 w-3/4 font-semibold text-md text-black ${
                                                            category.id === 2
                                                              ? "bg-[#E7F5E8]"
                                                              : "bg-[#E6F3FC]"
                                                          }`}
                                                        >
                                                          <span className="ml-10 pl-6">
                                                            {" "}
                                                            {Number(
                                                              item.stockMarketPrice
                                                            )
                                                              .toFixed(2)
                                                              .toString()
                                                              .replace(
                                                                /\B(?=(\d{3})+(?!\d))/g,
                                                                ","
                                                              )}
                                                          </span>
                                                        </td>
                                                        <td
                                                          className={`py-4 px-4 w-3/4 rounded-r-lg ${
                                                            category.id === 2
                                                              ? "bg-[#E7F5E8]"
                                                              : "bg-[#E6F3FC]"
                                                          }`}
                                                        >
                                                          {/* Delete Button */}
                                                          <button
                                                            className="text-black text-bold border-2 border-black rounded-full px-2 mr-4 py-0 hover:text-black"
                                                            onClick={(e) => {
                                                              e.stopPropagation(); // Prevent triggering the dropdown toggle
                                                              deleteStock(
                                                                item.id,
                                                                item.stockId
                                                              );
                                                            }}
                                                          >
                                                            &times;{" "}
                                                          </button>
                                                        </td>
                                                      </div>
                                                    </tr>
                                                  )
                                                )}
                                              {subcategory.id != 9 && (
                                                <tr className="text-left rounded-xl">
                                                  <td
                                                    colSpan="8"
                                                    className="py-2 w-full pl-3"
                                                  >
                                                    <div
                                                      className={`flex justify-center py-2 rounded-lg bg-[#F8FCFF] border-2 border-dashed  items-center ${
                                                        category.id === 2
                                                          ? "text-[#A9D4AB]"
                                                          : "text-[#92C5EA]"
                                                      }`}
                                                    >
                                                      <button
                                                        className="flex items-center gap-2 px-6 py-2 bg-white text-[#92C5EA] rounded-lg shadow-sm  focus:outline-none focus:ring-2 focus:ring-[#BBDBF2]"
                                                        onClick={() =>
                                                          handleAddItem(
                                                            subcategory.id,
                                                            category.id,
                                                            subcategory.stocks,
                                                            subcategoryIndex
                                                          )
                                                        }
                                                      >
                                                        {category.id === 3 ? (
                                                          <img
                                                            src="/add-green.svg"
                                                            alt="Add Icon"
                                                            className="w-5 h-5"
                                                          />
                                                        ) : (
                                                          <img
                                                            src="/add-me.svg"
                                                            alt="Add Icon"
                                                            className="w-5 h-5"
                                                          />
                                                        )}

                                                        <span
                                                          className={`text-sm ${
                                                            category.id === 2
                                                              ? "text-[#A9D4AB]"
                                                              : "text-[#92C5EA]"
                                                          }`}
                                                        >
                                                          Add Security
                                                        </span>
                                                      </button>
                                                    </div>
                                                  </td>
                                                </tr>
                                              )}{" "}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>

                              {totalErrors[category.id] && (
                                <div>
                                  {categoryCodes
                                    .filter(
                                      (item) => category.id === item.categoryId
                                    )
                                    .map((item, itemIndex, filteredStocks) => (
                                      <div className=" flex ml-5 mt-2 text-center items-center justify-center  rounded-md px-4 py-2 text-red-500 bg-red-100 border border-red-500">
                                        <div className="flex  items-center">
                                          <img
                                            src="/danger.svg"
                                            alt="Arrow"
                                            className=" left-0 w-5 h-5 mr-2"
                                          />{" "}
                                          Sub Allocation should be equal to{" "}
                                          {item.categoryId == 1
                                            ? growth == 100
                                              ? (
                                                  growth -
                                                  australianCashStockAllocation
                                                ).toFixed(2)
                                              : growth.toFixed(2)
                                            : defensive.toFixed(2)}
                                          %
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              )}
                              <div
                                className={`flex items-center p-4 mt-4 border rounded-md ${
                                  category.id === 2
                                    ? "border-[#A9D4AB]"
                                    : "border-[#92C5EA]"
                                }`}
                              >
                                {categoryCodes
                                  .filter(
                                    (item) => category.id === item.categoryId
                                  )
                                  .map((item, itemIndex, filteredStocks) => (
                                    <div
                                      key={itemIndex}
                                      className="flex items-center justify-between w-full space-x-4"
                                    >
                                      <div className="text-sm md:text-md font-bold text-black">
                                        SUB-TOTAL {category.name}
                                      </div>
                                      <div className="text-sm md:text-md font-bold text-black"></div>
                                      <div className="text-sm md:text-md font-bold text-black"></div>

                                      <div className="text-sm md:text-md  font-bold text-black">
                                        {Number(item.allocation).toFixed(2)} %
                                      </div>
                                      <div className="text-sm md:text-md font-bold text-black"></div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          ))}
                          {parseFloat(Number(totalPortfolio).toFixed(2)) !=
                            100.0 && (
                            <div>
                              <div className=" flex mb-2 text-center items-center justify-center  rounded-md px-4 py-2 text-red-500 bg-red-100 border border-red-500">
                                <div className="flex  items-center">
                                  <img
                                    src="/danger.svg"
                                    alt="Arrow"
                                    className=" left-0 w-5 h-5 mr-2"
                                  />{" "}
                                  Total Portfolio Allocation should be equal to
                                  100%
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="flex items-center p-4 border rounded-md border-black">
                            <div className="flex items-center justify-between w-full space-x-4">
                              <div className="text-sm md:text-md font-bold text-black">
                                TOTAL PORTFOLIO
                              </div>
                              <div className="text-sm md:text-md font-bold text-black"></div>
                              <div className="text-sm md:text-md font-bold text-black"></div>

                              <div className="text-sm md:text-md font-bold text-black">
                                {Number(totalPortfolio).toFixed(2)} %
                              </div>
                              <div className="text-sm md:text-md font-bold text-black"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center p-4 pt-2">
                        <div className="flex flex-col  w-full space-y-2">
                          {/* Top Section: Text */}
                          <span className="text-sm font-medium text-labelLightColour">
                            *Last SAA Rebalance: March 14, 2023
                          </span>

                          {/* Bottom Section: Buttons in a Row */}
                          <div className="flex md:flex-row flex-col flex-wrap items-left md:items-center justify-between w-full">
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                updateTAAData(existingCategories);
                              }}
                              className="flex items-center space-x-2 bg-white text-[#FF5050] border-[#FF5050] border-2 font-medium py-2 px-4 rounded-full text-sm"
                            >
                              <span>Undo Changes</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-center px-4">
                        <div className="flex flex-col w-full space-y-4">
                          {/* Bottom Section: Buttons in a Row */}
                          <div className="flex flex-wrap justify-between w-full space-y-4 sm:space-y-0 sm:flex-row sm:space-x-4">
                            {/* Blue Buttons on the Left */}
                            <div className="flex space-x-0 md:w-auto w-full md:flex-row flex-col md:space-x-4 sm:space-y-0 sm:justify-start">
                              <button
                                onClick={() => {
                                  let redirectState = {
                                    path: "/view-history",
                                    state: {
                                      from: location.pathname,
                                      historyStack: [
                                        ...(location.state?.historyStack || []),
                                        location.pathname,
                                      ],
                                    },
                                  };
                                  sessionStorage.setItem(
                                    "redirectAfterLogin",
                                    JSON.stringify(redirectState)
                                  );
                                  navigate("/view-history", {
                                    state: {
                                      from: location.pathname,
                                      historyStack: [
                                        ...(location.state?.historyStack || []),
                                        location.pathname,
                                      ],
                                    },
                                  });
                                }}
                                className="flex items-center space-x-2  bg-white text-[#005A9C] border-[#005A9C] border-2 font-medium py-2 px-6 rounded-full text-sm"
                              >
                                <span>View History</span>
                              </button>

                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  setLoading(true);
                                  saveTaaAsSaa(e);
                                }}
                                className="flex items-center md:mt-0 mt-2 space-x-2 bg-white text-[#005A9C] border-[#005A9C] border-2 font-medium py-2 px-6 rounded-full text-sm"
                              >
                                <span>Save TAA as SAA</span>
                              </button>
                            </div>

                            {/* Black Buttons on the Right */}
                            <div className="flex md:w-auto w-full space-x-0 md:flex-row flex-col md:space-x-4 sm:space-y-0 sm:justify-end">
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  setLoading(true);
                                  resetBackToSaa(e);
                                }}
                                className="flex  w-30 items-center space-x-2 text-white bg-black border-black border font-medium py-2 px-8 rounded-full text-sm"
                              >
                                <span>Reset back to SAA</span>
                              </button>

                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (
                                    Object.keys(errors).length !== 0 ||
                                    Object.keys(totalErrors).length !== 0
                                    //||
                                    // Object.keys(allowedPercentError).length !==
                                    //   0 ||
                                    // Object.keys(allowedPercentErrorCategory)
                                    //   .length !== 0
                                  ) {
                                    showToast(
                                      "Please set your allocated stock",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    Object.keys(twoPercentErrors).length !== 0
                                  ) {
                                    showToast(
                                      "Please set Australian cash atleast 2%",
                                      "error"
                                    );
                                    return;
                                  }
                                  if (
                                    parseFloat(
                                      Number(totalPortfolio).toFixed(2)
                                    ) != 100.0
                                  ) {
                                    showToast(
                                      "Portfolio Allocation should be 100%",
                                      "error"
                                    );
                                    return;
                                  }

                                  setLoading(true);
                                  updateTAA(e);
                                }}
                                className="flex items-center space-x-2 md:mt-0 mt-2 text-white bg-black border-black border font-medium py-2 px-8 rounded-full text-sm"
                              >
                                <span>Update TAA</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {parseFloat(Number(totalPortfolio).toFixed(2)) ==
                        100.0 && (
                        <div className="bg-white mt-6 px-4">
                          <PerformanceSection
                            riskProfile={riskProfile}
                            data={productCodes}
                            stockCode={stocks}
                            totalPercentage={totalPortfolio}
                            componentName="saa-taa"
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
              {tradingTab == "dda" && (
                <div className="pt-4 p-2">
                  {isLoading || isAllLoaded ? (
                    <div className="shimmer-container-list mb-4 ">
                      {/* Creating 5 rows of shimmer effect */}
                      {[...Array(2)].map((_, rowIndex) => (
                        <div key={rowIndex} className="shimmer-row-list">
                          {/* Creating 7 cells in each row for shimmer */}
                          {[...Array(2)].map((_, colIndex) => (
                            <div
                              key={colIndex}
                              className="shimmer-cell-list h-20"
                            >
                              <div className="shimmer-loader"></div>
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div
                      className="
                "
                    >
                      <div className="flex flex-col border-b pb-3 md:flex-col md:justify-start md:items-left">
                        {/* Left-aligned Heading */}
                        <h3 className="text-lg font-medium mb-2 md:text-ellipsis  md:overflow-hidden md:whitespace-nowrap md:mb-0">
                          Caprock Model Portfolio - {investmentProductName}
                        </h3>
                        <div className="text-sm font-normal mb-2 md:mb-0">
                          Strategic asset allocation empowers you to tailor your
                          investments to your specific needs and goals, offering
                          a disciplined approach to optimize returns and manage
                          risk over time.
                        </div>
                      </div>

                      <div className="bg-white px-2 py-4  ">
                        <div className="flex items-center justify-between border-b border-colour-custom pt-2 px-4">
                          <h1 className="text-lg font-medium mb-2 text-black text-center">
                            Current Target Allocation
                          </h1>
                          {/* <img
                            onClick={togglePopupEditStock}
                            src="/edit-details.svg" // Replace with the actual path to your edit icon
                            alt="Edit Icon"
                            className="w-4 h-4 cursor-pointer"
                          /> */}
                        </div>
                        <div className="overflow-x-auto ml-4 mb-4">
                          <table className=" w-full md:table-fixed border-collapse">
                            <thead>
                              <tr className="pl-14">
                                <th className="py-2 px-6 text-sm font-medium text-[#8C8C8C] border-b">
                                  No
                                </th>
                                <th className="py-2 px-4 text-sm w-30 font-medium text-[#8C8C8C] border-b">
                                  Security (Code)
                                </th>
                                <th className="py-2 px-2 text-sm text-left custom-width font-medium text-[#8C8C8C] border-b">
                                  Name
                                </th>
                                <th className="py-2 px-4 text-sm md:w-30 font-medium text-[#8C8C8C] border-b">
                                  SAA (%)
                                </th>
                                <th className="py-2 px-4 text-sm md:w-30 font-medium text-[#8C8C8C] border-b">
                                  DAA (%)
                                </th>
                                <th className="py-2 md:text-left  md:w-30   text-sm font-medium text-[#8C8C8C] border-b">
                                  Target(%)
                                </th>
                                <th className="py-2 px-4 md:text-left  md:w-30  text-sm font-medium text-[#8C8C8C] border-b">
                                  Market Price (AUD)
                                </th>
                                <th className="py-2 px-4 text-sm font-medium text-[#8C8C8C] border-b"></th>
                              </tr>
                            </thead>
                          </table>
                        </div>
                        <div className="max-h-[90vh]  overflow-y-auto pr-4">
                          {existingCategories.map((category, categoryIndex) => (
                            <div key={category.id} className="mb-6">
                              <div
                                className={`flex items-center flex-wrap justify-between p-4  rounded-md ${
                                  category.id === 2
                                    ? "bg-[#A9D4AB]"
                                    : "bg-[#92C5EA]"
                                }`}
                              >
                                <div
                                  className="flex items-center flex-grow cursor-pointer"
                                  onClick={() =>
                                    toggleExpandCategory(category.id)
                                  }
                                >
                                  <span className="text-sm md:text-lg font-bold text-black">
                                    {category.name}{" "}
                                    <span className="font-medium">
                                      {category.id === 2
                                        ? `(${defensive.toFixed(2)}%)`
                                        : `(${growth.toFixed(2)}%)`}
                                    </span>
                                  </span>
                                </div>
                                <div className="flex items-center gap-2">
                                  <div className="relative mt-2">
                                    <button
                                      onClick={() =>
                                        toggleCategoryDropdown(
                                          category.id,
                                          categoryIndex
                                        )
                                      }
                                      className={`flex items-center text-sm text-white p-3 rounded-xl transition-all ${
                                        category.id === 2
                                          ? "bg-[#709D72]"
                                          : "bg-[#63859F] "
                                      }`}
                                    >
                                      <FaPlus className="mr-2 " /> Add Asset
                                      Category{" "}
                                    </button>
                                    {isDropdownOpen(
                                      category.id,
                                      categoryIndex
                                    ) &&
                                      newCategories.length > 0 && (
                                        <div className="absolute z-50 mt-2 bg-white border rounded-md shadow-lg w-full">
                                          {newCategories
                                            .filter(
                                              (categoryItem) =>
                                                categoryItem.id === category.id
                                            ) // Match category ID
                                            .flatMap(
                                              (categoryItem) =>
                                                categoryItem.products
                                            ) // Extract products from matching categories
                                            .filter(
                                              (p) =>
                                                !(
                                                  selectedProductsByCategory[
                                                    category.id
                                                  ] || []
                                                ).includes(p.id) // Exclude selected products
                                            )
                                            .map((filteredProduct) => (
                                              <div
                                                key={filteredProduct.id}
                                                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                                onClick={() => {
                                                  toggleCategoryDropdown(
                                                    category.id,
                                                    categoryIndex
                                                  );
                                                  toggleProduct(
                                                    category.id,
                                                    filteredProduct.id
                                                  );
                                                  if (
                                                    !expandedCategory[
                                                      category.id
                                                    ]
                                                  ) {
                                                    toggleExpandCategory(
                                                      category.id
                                                    );
                                                  }
                                                }}
                                              >
                                                {filteredProduct.name}
                                              </div>
                                            ))}
                                        </div>
                                      )}
                                  </div>
                                  <span
                                    className="cursor-pointer lg:ml-4 ml-0"
                                    onClick={() =>
                                      toggleExpandCategory(category.id)
                                    }
                                  >
                                    {expandedCategory[category.id] ? (
                                      <img
                                        src="/export-arrow.svg"
                                        alt="Success Icon"
                                        className="h-4 w-4"
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </span>
                                </div>
                              </div>

                              {/* Subcategories */}
                              <div
                                className={`ml-4 md:ml-6 border-l-2 ${
                                  category.id === 2
                                    ? "border-[#A9D4AB]"
                                    : "border-[#92C5EA]"
                                }`}
                              >
                                {category.products
                                  .filter((product) =>
                                    (
                                      selectedProductsByCategory[category.id] ||
                                      []
                                    ).includes(product.id)
                                  )
                                  .map((subcategory, subcategoryIndex) => (
                                    <div
                                      key={subcategory.name}
                                      className="relative mb-2 pt-2 text-left"
                                    >
                                      {/* Subcategory Header */}
                                      <div className="flex items-center  rounded-md cursor-pointer">
                                        {category.id === 2 ? (
                                          <img
                                            src="/green-arrow.svg"
                                            alt="Arrow"
                                            className="w-5 h-5"
                                          />
                                        ) : (
                                          <img
                                            src="/arrow-hierarchy.svg"
                                            alt="Arrow"
                                            className="w-5 h-5"
                                          />
                                        )}

                                        <div
                                          className={`flex flex-col md:flex-row items-center justify-between p-4 w-full rounded-md cursor-pointer ${
                                            category.id === 2
                                              ? "bg-[#C0E2C1]"
                                              : "bg-[#C6DFF1]"
                                          }`}
                                        >
                                          {/* Left Side: Subcategory Name */}
                                          <div className="text-sm md:text-lg font-bold text-black md:w-1/3 md:mr-[0vw] custom-margin-dda text-center md:text-left w-full">
                                            {`${subcategoryIndex + 1}. ${
                                              subcategory.name
                                            }`}
                                          </div>
                                          {/* <div className="text-sm md:text-lg w-full md:w-1/3 md:mr-[3vw] custom-margin font-bold text-black text-center md:text-left">
                                        {`${subcategoryIndex + 1}. ${
                                          subcategory.name
                                        }`}
                                      </div> */}

                                          {/* Middle: 30 30 30 Spans + Input */}
                                          <div
                                            className={`flex   items-center justify-center md:justify-end space-x-2 md:space-x-10 
    ${
      strategyTypeId == 1 ? " custom-mr-st md:mr-14" : "md:mr-[8vw] custom-mr"
    }`}
                                          >
                                            {/* Allocation Input (kept close to spans) */}
                                            {productCodes
                                              .filter(
                                                (item) =>
                                                  subcategory.id ===
                                                  item.productId
                                              )
                                              .map((item) => (
                                                <div className="flex items-center justify-center md:justify-end space-x-2 md:space-x-10">
                                                  <span className="text-sm md:text-md">
                                                    {Number(
                                                      item.saaPercent
                                                    ).toFixed(2)}
                                                    %
                                                  </span>
                                                  <span className="text-sm md:text-md">
                                                    {Number(
                                                      item.daaPercent
                                                    ).toFixed(2)}
                                                    %
                                                  </span>
                                                  <div className="relative w-[60px] md:w-[90px]">
                                                    <input
                                                      type="number"
                                                      step="0.01"
                                                      min="0"
                                                      max="100"
                                                      value={item.allocation}
                                                      onChange={(e) =>
                                                        handleProductAllocationChange(
                                                          item.productId,
                                                          e.target.value,
                                                          category.id,
                                                          false
                                                        )
                                                      }
                                                      onBlur={(e) => {
                                                        const value =
                                                          parseFloat(
                                                            e.target.value
                                                          );
                                                        if (!isNaN(value)) {
                                                          handleProductAllocationChange(
                                                            item.productId,
                                                            value.toFixed(2),
                                                            category.id,
                                                            false
                                                          );
                                                        }
                                                      }}
                                                      className={`w-full text-sm px-2 py-1 md:py-2 rounded-lg  shadow-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black ${
                                                        errors[subcategory.id]
                                                          ? "border-[#FF5050] border-2"
                                                          : "border"
                                                      }`}
                                                    />
                                                    <span className="absolute inset-y-0 right-2 flex items-center text-xs font-medium text-gray-500">
                                                      %
                                                    </span>
                                                  </div>
                                                </div>
                                              ))}
                                          </div>
                                          <div className="flex items-center justify-center md:justify-end space-x-2 md:space-x-10">
                                            {strategyTypeId == 1 && (
                                              <button
                                                //  disabled={true}
                                                className="text-black  font-bold border-2 border-black rounded-full px-2 py-0
      hover:bg-black hover:text-white transition-all duration-200"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  DeleteProduct(
                                                    category.id,
                                                    subcategory.id
                                                  );
                                                }}
                                              >
                                                &times;
                                              </button>
                                            )}
                                          </div>
                                        </div>
                                      </div>

                                      {errors[subcategory.id] && (
                                        <div>
                                          {productCodes
                                            .filter(
                                              (item) =>
                                                item.productId !== 10 &&
                                                subcategory.id ===
                                                  item.productId
                                            )
                                            .map(
                                              (
                                                item,
                                                itemIndex,
                                                filteredStocks
                                              ) => (
                                                <div className=" flex ml-5 mt-2 text-center items-center justify-center  rounded-md px-4 py-2 text-red-500 bg-red-100 border border-red-500">
                                                  <div className="flex  items-center">
                                                    <img
                                                      src="/danger.svg"
                                                      alt="Arrow"
                                                      className=" left-0 w-5 h-5 mr-2"
                                                    />{" "}
                                                    Product Sub Allocation
                                                    should be equal to{" "}
                                                    {Number(
                                                      item.allocation
                                                    ).toFixed(2)}
                                                    %
                                                  </div>
                                                </div>
                                              )
                                            )}
                                        </div>
                                      )}
                                      {twoPercentErrors[subcategory.id] && (
                                        <div>
                                          {productCodes
                                            .filter(
                                              (item) =>
                                                subcategory.id ===
                                                item.productId
                                            )
                                            .map(
                                              (
                                                item,
                                                itemIndex,
                                                filteredStocks
                                              ) => (
                                                <div className=" flex ml-5 mt-2 text-center items-center justify-center  rounded-md px-4 py-2 text-red-500 bg-red-100 border border-red-500">
                                                  <div className="flex  items-center">
                                                    <img
                                                      src="/danger.svg"
                                                      alt="Arrow"
                                                      className=" left-0 w-5 h-5 mr-2"
                                                    />{" "}
                                                    Australian Cash should be
                                                    atleast 2%
                                                  </div>
                                                </div>
                                              )
                                            )}
                                        </div>
                                      )}
                                      {/* Table of Items */}
                                      <div
                                        className="ml-6 pl-0"
                                        style={{ height: "50%" }}
                                      >
                                        <div className="relative overflow-x-auto">
                                          <table className="min-w-full h-full table-auto border-collapse">
                                            <tbody className="rounded-md">
                                              {stocks
                                                .filter(
                                                  (item) => item.product !== 9
                                                )
                                                .filter(
                                                  (item) =>
                                                    subcategory.id ===
                                                    item.product
                                                )
                                                .map(
                                                  (
                                                    item,
                                                    itemIndex,
                                                    filteredStocks
                                                  ) => (
                                                    <tr
                                                      key={itemIndex}
                                                      className="text-left w-full mt-3  rounded-xl"
                                                    >
                                                      {itemIndex >= 0 && (
                                                        <td
                                                          className={`w-3 px-1 md:px-0 lg:px-1 relative
                                ${
                                  itemIndex === subcategory.stocks.length - 1
                                    ? ""
                                    : ""
                                }`}
                                                        >
                                                          {itemIndex ===
                                                          filteredStocks.length -
                                                            1 ? (
                                                            <div
                                                              className={`absolute left-0 top-0  w-[2px]  ${
                                                                category.id ===
                                                                2
                                                                  ? "bg-[#C0E2C1]"
                                                                  : "bg-[#C6DFF1]"
                                                              }`}
                                                              style={{
                                                                height: "60%", // 60% of the parent height
                                                              }}
                                                            ></div>
                                                          ) : (
                                                            <div
                                                              className={`absolute left-0 top-0 h-full w-[2px] ${
                                                                category.id ===
                                                                2
                                                                  ? "bg-[#C0E2C1]"
                                                                  : "bg-[#C6DFF1]"
                                                              }`}
                                                            ></div>
                                                          )}
                                                          {category.id === 3 ? (
                                                            <img
                                                              src="/green-arrow.svg"
                                                              alt="Arrow"
                                                              className="absolute left-0 w-3 h-3 mx-auto"
                                                            />
                                                          ) : (
                                                            <img
                                                              src="/arrow-hierarchy.svg"
                                                              alt="Arrow"
                                                              className="absolute left-0 w-3 h-3 mx-auto"
                                                            />
                                                          )}
                                                        </td>
                                                      )}
                                                      <div className="mt-2">
                                                        <td
                                                          className={`py-2 h-full w-40 py-2 rounded-l-lg mt-2 px-2 ${
                                                            category.id === 2
                                                              ? "bg-[#E7F5E8]"
                                                              : "bg-[#E6F3FC]"
                                                          }`}
                                                        >
                                                          {`${String.fromCharCode(
                                                            97 + itemIndex
                                                          )}`}
                                                          .{" "}
                                                          {/* Item Number (a, b, c) */}
                                                        </td>
                                                        <td
                                                          className={`pt-2 relative w-50 py-2 px-4 ${
                                                            category.id === 2
                                                              ? "bg-[#E7F5E8]"
                                                              : "bg-[#E6F3FC]"
                                                          }`}
                                                        >
                                                          <button
                                                            ref={(el) =>
                                                              (buttonRefs.current[
                                                                `${subcategory.id}-${itemIndex}`
                                                              ] = el)
                                                            } // Assign unique ref
                                                            onClick={() => {
                                                              toggleDropdown(
                                                                itemIndex,
                                                                subcategory.id
                                                              );
                                                            }}
                                                            className="px-4 py-2 text-sm font-medium rounded-xl   bg-white border flex items-center justify-start gap-2 focus:outline-none focus:ring-2 focus:ring-black"
                                                          >
                                                            <span className="w-20">
                                                              {item.code}
                                                            </span>
                                                            <img
                                                              src="/cross-grey.svg" // Replace with the correct path to your cross image
                                                              alt="Close"
                                                              className="w-2 h-2 ml-4"
                                                            />
                                                          </button>
                                                          <DropdownTest
                                                            isOpen={
                                                              dropdownOpen[
                                                                `${subcategory.id}-${itemIndex}`
                                                              ]
                                                            }
                                                            buttonRef={
                                                              buttonRefs
                                                                .current[
                                                                `${subcategory.id}-${itemIndex}`
                                                              ]
                                                            } // Pass unique ref to the dropdown
                                                          >
                                                            <div className="absolute z-50 mt-2 w-30 bg-white rounded-md shadow-lg">
                                                              <div className="p-2">
                                                                <input
                                                                  type="text"
                                                                  value={
                                                                    searchTerm
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    setSearchTerm(
                                                                      e.target
                                                                        .value
                                                                    )
                                                                  }
                                                                  placeholder="Search..."
                                                                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                                                                />
                                                              </div>
                                                              <div className="p-4  w-40 overflow-y-auto max-h-40">
                                                                <ul className="space-y-2">
                                                                  {getRelevantSecurityCodes(
                                                                    category.id,
                                                                    subcategory.id
                                                                  )
                                                                    .filter(
                                                                      (
                                                                        option
                                                                      ) =>
                                                                        option.stock.asx_code
                                                                          .toLowerCase()
                                                                          .includes(
                                                                            searchTerm.toLowerCase()
                                                                          )
                                                                    )
                                                                    .map(
                                                                      (
                                                                        option,
                                                                        optionIndex
                                                                      ) => (
                                                                        <li
                                                                          onClick={() => {
                                                                            handleCodeChange(
                                                                              itemIndex,
                                                                              subcategoryIndex,
                                                                              categoryIndex,
                                                                              option
                                                                                .stock
                                                                                .asx_code
                                                                            );
                                                                            setDropdownOpen(
                                                                              (
                                                                                prevState
                                                                              ) => ({
                                                                                ...prevState,
                                                                                [`${subcategory.id}-${itemIndex}`]:
                                                                                  !prevState[
                                                                                    `${subcategory.id}-${itemIndex}`
                                                                                  ],
                                                                              })
                                                                            );
                                                                            setSearchTerm(
                                                                              ""
                                                                            );
                                                                            setisAnyDropdownOpen(
                                                                              !isAnyDropdownOpen
                                                                            );
                                                                          }}
                                                                          key={
                                                                            optionIndex
                                                                          }
                                                                          className="flex justify-between items-center  px-4 py-2 text-sm text-black rounded-lg hover:bg-black hover:text-white  cursor-pointer"
                                                                        >
                                                                          {
                                                                            option
                                                                              .stock
                                                                              .asx_code
                                                                          }
                                                                        </li>
                                                                      )
                                                                    )}
                                                                </ul>
                                                              </div>
                                                            </div>
                                                          </DropdownTest>
                                                        </td>
                                                        <td
                                                          className={`py-2 px-4 w-3/4  ${
                                                            category.id === 2
                                                              ? "bg-[#E7F5E8]"
                                                              : "bg-[#E6F3FC]"
                                                          }`}
                                                        >
                                                          <span className="block md:break-words text-ellipsis  overflow-hidden whitespace-nowrap break-normal md:truncate lg:whitespace-normal w-full">
                                                            {item.name}
                                                          </span>
                                                        </td>
                                                        <td
                                                          className={`py-2 px-4  ${
                                                            category.id === 2
                                                              ? "bg-[#E7F5E8]"
                                                              : "bg-[#E6F3FC]"
                                                          }`}
                                                        >
                                                          <span className="text-sm">
                                                            {Number(
                                                              item.saaPercent
                                                            ).toFixed(2)}
                                                            %
                                                          </span>
                                                        </td>
                                                        <td
                                                          className={`py-2 px-4  ${
                                                            category.id === 2
                                                              ? "bg-[#E7F5E8]"
                                                              : "bg-[#E6F3FC]"
                                                          }`}
                                                        >
                                                          <span className="text-sm">
                                                            {Number(
                                                              item.daaPercent
                                                            ).toFixed(2)}
                                                            %
                                                          </span>
                                                        </td>
                                                        <td
                                                          className={`py-2 relative w-50 px-4 ${
                                                            category.id === 2
                                                              ? "bg-[#E7F5E8]"
                                                              : "bg-[#E6F3FC]"
                                                          }`}
                                                        >
                                                          <div className="relative ml-2">
                                                            <input
                                                              type="number"
                                                              step="0.01"
                                                              min="0"
                                                              max="100"
                                                              disabled={
                                                                item.product ==
                                                                10
                                                                  ? true
                                                                  : false
                                                              }
                                                              value={
                                                                item.allocation
                                                              }
                                                              onChange={(e) =>
                                                                handleStockAllocationChange(
                                                                  item.id,
                                                                  e.target
                                                                    .value,
                                                                  item.stockId
                                                                )
                                                              }
                                                              onBlur={(e) => {
                                                                const value =
                                                                  parseFloat(
                                                                    e.target
                                                                      .value
                                                                  );
                                                                if (
                                                                  !isNaN(value)
                                                                ) {
                                                                  handleStockAllocationChange(
                                                                    item.id,
                                                                    value.toFixed(
                                                                      2
                                                                    ),
                                                                    item.stockId
                                                                  );
                                                                }
                                                              }}
                                                              className="lg:w-20 w-20 text-sm bg-white px-3 py-3 rounded-xl text-black bg-white border shadow-sm focus:outline-none focus:ring-2 focus:ring-black focus:border-black"
                                                            />
                                                            <span className="absolute inset-y-0 right-3 flex items-center text-sm font-medium text-[#8C8C8C]">
                                                              %
                                                            </span>
                                                          </div>
                                                        </td>
                                                        <td
                                                          className={`py-4 px-4 w-3/4 font-semibold text-md text-black ${
                                                            category.id === 2
                                                              ? "bg-[#E7F5E8]"
                                                              : "bg-[#E6F3FC]"
                                                          }`}
                                                        >
                                                          <span className="ml-4">
                                                            {" "}
                                                            {Number(
                                                              item.stockMarketPrice
                                                            )
                                                              .toFixed(2)
                                                              .toString()
                                                              .replace(
                                                                /\B(?=(\d{3})+(?!\d))/g,
                                                                ","
                                                              )}
                                                          </span>
                                                        </td>
                                                        <td
                                                          className={`py-4 px-4 w-3/4 rounded-r-lg ${
                                                            category.id === 2
                                                              ? "bg-[#E7F5E8]"
                                                              : "bg-[#E6F3FC]"
                                                          }`}
                                                        >
                                                          {/* Delete Button */}
                                                          <button
                                                            className="text-black text-bold border-2 border-black rounded-full px-2 mr-4 py-0 hover:text-black"
                                                            onClick={(e) => {
                                                              e.stopPropagation(); // Prevent triggering the dropdown toggle
                                                              deleteStock(
                                                                item.id,
                                                                item.stockId
                                                              );
                                                            }}
                                                          >
                                                            &times;{" "}
                                                          </button>
                                                        </td>
                                                      </div>
                                                    </tr>
                                                  )
                                                )}
                                              {subcategory.id != 9 && (
                                                <tr className="text-left rounded-xl">
                                                  <td
                                                    colSpan="8"
                                                    className="py-2 w-full pl-3"
                                                  >
                                                    <div
                                                      className={`flex justify-center py-2 rounded-lg bg-[#F8FCFF] border-2 border-dashed  items-center ${
                                                        category.id === 2
                                                          ? "text-[#A9D4AB]"
                                                          : "text-[#92C5EA]"
                                                      }`}
                                                    >
                                                      <button
                                                        className="flex items-center gap-2 px-6 py-2 bg-white text-[#92C5EA] rounded-lg shadow-sm  focus:outline-none focus:ring-2 focus:ring-[#BBDBF2]"
                                                        onClick={() =>
                                                          handleAddItem(
                                                            subcategory.id,
                                                            category.id,
                                                            subcategory.stocks,
                                                            subcategoryIndex
                                                          )
                                                        }
                                                      >
                                                        {category.id === 2 ? (
                                                          <img
                                                            src="/add-green.svg"
                                                            alt="Add Icon"
                                                            className="w-5 h-5"
                                                          />
                                                        ) : (
                                                          <img
                                                            src="/add-me.svg"
                                                            alt="Add Icon"
                                                            className="w-5 h-5"
                                                          />
                                                        )}

                                                        <span
                                                          className={`text-sm ${
                                                            category.id === 2
                                                              ? "text-[#A9D4AB]"
                                                              : "text-[#92C5EA]"
                                                          }`}
                                                        >
                                                          Add Security
                                                        </span>
                                                      </button>
                                                    </div>
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                              </div>

                              {totalErrors[category.id] && (
                                <div>
                                  {categoryCodes
                                    .filter(
                                      (item) => category.id === item.categoryId
                                    )
                                    .map((item, itemIndex, filteredStocks) => (
                                      <div className=" flex ml-5 mt-2 text-center items-center justify-center  rounded-md px-4 py-2 text-red-500 bg-red-100 border border-red-500">
                                        <div className="flex  items-center">
                                          <img
                                            src="/danger.svg"
                                            alt="Arrow"
                                            className=" left-0 w-5 h-5 mr-2"
                                          />{" "}
                                          Sub Allocation should be equal to{" "}
                                          {item.categoryId == 1
                                            ? growth == 100
                                              ? (
                                                  growth -
                                                  australianCashStockAllocation
                                                ).toFixed(2)
                                              : growth.toFixed(2)
                                            : defensive.toFixed(2)}
                                          %
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              )}
                              <div
                                className={`flex items-center p-4 mt-4 border rounded-md ${
                                  category.id === 2
                                    ? "border-[#A9D4AB]"
                                    : "border-[#92C5EA]"
                                }`}
                              >
                                {categoryCodes
                                  .filter(
                                    (item) => category.id === item.categoryId
                                  )
                                  .map((item, itemIndex, filteredStocks) => (
                                    <div
                                      key={itemIndex}
                                      className="flex items-center justify-between w-full space-x-4"
                                    >
                                      <div className="text-sm md:text-md font-bold text-black">
                                        SUB-TOTAL {category.name}
                                      </div>
                                      <div className="text-sm md:text-md font-bold text-black"></div>
                                      <div className="text-sm md:text-md font-bold text-black"></div>

                                      <div className="text-sm md:text-md  font-bold text-black">
                                        {Number(item.allocation).toFixed(2)} %
                                      </div>
                                      <div className="text-sm md:text-md font-bold text-black"></div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          ))}
                          {parseFloat(Number(totalPortfolio).toFixed(2)) !=
                            100.0 && (
                            <div>
                              <div className=" flex mb-2 text-center items-center justify-center  rounded-md px-4 py-2 text-red-500 bg-red-100 border border-red-500">
                                <div className="flex  items-center">
                                  <img
                                    src="/danger.svg"
                                    alt="Arrow"
                                    className=" left-0 w-5 h-5 mr-2"
                                  />{" "}
                                  Total Portfolio Allocation should be equal to
                                  100%
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="flex items-center p-4 border rounded-md border-black">
                            <div className="flex items-center justify-between w-full ">
                              <div className="flex items-center justify-between flex-col md:flex-row w-full md:w-auto">
                                <span className="text-sm md:text-md font-bold text-black">
                                  TOTAL PORTFOLIO
                                </span>
                                <span
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setTotalErrors([]);
                                    setErrors([]);
                                    setSelectedProductsByCategory({});

                                    updateTAAData(actualCategories);
                                    setExistingCategories(actualCategories);
                                  }}
                                  className="ml-2 text-xs font-normal rounded-full bg-black text-white py-1 px-3 cursor-pointer"
                                >
                                  Reset Changes
                                </span>
                              </div>
                              <div className="text-sm md:text-md font-bold text-black"></div>

                              <div className="text-sm md:text-md  font-bold text-black"></div>

                              <div className="text-sm md:text-md mr-[3vw] new-margin font-bold text-black">
                                {totalPortfolio.toFixed(2)} %
                              </div>
                              <div className="text-sm md:text-md font-bold text-black"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {parseFloat(Number(totalPortfolio).toFixed(2)) ==
                        100.0 && (
                        <div className="bg-white mt-6 px-4">
                          <PerformanceSection
                            riskProfile={riskProfile}
                            data={productCodes}
                            stockCode={stocks}
                            totalPercentage={totalPortfolio}
                            componentName="saa-taa"
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
              {tradingTab == "rebalancing" && (
                <div className="pt-4 p-2">
                  {isLoadingRebalacing ? (
                    <div className="shimmer-container-list mb-4 ">
                      {/* Creating 5 rows of shimmer effect */}
                      {[...Array(2)].map((_, rowIndex) => (
                        <div key={rowIndex} className="shimmer-row-list">
                          {/* Creating 7 cells in each row for shimmer */}
                          {[...Array(2)].map((_, colIndex) => (
                            <div
                              key={colIndex}
                              className="shimmer-cell-list h-20"
                            >
                              <div className="shimmer-loader"></div>
                            </div>
                          ))}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="w-full bg-white">
                      <div className="flex items-center border-b border-colour-custom ">
                        <h1 className="text-lg font-medium mb-2">
                          Caprock Model Portfolio - {investmentProductName}
                        </h1>
                      </div>
                      <div className="flex mt-4 justify-between items-center border-b mb-4">
                        <h3 className="text-md font-semibold mb-2 ">
                          Portfolio Breakdown
                        </h3>
                      </div>
                      {rebalancingData && rebalancingData.length > 0 && (
                        <div>
                          <div className="overflow-x-auto mt-4">
                            <table className="table-auto border-collapse w-full text-sm">
                              <thead>
                                <tr className="bg-[#6AA7D3] text-white font-semibold">
                                  <th className="border border-white  px-4 py-2">
                                    No
                                  </th>
                                  <th className="border border-white  px-4 py-2">
                                    Strategic Asset Allocation
                                  </th>
                                  <th className="border border-white  px-4 py-2">
                                    Code
                                  </th>
                                  <th className="border border-white  px-4 py-2">
                                    Shares
                                  </th>
                                  <th className="border border-white  px-4 py-2">
                                    Value
                                  </th>
                                  <th className="border border-white  px-4 py-2">
                                    Current(%)
                                  </th>
                                  <th className="border border-white  px-4 py-2">
                                    Target(%)
                                  </th>
                                  <th className="border border-white  px-4 py-2">
                                    Difference
                                  </th>
                                  <th className="border border-white  px-4 py-2">
                                    Action
                                  </th>
                                </tr>
                              </thead>
                              {isLoadingRebalacing ? (
                                <tbody className="shimmer-container-list ">
                                  {/* Creating 5 rows of shimmer effect */}
                                  {[...Array(5)].map((_, rowIndex) => (
                                    <tr
                                      key={rowIndex}
                                      className="shimmer-row-list"
                                    >
                                      {/* Creating 7 cells in each row for shimmer */}
                                      {[...Array(9)].map((_, colIndex) => (
                                        <td
                                          key={colIndex}
                                          className="shimmer-cell-list"
                                        >
                                          <div className="shimmer-loader"></div>
                                        </td>
                                      ))}
                                    </tr>
                                  ))}
                                </tbody>
                              ) : (
                                <tbody>
                                  {rebalancingData.map(
                                    (categoryData, categoryIndex) => (
                                      <React.Fragment key={categoryIndex}>
                                        {/* Category Row */}
                                        <tr
                                          className={`px-6 py-2 rounded-lg ${
                                            categoryData.name.toUpperCase() ==
                                            "GROWTH"
                                              ? "bg-[#92C5EA]"
                                              : "bg-[#A9D4AB]"
                                          }`}
                                        >
                                          <td
                                            colSpan={1}
                                            className="border border-white px-4 py-2 font-bold"
                                          ></td>
                                          <td
                                            colSpan={1}
                                            className="border border-white px-4 py-2 font-bold"
                                          >
                                            {categoryData.name.toUpperCase()}
                                          </td>
                                          <td
                                            colSpan={1}
                                            className="border border-white  px-4 py-2 font-bold"
                                          ></td>
                                          <td
                                            colSpan={1}
                                            className="border border-white px-4 py-2 font-bold"
                                          ></td>
                                          <td
                                            colSpan={1}
                                            className="border border-white px-4 py-2 font-bold"
                                          ></td>
                                          <td
                                            colSpan={1}
                                            className="border border-white px-4 py-2 font-bold"
                                          ></td>
                                          <td
                                            colSpan={1}
                                            className={`border border-white px-4 py-2 font-bold`}
                                          ></td>
                                          <td
                                            colSpan={1}
                                            className="border border-white px-4 py-2 font-bold"
                                          ></td>
                                          <td
                                            colSpan={1}
                                            className="border border-white px-4 py-2 font-bold"
                                          ></td>
                                        </tr>

                                        {/* Products */}
                                        {categoryData.products.map(
                                          (product, productIndex) => (
                                            <React.Fragment key={productIndex}>
                                              {/* Product Row */}
                                              <tr
                                                className={`text-[#005A9C] ${
                                                  categoryData.name.toUpperCase() ==
                                                  "GROWTH"
                                                    ? "bg-[#C6DFF1]"
                                                    : "bg-[#C0E2C1]"
                                                }`}
                                              >
                                                <td
                                                  colSpan={1}
                                                  className="border border-white px-4 py-2 font-bold"
                                                >
                                                  {(productIndex + 1)
                                                    .toString()
                                                    .padStart(2, "0")}
                                                </td>
                                                <td
                                                  colSpan={1}
                                                  className="border border-white px-4 py-2 font-semibold"
                                                >
                                                  {product.name}
                                                </td>
                                                <td
                                                  colSpan={1}
                                                  className="border border-white px-4 py-2 font-semibold"
                                                ></td>
                                                <td
                                                  colSpan={1}
                                                  className="border border-white px-4 py-2 font-bold"
                                                ></td>
                                                <td
                                                  colSpan={1}
                                                  className="border border-white px-4 py-2 font-bold"
                                                >
                                                  {" "}
                                                  {product.action_value
                                                    .toFixed(2)
                                                    .toString()
                                                    .replace(
                                                      /\B(?=(\d{3})+(?!\d))/g,
                                                      ","
                                                    ) || "-"}
                                                </td>
                                                <td
                                                  colSpan={1}
                                                  className="border border-white px-4 py-2 font-bold"
                                                >
                                                  {product.current_percentage.toFixed(
                                                    2
                                                  )}
                                                </td>
                                                <td
                                                  colSpan={1}
                                                  className="border border-white px-4 py-2 font-bold"
                                                >
                                                  {product.target_percentage.toFixed(
                                                    2
                                                  )}
                                                </td>
                                                <td
                                                  colSpan={1}
                                                  className={`border border-white px-4 py-2 font-bold ${
                                                    product.difference_percentage <
                                                    0
                                                      ? "text-[#FF5050]"
                                                      : "text-[#34C046]"
                                                  }`}
                                                >
                                                  {product.difference_percentage.toFixed(
                                                    2
                                                  )}
                                                </td>
                                                <td
                                                  colSpan={1}
                                                  className="border border-white px-4 py-2 font-bold"
                                                >
                                                  <button
                                                    disabled={true}
                                                    className={`font-medium h-4 rounded-xl px-4 py-2  flex justify-between items-center focus:outline-none${
                                                      product.action == "none"
                                                        ? " border-2 border-black text-black bg-white"
                                                        : ""
                                                    }
                              ${
                                product.action == "buy"
                                  ? " border-2 border-[#34C046] text-[#34C046] bg-white"
                                  : ""
                              }
                              ${
                                product.action == "sell"
                                  ? " border-2 border-[#FF5050] text-[#FF5050] bg-white"
                                  : ""
                              }
                              `}
                                                  >
                                                    <span className="">
                                                      {" "}
                                                      {product.action
                                                        .charAt(0)
                                                        .toUpperCase() +
                                                        product.action.slice(1)}
                                                    </span>
                                                  </button>
                                                </td>
                                              </tr>

                                              {/* Stocks */}
                                              {product.stocks.map(
                                                (stock, stockIndex) => (
                                                  <tr
                                                    key={stockIndex}
                                                    className={`text-[#black] ${
                                                      categoryData.name.toUpperCase() ==
                                                      "GROWTH"
                                                        ? "bg-[#E6F3FC]"
                                                        : "bg-[#E7F5E8]"
                                                    }`}
                                                  >
                                                    <td className="border border-white px-4 py-2"></td>
                                                    <td className="border border-white px-4 py-2">
                                                      {stock.stock_name}
                                                    </td>
                                                    <td className="border border-white px-4 py-2">
                                                      {stock.asx_code}
                                                    </td>
                                                    <td className="border border-white px-4 py-2">
                                                      {!stock.action_quantity
                                                        ? "00"
                                                        : stock.action_quantity
                                                            .toString()
                                                            .replace(
                                                              /\B(?=(\d{3})+(?!\d))/g,
                                                              ","
                                                            )}
                                                    </td>
                                                    <td className="border border-white px-4 py-2">
                                                      {stock.action_value
                                                        .toFixed(2)
                                                        .toString()
                                                        .replace(
                                                          /\B(?=(\d{3})+(?!\d))/g,
                                                          ","
                                                        ) || "-"}
                                                    </td>
                                                    <td className="border border-white px-4 py-2">
                                                      {stock.current_percentage.toFixed(
                                                        2
                                                      )}
                                                    </td>
                                                    <td className="border border-white px-4 py-2">
                                                      {stock.target_percentage.toFixed(
                                                        2
                                                      )}
                                                    </td>
                                                    <td
                                                      className={`border border-white px-4 py-2 font-bold ${
                                                        stock.difference_percentage <
                                                        0
                                                          ? "text-[#FF5050]"
                                                          : "text-[#34C046]"
                                                      }`}
                                                    >
                                                      {stock.difference_percentage.toFixed(
                                                        2
                                                      )}
                                                    </td>
                                                    <td className="border border-white px-4 py-2">
                                                      <button
                                                        disabled={true}
                                                        className={`font-medium h-4 rounded-xl px-4 py-2  flex justify-between items-center focus:outline-none${
                                                          stock.action == "none"
                                                            ? " border-2 border-black text-black bg-white"
                                                            : ""
                                                        }
                              ${
                                stock.action == "buy"
                                  ? " border-2 border-[#34C046] text-[#34C046] bg-white"
                                  : ""
                              }
                              ${
                                stock.action == "sell"
                                  ? " border-2 border-[#FF5050] text-[#FF5050] bg-white"
                                  : ""
                              }
                              `}
                                                      >
                                                        <span className="">
                                                          {" "}
                                                          {stock.action
                                                            .charAt(0)
                                                            .toUpperCase() +
                                                            stock.action.slice(
                                                              1
                                                            )}
                                                        </span>
                                                      </button>
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                            </React.Fragment>
                                          )
                                        )}
                                        <tr
                                          className={`font-bold ${
                                            categoryData.name.toUpperCase() ==
                                            "GROWTH"
                                              ? "bg-[#92C5EA]"
                                              : "bg-[#A9D4AB]"
                                          }`}
                                        >
                                          <td
                                            colSpan={1}
                                            className="border px-4 py-2"
                                          ></td>
                                          <td
                                            colSpan={2}
                                            className="border px-4 py-2"
                                          >
                                            SUB-TOTAL {categoryData.name}
                                          </td>
                                          <td
                                            colSpan={1}
                                            className="border px-4 py-2"
                                          ></td>
                                          <td
                                            colSpan={1}
                                            className="border px-4 py-2"
                                          >
                                            {categoryData.action_value
                                              .toFixed(2)
                                              .toString()
                                              .replace(
                                                /\B(?=(\d{3})+(?!\d))/g,
                                                ","
                                              ) || "-"}
                                          </td>
                                          <td
                                            colSpan={1}
                                            className={`border px-4 py-2`}
                                          >
                                            {" "}
                                            {categoryData.current_percentage.toFixed(
                                              2
                                            )}
                                          </td>
                                          <td
                                            colSpan={1}
                                            className="border px-4 py-2"
                                          >
                                            {categoryData.target_percentage.toFixed(
                                              2
                                            )}
                                          </td>
                                          <td
                                            colSpan={1}
                                            className={`border px-4 py-2 ${
                                              categoryData.difference_percentage <
                                              0
                                                ? "text-[#FF5050]"
                                                : "text-[#34C046]"
                                            }`}
                                          >
                                            {categoryData.difference_percentage.toFixed(
                                              2
                                            )}
                                          </td>
                                          <td
                                            colSpan={1}
                                            className="border px-4 py-2"
                                          >
                                            <button
                                              disabled={true}
                                              className={`font-medium h-4 rounded-xl px-4 py-2  flex justify-between items-center focus:outline-none${
                                                categoryData.action == "none"
                                                  ? " border-2 border-black text-black bg-white"
                                                  : ""
                                              }
                              ${
                                categoryData.action == "buy"
                                  ? " border-2 border-[#34C046] text-[#34C046] bg-white"
                                  : ""
                              }
                              ${
                                categoryData.action == "sell"
                                  ? " border-2 border-[#FF5050] text-[#FF5050] bg-white"
                                  : ""
                              }
                              `}
                                            >
                                              <span className="">
                                                {" "}
                                                {categoryData.action
                                                  .charAt(0)
                                                  .toUpperCase() +
                                                  categoryData.action.slice(1)}
                                              </span>
                                            </button>
                                          </td>
                                        </tr>
                                      </React.Fragment>
                                    )
                                  )}
                                  <React.Fragment>
                                    <tr className="bg-[#EAEAEA] font-bold">
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2 text-right"
                                      ></td>
                                      <td
                                        colSpan={2}
                                        className="border px-4 py-2"
                                      >
                                        Summary
                                      </td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      ></td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      ></td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2 text-right"
                                      ></td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2 text-right"
                                      ></td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2 text-right"
                                      ></td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2 text-right"
                                      ></td>
                                    </tr>
                                    <tr className="bg-[#92C5EA]  font-bold">
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2 text-right"
                                      ></td>
                                      <td
                                        colSpan={2}
                                        className="border px-4 py-2"
                                      >
                                        {rebalancingData[0].name}
                                      </td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      ></td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      >
                                        {" "}
                                        {rebalancingData[0].action_value
                                          .toFixed(2)
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          ) || "-"}
                                      </td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      >
                                        {rebalancingData[0].current_percentage.toFixed(
                                          2
                                        )}
                                      </td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      >
                                        {rebalancingData[0].target_percentage.toFixed(
                                          2
                                        )}
                                      </td>
                                      <td
                                        colSpan={1}
                                        className={`border px-4 py-2 ${
                                          rebalancingData[0]
                                            .difference_percentage < 0
                                            ? "text-[#FF5050]"
                                            : "text-[#34C046]"
                                        }`}
                                      >
                                        {rebalancingData[0].difference_percentage.toFixed(
                                          2
                                        )}
                                      </td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      >
                                        <button
                                          disabled={true}
                                          className={`font-medium h-4 rounded-xl px-4 py-2  flex justify-between items-center focus:outline-none${
                                            rebalancingData[0].action == "none"
                                              ? " border-2 border-black text-black bg-white"
                                              : ""
                                          }
                              ${
                                rebalancingData[0].action == "buy"
                                  ? " border-2 border-[#34C046] text-[#34C046] bg-white"
                                  : ""
                              }
                              ${
                                rebalancingData[0].action == "sell"
                                  ? " border-2 border-[#FF5050] text-[#FF5050] bg-white"
                                  : ""
                              }
                              `}
                                        >
                                          <span className="">
                                            {" "}
                                            {rebalancingData[0].action
                                              .charAt(0)
                                              .toUpperCase() +
                                              rebalancingData[0].action.slice(
                                                1
                                              )}
                                          </span>
                                        </button>
                                      </td>
                                    </tr>
                                    <tr className="bg-[#A9D4AB]  font-bold">
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2 text-right"
                                      ></td>
                                      <td
                                        colSpan={2}
                                        className="border px-4 py-2"
                                      >
                                        {rebalancingData[1].name}
                                      </td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      ></td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      >
                                        {" "}
                                        {rebalancingData[1].action_value
                                          .toFixed(2)
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          ) || "-"}
                                      </td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      >
                                        {rebalancingData[1].current_percentage.toFixed(
                                          2
                                        )}
                                      </td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      >
                                        {rebalancingData[1].target_percentage.toFixed(
                                          2
                                        )}
                                      </td>
                                      <td
                                        colSpan={1}
                                        className={`border px-4 py-2 ${
                                          rebalancingData[1]
                                            .difference_percentage < 0
                                            ? "text-[#FF5050]"
                                            : "text-[#34C046]"
                                        }`}
                                      >
                                        {rebalancingData[1].difference_percentage.toFixed(
                                          2
                                        )}
                                      </td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      >
                                        <button
                                          disabled={true}
                                          className={`font-medium h-4 rounded-xl px-4 py-2  flex justify-between items-center focus:outline-none${
                                            rebalancingData[1].action == "none"
                                              ? " border-2 border-black text-black bg-white"
                                              : ""
                                          }
                              ${
                                rebalancingData[1].action == "buy"
                                  ? " border-2 border-[#34C046] text-[#34C046] bg-white"
                                  : ""
                              }
                              ${
                                rebalancingData[1].action == "sell"
                                  ? " border-2 border-[#FF5050] text-[#FF5050] bg-white"
                                  : ""
                              }
                              `}
                                        >
                                          <span className="">
                                            {" "}
                                            {rebalancingData[1].action
                                              .charAt(0)
                                              .toUpperCase() +
                                              rebalancingData[1].action.slice(
                                                1
                                              )}
                                          </span>
                                        </button>
                                      </td>
                                    </tr>
                                    <tr className="bg-[#CDCDCD] font-bold">
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      ></td>
                                      <td
                                        colSpan={2}
                                        className="border px-4 py-2"
                                      >
                                        TOTAL PORTFOLIO
                                      </td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      ></td>

                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      >
                                        {(
                                          rebalancingData[0].action_value +
                                          rebalancingData[1].action_value
                                        )
                                          .toFixed(2)
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          ) || "-"}
                                      </td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      >
                                        {(
                                          rebalancingData[0]
                                            .current_percentage +
                                          rebalancingData[1].current_percentage
                                        ).toFixed(2) || "-"}
                                      </td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      >
                                        {(
                                          rebalancingData[0].target_percentage +
                                          rebalancingData[1].target_percentage
                                        ).toFixed(2) || "-"}
                                      </td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      ></td>
                                      <td
                                        colSpan={1}
                                        className="border px-4 py-2"
                                      ></td>
                                    </tr>
                                  </React.Fragment>
                                </tbody>
                              )}
                            </table>
                          </div>
                          <div className="flex flex-col md:flex-row items-center justify-between mt-6 px-8 py-4 bg-[#FF5050] bg-opacity-20 shadow-md rounded-md space-y-4 md:space-y-0">
                            {/* Text Section */}
                            <div className="text-center md:text-left flex-1">
                              <span className="block text-sm md:text-md font-medium text-black">
                                Auto rebalance will perform all buy and sell
                                transactions needed to rebalance the portfolio
                              </span>
                            </div>

                            {/* Button Section */}
                            <div className="text-center md:text-right">
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  setLoading(true);
                                  postAutoBalanced(e);
                                }}
                                className="flex items-center justify-center space-x-2 bg-black text-white font-medium py-2 px-4 rounded-full text-sm"
                              >
                                <span>Auto Rebalance</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
        {filter == "investors" && (
          <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
            {/* Top Navigation */}
            <div className="bg-white p-6 shadow rounded-lg ">
              <div className="flex items-center space-x-4 mb-6">
                <span
                  onClick={() => setIsCurrentInvestorSelected(true)}
                  className={`cursor-pointer   pr-4 font-medium ${
                    isCurrentInvestorSelected
                      ? "border-black text-black border-b-2"
                      : "text-gray-500"
                  }`}
                >
                  Current Investors
                </span>
                <span className="text-[#B2B2B2]">|</span>
                <span
                  className={`cursor-pointer  font-medium ${
                    !isCurrentInvestorSelected
                      ? "border-black text-black border-b-2"
                      : "text-gray-500"
                  }`}
                  onClick={() => setIsCurrentInvestorSelected(false)}
                >
                  Add Investor
                </span>{" "}
              </div>
              {isCurrentInvestorSelected && (
                <div className="p-2 mb-4">
                  <div className="flex flex-col border-b pb-3 md:flex-row md:justify-between md:items-center">
                    {/* Left-aligned Heading */}
                    <h3 className="text-lg font-medium mb-2 md:text-ellipsis  md:overflow-hidden md:whitespace-nowrap md:mb-0">
                      Caprock Model Portfolio - {investmentProductName}
                    </h3>
                  </div>
                  <div className="flex flex-col border-b pt-2 pb-3 md:flex-row md:justify-between md:items-center">
                    {/* Left-aligned Heading */}
                    <h3 className="text-lg font-medium mb-2 md:text-ellipsis  md:overflow-hidden md:whitespace-nowrap md:mb-0">
                      Investors
                    </h3>

                    {/* Right-aligned Information */}
                    <div className="flex flex-wrap items-center space-x-2">
                      <div className="flex flex-col items-center">
                        <span className="text-sm font-semibold text-[#464646] leading-tight">
                          Number of
                        </span>
                        <span className="text-sm font-semibold text-[#464646] leading-tight">
                          Investors
                        </span>
                      </div>{" "}
                      <span className="text-md font-semibold">|</span>
                      <span className="text-sm font-semibold rounded-md text-white py-1 px-3 bg-[#3047EC]">
                        {totalInvestors}
                      </span>
                      <span className="text-md font-semibold">|</span>
                      <div className="flex flex-col items-center">
                        <span className="text-sm font-semibold text-[#464646] leading-tight">
                          Total
                        </span>
                        <span className="text-sm font-semibold text-[#464646] leading-tight">
                          Invested $
                        </span>
                      </div>{" "}
                      <span className="text-sm font-semibold">|</span>
                      <span className="text-sm font-semibold rounded-md text-white py-1 px-3 bg-[#3047EC]">
                        ${" "}
                        {(totalInvestedAmount == null ? 0 : totalInvestedAmount)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </span>
                    </div>
                  </div>
                  <div className="flex justify-between mt-4 flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
                    <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
                      <div className="flex items-center space-x-2">
                        <span className="lg:text-md  text-sm text-[#8C8C8C]">
                          Show Records
                        </span>
                        <Dropdown
                          label=""
                          options={filterOptions}
                          preselectedValue={preSelectedFilter}
                          onSelect={handleFilterChange}
                        />
                      </div>
                      <div className="flex items-center">
                        <div className="relative">
                          <input
                            type="text"
                            className="p-2 pl-8 border rounded-xl"
                            placeholder="Search Investors"
                            value={searchQuery}
                            onChange={(e) => {
                              setCurrentPage(1);
                              setSearchQuery(e.target.value);
                            }}
                          />
                          <span className="absolute left-2 top-3 text-gray-500">
                            {" "}
                            <img
                              src="/search-normal.svg"
                              alt="Company Logo"
                              className="mr-2"
                            />
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-col md:flex-row items-center space-x-0 md:space-x-4">
                      <div className="relative w-full md:w-full">
                        {/* Dropdown Button */}
                        <button
                          onClick={() => setIsOpenFilter(!isOpenFilter)}
                          className={`w-60 md:w-full border font-medium border-gray-300 h-10 rounded-xl text-sm px-2 py-2 pr-10 flex justify-between items-center focus:outline-none ${
                            isOpenFilter
                              ? "bg-black text-white"
                              : "bg-white text-black"
                          }`}
                        >
                          <div className="flex items-center">
                            {isOpenFilter ? (
                              <img
                                src="/filter-sort-white.svg"
                                alt="Filter Icon"
                                className="h-5 w-5 mr-2"
                              />
                            ) : (
                              <img
                                src="/filter-sort-black.svg"
                                alt="Filter Icon"
                                className="h-5 w-5 mr-2"
                              />
                            )}
                            Filter Status
                          </div>
                        </button>

                        {/* Dropdown List */}
                        {isOpenFilter && (
                          <div
                            className="absolute left-0 mt-2 overflow-y-auto mb-5 w-full bg-white border rounded-md shadow-lg z-50"
                            style={{
                              maxHeight: "200px", // Optional: limit height
                            }}
                          >
                            {allFilteraStatus.map((option) => (
                              <div
                                onClick={() => {
                                  setFilterStatus(option.value);
                                  setIsOpenFilter(false);
                                }}
                                key={option.value}
                                className="px-4 py-2 flex items-center hover:bg-black hover:text-white cursor-pointer"
                              >
                                {option.label}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      <div
                        ref={DownloadDocRef}
                        className="relative mt-2 w-full  md:mt-0 inline-block "
                      >
                        <div
                          className="flex justify-between items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                          onClick={() => setisOpenDownload(!isOpenDownload)}
                        >
                          <img
                            src="/document-download.svg"
                            alt="document-download"
                            className="mr-2"
                          />
                          <span>{selected}</span>
                          <span className="text-gray-500">
                            {" "}
                            <img
                              src="/download-small-arrow.svg"
                              alt="document-download"
                              className=""
                            />
                          </span>
                        </div>
                        {isOpenDownload && (
                          <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                            {options.map((option) => (
                              <li
                                key={option.value}
                                className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setLoading(true);
                                  downloadReports(e, option);
                                }}
                              >
                                {option.label}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    onScroll={() => setShowDownloadPopup(false)}
                    className="overflow-x-auto "
                  >
                    <table className="w-full h-full  border-separate pb-4 pt-4 border-[#EDEDED]  border-spacing-y-2">
                      {/* Table Header */}
                      <thead className="text-[#8C8C8C] text-sm">
                        <tr className="border border-[#EDEDED]">
                          {investorheaders.map((header) => (
                            <th
                              key={header.label}
                              onClick={() => handleSort(header.key)}
                              className="cursor-pointer w-40 font-medium px-4 py-2 border-b text-left"
                            >
                              {/* {header}
            <img src="/sort.svg" alt="sort icon" className="w-4 h-4 ml-2" /> */}
                              <div class="flex items-center">
                                <span>{header.label}</span>
                                {header.label != "" && (
                                  <img
                                    src="/sort.svg"
                                    alt="Icon"
                                    class="w-4 h-4 ml-2"
                                  />
                                )}
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>

                      {isLoading ? (
                        <tbody className="shimmer-container-list ">
                          {/* Creating 5 rows of shimmer effect */}
                          {[...Array(5)].map((_, rowIndex) => (
                            <tr key={rowIndex} className="shimmer-row-list">
                              {/* Creating 7 cells in each row for shimmer */}
                              {[...Array(4)].map((_, colIndex) => (
                                <td
                                  key={colIndex}
                                  className="shimmer-cell-list"
                                >
                                  <div className="shimmer-loader"></div>
                                </td>
                              ))}
                            </tr>
                          ))}
                        </tbody>
                      ) : (
                        <tbody className="text-sm font-medium text-black">
                          {investortableData.map((row) => (
                            <tr className="mb-2 bg-[#F9F9F9]">
                              {/* Dropdown Button */}
                              <td className="px-4 py-4 relative">
                                {formatDateList(row.request_date)}
                              </td>
                              <td className="px-4 py-2 relative">
                                <button
                                  ref={(el) =>
                                    (buttonRefs.current[
                                      `${row.investment_request_id}`
                                    ] = el)
                                  }
                                  disabled={
                                    row.status != "approved" ? false : true
                                  }
                                  onClick={() =>
                                    handleDropdownToggle(
                                      row.investment_request_id
                                    )
                                  }
                                  className={` w-40  font-medium h-10 rounded-xl text-sm px-2 py-2  flex justify-between items-center focus:outline-none${
                                    row.status == "pending"
                                      ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F1DCCD]"
                                      : ""
                                  }
                              ${
                                row.status == "approved"
                                  ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#93DB9C]"
                                  : ""
                              }
                              ${
                                row.status == "rejected"
                                  ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#E9BDBD]"
                                  : ""
                              }
                              `}
                                >
                                  <span className="mr-6">
                                    {" "}
                                    {row.status.charAt(0).toUpperCase() +
                                      row.status.slice(1)}
                                  </span>
                                  {row.status != "approved" && (
                                    <img
                                      src={`${
                                        openDropdown ===
                                        row.investment_request_id
                                          ? "/Vector.svg"
                                          : "/down-grey.svg"
                                      }`}
                                      alt="Selected"
                                      className="w-3 h-3 ml-4"
                                    />
                                  )}
                                </button>
                                <DropdownTest
                                  isOpen={
                                    openDropdown === row.investment_request_id
                                  }
                                  buttonRef={
                                    buttonRefs.current[
                                      `${row.investment_request_id}`
                                    ]
                                  } // Pass unique ref to the dropdown
                                >
                                  <div
                                    ref={dropdownRef}
                                    className="absolute left-0 bg-white rounded-md shadow-lg overflow-hidden z-50 w-full max-w-[200px] border"
                                    style={{
                                      position: "absolute",
                                      top: "100%",
                                      left: 0,
                                    }}
                                  >
                                    {AllStatus.map((option) => (
                                      <div
                                        key={option.value}
                                        onClick={(e) =>
                                          handleStatusChange(
                                            e,
                                            option,
                                            row.investment_request_id
                                          )
                                        }
                                        className={`px-4 py-2 p-3 w-30 mx-2 my-1 text-sm cursor-pointer flex items-center justify-between rounded-xl ${
                                          option.value === "approved"
                                            ? "border-2 border-[#34C046] text-[#34C046] bg-[#93DB9C] hover:bg-[#34C046] hover:text-white"
                                            : "border-2 border-[#FF5050] text-[#FF5050] bg-[#E9BDBD] hover:bg-[#FF5050] hover:text-white"
                                        }`}
                                      >
                                        <span>{option.label}</span>
                                      </div>
                                    ))}
                                  </div>
                                </DropdownTest>
                              </td>
                              <td
                                onClick={() =>
                                  handleUserClick(row.investment_request_id)
                                }
                                className="px-4 py-4 text-ellipsis  cursor-pointer overflow-hidden whitespace-nowrap"
                              >
                                {row.investor_name}
                              </td>

                              <td className="px-4 py-4 text-left text-ellipsis  overflow-hidden whitespace-nowrap">
                                $
                                {row.invested_amount
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              </td>

                              <td className="px-4 py-4 text-left">
                                $
                                {row.cash_account
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                              </td>
                              <td
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleViewApplications(
                                    e,
                                    row.investment_request_id
                                  );
                                  // setShowPopup(true)
                                }}
                                className="px-4 py-2  text-ellipsis  overflow-hidden whitespace-nowrap"
                              >
                                <span className="text-black bg-white px-2 py-2 cursor-pointer rounded-xl">
                                  View Applications
                                </span>
                              </td>
                              <td
                                onClick={(e) => {
                                  e.preventDefault();
                                  const rect =
                                    e.currentTarget.getBoundingClientRect();
                                  setPopupPosition({
                                    x: rect.left + 20,
                                    y: rect.bottom + window.scrollY,
                                  });
                                  setSelectedRow(row); // Save which row was clicked
                                  setShowDownloadPopup(true);
                                }}
                                className="px-4 py-2 text-ellipsis overflow-hidden whitespace-nowrap"
                              >
                                <span className="text-black bg-white px-2 py-2 cursor-pointer rounded-xl shadow hover:bg-gray-100 transition">
                                  Download Holding Valuation Report
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      )}
                      {showDownloadPopup && selectedRow && (
                        <div
                          className="absolute z-50 w-[72vw] max-w-[200px] bg-white border border-gray-300 rounded-md shadow-md p-3"
                          style={{
                            left: popupPosition.x,
                            top: popupPosition.y,
                          }}
                        >
                          {/* Header */}
                          <div className="flex justify-between items-start mb-1">
                            <h2 className="text-[13px] font-medium text-gray-800">
                              Download
                            </h2>
                            <button
                              onClick={() => setShowDownloadPopup(false)}
                              className="text-gray-500 hover:text-gray-700"
                              aria-label="Close"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-3 w-3"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth="2"
                                  d="M6 18L18 6M6 6l12 12"
                                />
                              </svg>
                            </button>
                          </div>

                          {/* Subtext */}
                          <p className="text-[11px] text-gray-500 mb-2">
                            Select format:
                          </p>

                          {/* Compact Buttons */}
                          <div className="flex flex-col gap-1">
                            <button
                              onClick={() => {
                                setShowDownloadPopup(false);
                                setLoading(true);
                                downloadValuationReport(
                                  "pdf",
                                  selectedRow.user_id,
                                  selectedRow.portfolio_id
                                );
                              }}
                              className="w-full px-3 py-1 text-xs font-medium bg-black text-white rounded-full transition"
                            >
                              PDF
                            </button>
                            <button
                              onClick={() => {
                                setShowDownloadPopup(false);
                                setLoading(true);
                                downloadValuationReport(
                                  "excel",
                                  selectedRow.user_id,
                                  selectedRow.portfolio_id
                                );
                              }}
                              className="w-full px-3 py-1 text-xs font-medium bg-black text-white rounded-full transition"
                            >
                              Excel
                            </button>
                          </div>
                        </div>
                      )}

                      {showPopup && (
                        <DocumentPopup
                          isOpen={showPopup}
                          onClose={() => setShowPopup(false)}
                          files={selectedFiles}
                        />
                      )}
                    </table>
                  </div>
                  {isUserPopOpen && (
                    <InvestorDetailPopup
                      investmentID={currentInvestmentId}
                      onClose={() => setisUserPopOpen(false)}
                    />
                  )}
                  {!isLoading && (
                    <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
                      {/* Entries Info Section */}
                      <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
                        Showing {showRecords * (currentPage - 1) + 1} to{" "}
                        {currentPage === totalPages || totalPages == 0
                          ? totalCount
                          : Math.max(
                              showRecords * currentPage,
                              investortableData.length
                            )}{" "}
                        of {totalCount} entries
                      </div>

                      {/* Pagination Section */}
                      <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
                        {/* Previous Button */}
                        <button
                          disabled={currentPage === 1}
                          onClick={() => setCurrentPage((prev) => prev - 1)}
                          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Prev
                        </button>

                        {/* Page Buttons */}
                        {Array.from({ length: Math.min(totalPages, 5) }).map(
                          (_, index) => {
                            const startPage = Math.max(
                              1,
                              Math.min(totalPages - 4, currentPage - 2)
                            );
                            const page = startPage + index;

                            return (
                              <button
                                key={page}
                                onClick={() => setCurrentPage(page)}
                                className={`px-3 py-1 rounded ${
                                  currentPage === page
                                    ? "bg-black text-white"
                                    : "bg-white border border-gray-300 text-black"
                                }`}
                              >
                                {page}
                              </button>
                            );
                          }
                        )}

                        {/* Next Button */}
                        <button
                          disabled={currentPage === totalPages}
                          onClick={() => setCurrentPage((prev) => prev + 1)}
                          className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {/* Input Section */}
              {!isCurrentInvestorSelected && (
                <div className=" mb-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                    <div className="flex  flex-col pr-4 pt-4">
                      <label
                        htmlFor="refId"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Client Id
                      </label>
                      <input
                        id="refId"
                        type="text"
                        value={clientId}
                        onBlur={handleBlurClientId}
                        onChange={(e) => setClientId(e.target.value)}
                        className={`border p-2 text-black font-medium rounded-md text-md ${
                          isClientExist || clientName == ""
                            ? "border-black"
                            : "border-[#FF5050]"
                        }`}
                        placeholder="C947534324"
                      />
                      <div className="flex bg-[#F9F9F9] rounded-md px-2 py-2 items-center mt-2 space-x-2">
                        <span className="text-sm text-labelColour font-medium">
                          Client Name:{" "}
                        </span>
                        {isClientExist && clientName && (
                          <img
                            src="/valid.svg" // Replace with your icon path
                            alt="User Icon"
                            className="w-4 h-4 "
                          />
                        )}
                        {!isClientExist && clientName && (
                          <img
                            src="/danger.svg" // Replace with your icon path
                            alt="User Icon"
                            className="w-4 h-4"
                          />
                        )}
                        <span
                          className={`text-sm ml-2 font-medium ${
                            isClientExist
                              ? "text-black text-sm"
                              : "text-[#FF5050] text-xs"
                          }`}
                        >
                          {clientName}
                        </span>
                      </div>
                    </div>
                    {/* center column */}
                    <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l  border-gray-300 pr-4 md:pl-4">
                      <label
                        htmlFor="refId"
                        className="mb-1 text-sm text-labelColour"
                      >
                        Creator Id
                      </label>
                      <input
                        id="refId"
                        type="text"
                        value={creatorId}
                        onBlur={handleBlurCreatorId}
                        onChange={(e) => {
                          setCreatorId(e.target.value);
                        }}
                        className={`border p-2 text-black font-medium rounded-md text-md ${
                          isCreatorExist || creatorName == ""
                            ? "border-black"
                            : "border-[#FF5050]"
                        }`}
                        placeholder="C947534324"
                      />
                      <div className="flex bg-[#F9F9F9] rounded-md px-2 py-2 items-center mt-2 space-x-2">
                        <span className="text-sm text-labelColour font-medium">
                          Creator Name:{" "}
                        </span>
                        {isCreatorExist && creatorName && (
                          <img
                            src="/valid.svg" // Replace with your icon path
                            alt="User Icon"
                            className="w-4 h-4"
                          />
                        )}
                        {!isCreatorExist && creatorName && (
                          <img
                            src="/danger.svg" // Replace with your icon path
                            alt="User Icon"
                            className="w-4 h-4"
                          />
                        )}
                        <span
                          className={` text-ellipsis  overflow-hidden whitespace-nowrap font-medium ${
                            isCreatorExist
                              ? "text-black text-sm"
                              : "text-[#FF5050] text-xs"
                          }`}
                        >
                          {creatorName}
                        </span>
                      </div>
                    </div>
                    {/* Left column */}
                    <div className="flex lg:pt-4 pt-0 flex-col px-4"></div>
                  </div>

                  {/* Add Investor Button */}
                  <button
                    disabled={isClientExist && isCreatorExist ? false : true}
                    onClick={addInvestorDetail}
                    className={`mt-6 px-4 py-2 rounded-full ${
                      isClientExist && isCreatorExist
                        ? "bg-black text-white"
                        : "bg-gray-300 text-gray-600"
                    }`}
                  >
                    Add Investor
                  </button>
                </div>
              )}
            </div>
            {/* Investor Details */}
            {!isCurrentInvestorSelected && isInvestorAvailable && (
              <div className="bg-white p-6 mt-4 rounded-lg shadow ">
                <h3 className="text-md font-semibold mb-4 pb-2 border-b">
                  Investor Details
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                  <div className="flex flex-col px-4 pt-4">
                    <div>
                      <span className="block text-labelColour] text-sm">
                        First Name
                      </span>
                      <span className="font-medium">
                        {investorClientFirstName}
                      </span>
                    </div>
                    <div>
                      <span className="block  mt-4 text-labelColour text-sm">
                        Last Name
                      </span>
                      <span className="font-medium">
                        {investorClientLastName}
                      </span>
                      <span className="block mt-4 text-labelColour text-sm">
                        ABN
                      </span>
                      <span className="font-medium">{investorClientAbn}</span>
                    </div>
                  </div>
                  {/* center column */}
                  <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                    <div>
                      <span className="block text-labelColour text-sm">
                        Email
                      </span>
                      <span className="font-medium">{investorClientEmail}</span>
                    </div>
                    <div>
                      <span className="block mt-4 text-labelColour text-sm">
                        Mobile Number
                      </span>
                      <span className="font-medium">{investorClientPhone}</span>
                    </div>
                  </div>
                  {/* Left column */}
                  <div className="flex lg:pt-2 pt-0 flex-col px-4">
                    <Dropdown
                      label="Investment Manager Settlement account"
                      options={newClientAccountData}
                      preselectedValue={preSelectedClientAccount}
                      onSelect={handleSelectClientAccount}
                    />
                    <div>
                      <span className="block mt-2 text-labelColour text-sm">
                        Account Balance
                      </span>
                      <span className="font-medium">
                        {" "}
                        $
                        {clientAccountBalance
                          ? clientAccountBalance
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          : "0.00"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* Portfolio Breakdown */}
            {!isCurrentInvestorSelected && (
              <div className="bg-white p-6 rounded-lg shadow mt-4">
                <div className="flex justify-between items-center border-b mb-4">
                  <h3 className="text-md font-semibold mb-2 ">
                    Portfolio Breakdown
                  </h3>
                </div>

                {/* Investment Amount */}
                <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0 mb-4">
                  {/* Left Section: Input Field and Button */}
                  <div className="flex flex-col w-full md:w-1/3 lg:w-1/4">
                    {/* Label */}
                    <label
                      htmlFor="investmentAmount"
                      className="text-sm font-medium text-labelColour mb-2"
                    >
                      Investment Amount
                    </label>

                    {/* Input and Button Section */}
                    <div className="flex items-center space-x-2">
                      {/* Input Field */}
                      <div className="relative flex-grow">
                        {/* Dollar Icon */}
                        <span className="absolute inset-y-0 left-2 flex items-center text-gray-500">
                          $
                        </span>
                        <input
                          id="investmentAmount"
                          ref={inputRef}
                          type="text"
                          value={formatNumber(investmentAmount)}
                          onChange={handleInputChange}
                          onBlur={handleBlur}
                          className="pl-6 pr-3 py-2 border border-gray-300 rounded-md text-right w-full md:w-40"
                        />
                      </div>

                      {/* View Breakdown Button */}
                      <button
                        disabled={portfolioDataAvailable ? true : false}
                        onClick={(e) => {
                          e.preventDefault();
                          if (investmentAmount == 0) {
                            showToast("Please enter the valid amount", "error");
                            return;
                          }
                          setLoading(true);
                          viewBrekdown(e);
                        }}
                        className="bg-black text-white px-4 py-2 text-sm rounded-full whitespace-nowrap"
                      >
                        View Breakdown
                      </button>
                    </div>
                  </div>

                  {/* Right Section: Download Report */}
                  <div className="flex items-center justify-end w-60 md:w-1/3 lg:w-1/4">
                    {portfolioData &&
                      portfolioData.length > 0 &&
                      portfolioDataAvailable && (
                        <div
                          ref={DownloadDocBreakdownRef}
                          className="relative mt-6"
                        >
                          {/* Dropdown Button */}
                          <div
                            className="flex justify-between w-60 items-center px-3 py-2 border border-gray-300 rounded-md cursor-pointer"
                            onClick={() =>
                              setisOpenInvestorDropdown(!isOpenInvestorDropdown)
                            }
                          >
                            <img
                              src="/document-download.svg"
                              alt="Download Icon"
                              className="w-4 h-4 mr-2"
                            />
                            <span className="flex-grow truncate">
                              {selectedInvestorReport}
                            </span>
                            <img
                              src="/download-small-arrow.svg"
                              alt="Chevron Down"
                              className="w-3 h-3 text-gray-500"
                            />
                          </div>

                          {/* Dropdown Options */}
                          {isOpenInvestorDropdown && (
                            <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                              {options.map((option) => (
                                <li
                                  key={option.value}
                                  className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setLoading(true);
                                    downloadReportsBreakdown(e, option);
                                  }}
                                >
                                  {option.label}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      )}
                  </div>
                </div>

                {/* Table */}
                {portfolioDataAvailable && (
                  <div className="overflow-x-auto">
                    <table className="table-auto border-collapse w-full text-sm">
                      <thead>
                        <tr className="bg-[#6AA7D3] text-white font-semibold">
                          <th className="border border-white  px-4 py-2">No</th>
                          <th className="border border-white  px-4 py-2">
                            Strategic Asset Allocation
                          </th>
                          <th className="border border-white  px-4 py-2">
                            Code
                          </th>
                          <th className="border border-white  px-4 py-2">
                            SAA
                          </th>
                          <th className="border border-white  px-4 py-2">
                            Capital
                          </th>
                          <th className="border bg-[#F4D580]  border-white  px-4 py-2">
                            Market Price
                          </th>
                          <th className="border border-white  px-4 py-2">
                            Shares
                          </th>
                          <th className="border border-white  px-4 py-2">
                            Value ($)
                          </th>
                          <th className="border border-white  px-4 py-2">
                            Brokerage
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {portfolioData.map((categoryData, categoryIndex) => (
                          <React.Fragment key={categoryIndex}>
                            {/* Category Row */}
                            <tr
                              className={`px-6 py-2 rounded-lg ${
                                categoryData.category.name.toUpperCase() ==
                                "GROWTH"
                                  ? "bg-[#92C5EA]"
                                  : "bg-[#A9D4AB]"
                              }`}
                            >
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              >
                                {categoryData.category.name.toUpperCase()}
                              </td>
                              <td
                                colSpan={1}
                                className="border border-white  px-4 py-2 font-bold"
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white bg-[#F4D580]  px-4 py-2 font-bold"
                              ></td>
                              <td
                                colSpan={1}
                                className={`border border-white px-4 py-2 font-bold ${
                                  categoryData.category.name.toUpperCase() ==
                                  "GROWTH"
                                    ? ""
                                    : "bg-[#F8C5C5]"
                                }`}
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              ></td>
                              <td
                                colSpan={1}
                                className="border border-white px-4 py-2 font-bold"
                              ></td>
                            </tr>

                            {/* Products */}
                            {categoryData.category.products.map(
                              (product, productIndex) => (
                                <React.Fragment key={productIndex}>
                                  {/* Product Row */}
                                  <tr
                                    className={`text-[#005A9C] ${
                                      categoryData.category.name.toUpperCase() ==
                                      "GROWTH"
                                        ? "bg-[#C6DFF1]"
                                        : "bg-[#C0E2C1]"
                                    }`}
                                  >
                                    <td
                                      colSpan={1}
                                      className="border border-white px-4 py-2 font-bold"
                                    >
                                      {(productIndex + 1)
                                        .toString()
                                        .padStart(2, "0")}
                                    </td>
                                    <td
                                      colSpan={1}
                                      className="border border-white px-4 py-2 font-semibold"
                                    >
                                      {product.name}
                                    </td>
                                    <td
                                      colSpan={1}
                                      className="border border-white px-4 py-2 font-semibold"
                                    ></td>
                                    <td
                                      colSpan={1}
                                      className="border border-white px-4 py-2 font-bold"
                                    >
                                      {product.allocation
                                        .toFixed(2)
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                      %
                                    </td>
                                    <td
                                      colSpan={1}
                                      className="border border-white px-4 py-2 font-bold"
                                    >
                                      {product.capital
                                        .toFixed(2)
                                        .toString()
                                        .replace(
                                          /\B(?=(\d{3})+(?!\d))/g,
                                          ","
                                        ) || "-"}
                                    </td>
                                    <td
                                      colSpan={1}
                                      className="border border-white bg-[#F4D580] px-4 py-2 font-bold"
                                    ></td>
                                    <td
                                      colSpan={1}
                                      className="border border-white bg-[#F8C5C5] px-4 py-2 font-bold"
                                    ></td>
                                    <td
                                      colSpan={1}
                                      className="border border-white px-4 py-2 font-bold"
                                    ></td>
                                    <td
                                      colSpan={1}
                                      className="border border-white px-4 py-2 font-bold"
                                    ></td>
                                  </tr>

                                  {/* Stocks */}
                                  {product.stocks.map((stock, stockIndex) => (
                                    <tr
                                      key={stockIndex}
                                      className={`text-[#black] ${
                                        categoryData.category.name.toUpperCase() ==
                                        "GROWTH"
                                          ? "bg-[#E6F3FC]"
                                          : "bg-[#E7F5E8]"
                                      }`}
                                    >
                                      <td className="border border-white px-4 py-2"></td>
                                      <td className="border border-white px-4 py-2">
                                        {stock.name}
                                      </td>
                                      <td className="border border-white px-4 py-2">
                                        {stock.asx_code}
                                      </td>
                                      <td className="border border-white px-4 py-2">
                                        {stock.allocation.toFixed(2)}%{" "}
                                        {!stock.allocation ? "-" : ""}
                                      </td>
                                      <td className="border border-white px-4 py-2">
                                        {stock.capital
                                          .toFixed(2)
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          ) || "-"}
                                      </td>
                                      <td className="border border-white bg-[#F4D580]  px-4 py-2">
                                        {Number(stock.market_value)
                                          .toFixed(2)
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          ) || "-"}
                                      </td>
                                      <td className="border border-white bg-[#F8C5C5] px-4 py-2">
                                        {!stock.quantity
                                          ? "00"
                                          : stock.quantity
                                              .toString()
                                              .replace(
                                                /\B(?=(\d{3})+(?!\d))/g,
                                                ","
                                              )}
                                      </td>
                                      <td className="border border-white px-4 py-2">
                                        {Number(stock.market_value)
                                          .toFixed(2)
                                          .toString()
                                          .replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          ) || "-"}
                                      </td>
                                      <td className="border border-white px-4 py-2">
                                        {!stock.brokerage_fee
                                          ? "-"
                                          : stock.brokerage_fee.toFixed(2)}
                                      </td>
                                    </tr>
                                  ))}
                                </React.Fragment>
                              )
                            )}
                            <tr
                              className={`font-bold ${
                                categoryData.category.name.toUpperCase() ==
                                "GROWTH"
                                  ? "bg-[#92C5EA]"
                                  : "bg-[#A9D4AB]"
                              }`}
                            >
                              <td colSpan={1} className="border px-4 py-2"></td>
                              <td colSpan={2} className="border px-4 py-2">
                                SUB-TOTAL {categoryData.category.name}
                              </td>
                              <td colSpan={1} className="border px-4 py-2">
                                {categoryData.category.allocation || "-"}
                              </td>
                              <td colSpan={1} className="border px-4 py-2">
                                {categoryData.category.capital
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"}
                              </td>
                              <td
                                colSpan={1}
                                className="border bg-[#F4D580]  px-4 py-2"
                              ></td>
                              <td
                                colSpan={1}
                                className={`border px-4 py-2 ${
                                  categoryData.category.name.toUpperCase() ==
                                  "GROWTH"
                                    ? "bg-[#F8C5C5]"
                                    : ""
                                }`}
                              ></td>
                              <td
                                colSpan={1}
                                className="border px-4 py-2 text-right"
                              >
                                {Number(categoryData.category.market_value)
                                  .toFixed(2)
                                  .toString()
                                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"}
                              </td>
                              <td
                                colSpan={1}
                                className="border px-4 py-2 text-right"
                              ></td>
                            </tr>

                            {categoryData.category.name.toUpperCase() ==
                              "GROWTH" && (
                              <tr className="bg-[#EAEAEA] font-bold">
                                <td
                                  colSpan={1}
                                  className="border px-4 py-2 text-right"
                                ></td>
                                <td
                                  colSpan={2}
                                  className="border px-4 py-2"
                                ></td>
                                <td
                                  colSpan={1}
                                  className="border px-4 py-2"
                                ></td>
                                <td
                                  colSpan={1}
                                  className="border px-4 py-2"
                                ></td>
                                <td
                                  colSpan={1}
                                  className="border   px-4 py-2 text-right"
                                ></td>
                                <td
                                  colSpan={1}
                                  className="border px-4 py-2 text-right"
                                ></td>
                                <td
                                  colSpan={1}
                                  className="border px-4 py-2 text-right"
                                ></td>
                                <td
                                  colSpan={1}
                                  className="border px-4 py-2 text-right"
                                ></td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))}
                        <React.Fragment>
                          <tr className="bg-[#EAEAEA] font-bold">
                            <td
                              colSpan={1}
                              className="border px-4 py-2 text-right"
                            ></td>
                            <td colSpan={2} className="border px-4 py-2">
                              Summary
                            </td>
                            <td colSpan={1} className="border px-4 py-2"></td>
                            <td colSpan={1} className="border px-4 py-2"></td>
                            <td
                              colSpan={1}
                              className="border bg-[#F4D580]  px-4 py-2 text-right"
                            ></td>
                            <td
                              colSpan={1}
                              className="border px-4 py-2 text-right"
                            ></td>
                            <td
                              colSpan={1}
                              className="border px-4 py-2 text-right"
                            ></td>
                            <td
                              colSpan={1}
                              className="border px-4 py-2 text-right"
                            ></td>
                          </tr>
                          <tr className="bg-[#92C5EA]  font-bold">
                            <td
                              colSpan={1}
                              className="border px-4 py-2 text-right"
                            ></td>
                            <td colSpan={2} className="border px-4 py-2">
                              {portfolioData[0].category.name}
                            </td>
                            <td colSpan={1} className="border px-4 py-2">
                              {portfolioData[0].category.allocation || "-"}
                            </td>
                            <td colSpan={1} className="border px-4 py-2">
                              {portfolioData[0].category.capital
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"}
                            </td>
                            <td
                              colSpan={1}
                              className="border bg-[#F4D580]  px-4 py-2"
                            ></td>
                            <td colSpan={1} className="border px-4 py-2"></td>
                            <td colSpan={1} className="border px-4 py-2">
                              {Number(portfolioData[0].category.market_value)
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"}
                            </td>
                            <td colSpan={1} className="border px-4 py-2 ">
                              {portfolioData[0].category.category_brokerage_fee.toFixed(
                                2
                              ) || "-"}
                            </td>
                          </tr>
                          <tr className="bg-[#A9D4AB] font-bold">
                            <td colSpan={1} className="border px-4 py-2 "></td>
                            <td colSpan={2} className="border px-4 py-2">
                              {portfolioData[1].category.name}
                            </td>
                            <td colSpan={1} className="border px-4 py-2">
                              {portfolioData[1].category.allocation || "-"}
                            </td>
                            <td colSpan={1} className="border px-4 py-2">
                              {portfolioData[1].category.capital
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"}
                            </td>
                            <td
                              colSpan={1}
                              className="border bg-[#F4D580]  px-4 py-2 text-right"
                            ></td>
                            <td colSpan={1} className="border px-4 py-2"></td>
                            <td colSpan={1} className="border px-4 py-2">
                              {Number(portfolioData[1].category.market_value)
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"}
                            </td>
                            <td colSpan={1} className="border px-4 py-2">
                              {portfolioData[1].category.category_brokerage_fee.toFixed(
                                2
                              ) || "-"}
                            </td>
                          </tr>
                          <tr className="bg-[#CDCDCD] font-bold">
                            <td colSpan={1} className="border px-4 py-2"></td>
                            <td colSpan={2} className="border px-4 py-2">
                              TOTAL PORTFOLIO
                            </td>
                            <td colSpan={1} className="border px-4 py-2">
                              {portfolioData[0].category.allocation +
                                portfolioData[1].category.allocation || "-"}
                            </td>
                            <td colSpan={1} className="border px-4 py-2">
                              {(
                                portfolioData[0].category.capital +
                                portfolioData[1].category.capital
                              )
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"}
                            </td>
                            <td
                              colSpan={1}
                              className="border bg-[#F4D580]  px-4 py-2"
                            ></td>
                            <td colSpan={1} className="border px-4 py-2"></td>
                            <td colSpan={1} className="border px-4 py-2">
                              {Number(
                                portfolioData[0].category.market_value +
                                  portfolioData[1].category.market_value
                              )
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",") || "-"}
                            </td>
                            <td colSpan={1} className="border px-4 py-2">
                              {(
                                portfolioData[0].category
                                  .category_brokerage_fee +
                                portfolioData[1].category.category_brokerage_fee
                              ).toFixed(2) || "-"}
                            </td>
                          </tr>
                        </React.Fragment>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
        {filter == "details" && (
          <div className="w-full  p-4 bg-white rounded-lg shadow-lg">
            <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
              <h1 className="text-lg font-medium mb-2">
                Caprock Model Portfolio - {investmentProductName}
              </h1>
            </div>
            <div className="mt-2 border rounded-md">
              <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                <h1 className="text-md font-medium mb-2 text-black text-center">
                  Basic Details
                </h1>
                {/* Edit Icon on the Right */}
                <img
                  onClick={togglePopup}
                  src="/edit-details.svg" // Replace with the actual path to your edit icon
                  alt="Edit Icon"
                  className="w-4 h-4 cursor-pointer"
                />
              </div>
              {isOpen && (
                <div className="fixed inset-0   flex items-center justify-center bg-black bg-opacity-50 z-50">
                  <div className="bg-white h-[90vh] rounded-lg w-[90%] max-w-[700px] p-6 md:max-h-screen md:h-auto  overflow-y-auto">
                    {/* Modal Header */}
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-lg font-medium text-center w-full">
                        Caprock Model Portfolio -{" "}
                        <br className="hidden md:block" />{" "}
                        {investmentProductName}
                      </h2>
                      <button onClick={togglePopup}>
                        <img
                          src="/add.svg"
                          alt="Close"
                          className="w-8 h-8 md:w-10 md:h-10"
                        />
                      </button>
                    </div>

                    {/* Modal Content */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      {/* Left Side */}
                      <div className="space-y-4 md:border-r-2 md:pr-4">
                        <Dropdown
                          label="Investment Manager"
                          options={users}
                          onSelect={handleSelectInvestmentManager}
                          preselectedValue={preselectedManager}
                          search={true}
                        />

                        <Dropdown
                          label="Change Account"
                          options={InvestmentManagerAccountData}
                          onSelect={handleSelectInvestmentManagerAccount}
                          preselectedValue={preselectedManagerAccount}
                        />

                        <Dropdown
                          label="Select Advisor"
                          options={users}
                          onSelect={handleSelectAdvisor}
                          preselectedValue={preselectedAdvisor}
                          search={true}
                        />

                        <Dropdown
                          label="Change Account"
                          options={AdvisorAccountData}
                          onSelect={handleSelectAdvisorAccount}
                          preselectedValue={preselectedAdvisorAccount}
                        />
                      </div>

                      {/* Right Side */}
                      <div className="space-y-4 md:border-r-2 md:pr-4">
                        <Dropdown
                          label="Sub Advisor"
                          options={users}
                          preselectedValue={preselectedSubAdvisor}
                          onSelect={handleSelectSubAdvisor}
                          search={true}
                        />
                        <Dropdown
                          label="Change Account"
                          options={SubAdvisorAccountData}
                          onSelect={handleSelectSubAdvisorAccount}
                          preselectedValue={preselectedSubAdvisorAccount}
                        />

                        <Dropdown
                          label="Platform"
                          options={users}
                          onSelect={handleSelectPlatform}
                          preselectedValue={preselectedPlatform}
                          search={true}
                        />
                        <Dropdown
                          label="Settlement Account"
                          options={SettlementAccountData}
                          onSelect={handleSelectSettlementAccount}
                          preselectedValue={preselectedPlatformAccount}
                        />
                      </div>
                      <div className="space-y-4  md:pr-4">
                        <Dropdown
                          label="Select Asset Manager"
                          options={users}
                          onSelect={handleSelectAssetManager}
                          preselectedValue={preSelectedAssetManager}
                          search={true}
                        />

                        <Dropdown
                          label="Change Account"
                          options={AssetManagerAccountData}
                          onSelect={handleSelectAssetManagerAccount}
                          preselectedValue={preselectedAssetManagerAccount}
                        />
                        <Dropdown
                          label="Select Custodian"
                          options={users}
                          onSelect={handleSelectCustodian}
                          preselectedValue={preselectedCustodian}
                          search={true}
                        />

                        <Dropdown
                          label="Change Account"
                          options={CustodianAccountData}
                          onSelect={handleSelectCustodianAccount}
                          preselectedValue={preselectedCustodianAccount}
                        />
                      </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="flex flex-col md:flex-row justify-center md:space-x-4 space-y-2 md:space-y-0 mt-6">
                      <button
                        onClick={togglePopup}
                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                      >
                        Cancel
                      </button>
                      <button
                        disabled={isNewChange}
                        onClick={(e) => {
                          e.preventDefault();
                          if (investmentManagerId == null) {
                            showToast(
                              "Please select Investment Manager",
                              "error"
                            );
                            return;
                          }
                          if (InvestmentManagerAccount == null) {
                            showToast("Please select Manager account", "error");
                            return;
                          }
                          if (platformId == null) {
                            showToast("Please select Platform", "error");
                            return;
                          }
                          if (platformAccount == null) {
                            showToast(
                              "Please select Platform account",
                              "error"
                            );
                            return;
                          }
                          if (advisorId != null && advisorAccount == null) {
                            showToast("Please select Advisor Account", "error");
                            return;
                          }
                          if (
                            subadvisorId != null &&
                            subAdvisorAccount == null
                          ) {
                            showToast(
                              "Please select Sub Advisor Account",
                              "error"
                            );
                            return;
                          }
                          if (custodianId != null && custodianAccount == null) {
                            showToast(
                              "Please select Custodian Account",
                              "error"
                            );
                            return;
                          }
                          if (
                            assetManagerId != null &&
                            assetManagerAccount == null
                          ) {
                            showToast(
                              "Please select Asset Manager Account",
                              "error"
                            );
                            return;
                          }
                          setLoading(true);
                          handleCreateInvestment(e);
                        }}
                        className={`px-6 py-2 rounded-lg ${
                          isNewChange
                            ? "bg-gray-400"
                            : "bg-black text-white hover:bg-gray-800"
                        }`}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div className="flex flex-col px-4 pt-4">
                  <label
                    htmlFor="refId"
                    className="mb-1 text-sm text-[#A6A6A6]"
                  >
                    Ref ID
                  </label>
                  <span>{refId}</span>
                  <div className="mt-4">
                    <label
                      htmlFor="investmentType"
                      className="mb-1 text-sm text-[#A6A6A6]"
                    >
                      strategy Type
                    </label>
                    <div>{strategyType}</div>
                  </div>
                  <div className="mt-4">
                    <label
                      htmlFor="investmentType"
                      className="mb-1  text-sm text-[#A6A6A6]"
                    >
                      Risk Profile
                    </label>
                    <div>{riskProfile}</div>
                  </div>
                  <label
                    htmlFor="investmentType"
                    className="mb-1 mt-4 text-sm text-[#A6A6A6]"
                  >
                    Investment Type
                  </label>
                  <div>{investmentType}</div>
                  <label
                    htmlFor="investmentType"
                    className="mb-1 mt-4 text-sm text-[#A6A6A6]"
                  >
                    Custodian
                  </label>
                  <div>{custodianNameFromAPI}</div>
                </div>
                {/* center column */}
                <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 text-sm"
                  >
                    <span className="text-[#A6A6A6]">Investment Manager</span>
                  </label>
                  <div>{investmentManagerNamefromAPI}</div>

                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 mt-4 text-sm"
                  >
                    <span className="text-[#A6A6A6]">
                      Investment Manager Settlement Account
                    </span>
                  </label>
                  <span>{investmentManagerAccountfromAPI}</span>
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 mt-4 text-sm"
                  >
                    <span className="text-[#A6A6A6]">Sub Advisor</span>
                  </label>
                  <div>{subadvisorIdfromAPI}</div>

                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 mt-4 text-sm"
                  >
                    <span className="text-[#A6A6A6]">
                      Sub Advisor Settlement Account
                    </span>
                  </label>
                  <div>{subAdvisorAccountfromAPI}</div>
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 mt-4 text-sm"
                  >
                    <span className="text-[#A6A6A6]">Advisor</span>
                  </label>
                  <div>{advisorIdfromAPI}</div>
                </div>
                {/* Left column */}
                <div className="flex lg:pt-4 pt-0 flex-col px-4">
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1  text-sm"
                  >
                    <span className="text-[#A6A6A6]">
                      Advisor Settlement Account
                    </span>
                  </label>
                  <div>{advisorAccountfromAPI}</div>
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 mt-4 text-sm"
                  >
                    <span className="text-[#A6A6A6]">Entity</span>
                  </label>
                  <div>{platformIdfromAPI}</div>
                  <label
                    htmlFor="investmentManagerFees"
                    className="mt-4 mb-1 text-sm"
                  >
                    <span className="text-[#A6A6A6]">Settlement Account</span>
                  </label>
                  <div>{platformAccountfromAPI}</div>
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 mt-4 text-sm"
                  >
                    <span className="text-[#A6A6A6]">Asset Manager</span>
                  </label>
                  <div>{assetManagerNamefromAPI}</div>
                  <label
                    htmlFor="investmentManagerFees"
                    className=" mb-1 mt-4 text-sm"
                  >
                    <span className="text-[#A6A6A6]">
                      Asset Manager Account
                    </span>
                  </label>
                  <div>{assetManagerAccountfromAPI}</div>
                </div>
              </div>

              {/* Fund Objective & Process Section */}
              <div className="mt-6 mb-4 px-4">
                <label
                  htmlFor="fundObjective"
                  className="block mb-1 text-sm text-[#A6A6A6]"
                >
                  Fund Objective & Process
                </label>
                <div
                  dangerouslySetInnerHTML={{ __html: fundObjectives }}
                  className=" overflow-y-auto max-h-[400px] prose prose-sm sm:prose-base dark:prose-invert max-w-none text-sm leading-relaxed list-decimal list-inside"
                ></div>
                <style jsx>{`
                  ol {
                    list-style-type: decimal;
                    padding-left: 1.25rem;
                  }

                  ul {
                    list-style-type: disc;
                    padding-left: 1.25rem;
                  }
                `}</style>
              </div>
            </div>
          </div>
        )}

        {filter == "details" && (
          <div>
            <div className="w-full p-4 mt-6 bg-white rounded-lg shadow-lg">
              <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
                <h1 className="text-lg font-medium mb-2">
                  Caprock Model Portfolio - {investmentProductName}
                </h1>
              </div>
              <div className="mt-2 border  rounded-md">
                <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                  <h1 className="text-md font-medium mb-2 text-black text-center">
                    Investment Details
                  </h1>
                  {/* Edit Icon on the Right */}
                  <img
                    onClick={togglePopupEdit}
                    src="/edit-details.svg"
                    alt="Edit Icon"
                    className="w-4 h-4 cursor-pointer"
                  />
                </div>
                {isOpenEdit && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white h-[90vh] rounded-lg w-[90%] max-w-[700px] p-6 md:max-h-screen md:h-auto  overflow-y-auto">
                      {/* Modal Header */}
                      <div className="flex items-center border-b-2 justify-between mb-6">
                        <h2 className="text-lg font-medium text-center w-full">
                          Caprock Model Portfolio - <br />{" "}
                          {investmentProductName}
                        </h2>
                        <button onClick={togglePopupEdit}>
                          <img
                            src="/add.svg"
                            alt="Close"
                            className="w-10 h-10"
                          />
                        </button>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        {/* Left Side */}
                        <div className="space-y-4 md:border-r-2 md:pr-4">
                          <div>
                            <label
                              htmlFor="smaFees"
                              className="block mb-1 text-sm"
                            >
                              <span className="text-labelColour">
                                SMA Fees %
                              </span>
                              <br />
                              <span className="text-[#868686] text-xs">
                                Including GST
                              </span>
                            </label>
                            <div className="relative">
                              <input
                                type="number"
                                value={smaFeesUpdate}
                                onChange={(e) => {
                                  setsmaFeesUpdate(e.target.value);
                                  setisNewChangeFees(false);
                                }}
                                className="p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md block"
                              />
                              <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                                %
                              </span>
                            </div>
                          </div>
                          {/* Investment Manager Fees */}
                          <div>
                            <label
                              htmlFor="investmentFees"
                              className="block mb-1 text-sm"
                            >
                              <span className="text-labelColour">
                                Investment Manager Fees %
                              </span>
                              <br />
                              <span className="text-[#868686] text-xs">
                                Weighted Average
                              </span>
                            </label>
                            <div className="relative">
                              <input
                                type="number"
                                value={managerFeesUpdate}
                                disabled={
                                  investmentManagerId == null ? true : false
                                }
                                onChange={(e) => {
                                  setmanagerFeesUpdate(e.target.value);
                                  setisNewChangeFees(false);
                                }}
                                className={`${
                                  investmentManagerId == null
                                    ? "bg-gray-200"
                                    : "bg-white"
                                } p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md block`}
                              />
                              <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                                %
                              </span>
                            </div>
                          </div>
                          {/* Sub Advisor Fees */}
                          <div>
                            <label
                              htmlFor="subAdvisorFees"
                              className="block mb-1 text-sm"
                            >
                              <span className="text-labelColour">
                                Advisor Fees %
                              </span>
                            </label>
                            <div className="relative">
                              <input
                                type="number"
                                value={advisorFeesUpdate}
                                disabled={advisorId == null ? true : false}
                                onChange={(e) => {
                                  setadvisorFeesUpdate(e.target.value);
                                  setisNewChangeFees(false);
                                }}
                                className={`${
                                  advisorId == null ? "bg-gray-200" : "bg-white"
                                } p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md block`}
                              />
                              <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                                %
                              </span>
                            </div>
                          </div>
                        </div>

                        {/* Right Side */}
                        <div className="space-y-4  md:border-r-2 md:pr-4">
                          <div>
                            <label
                              htmlFor="smaFees"
                              className="block mb-1 text-sm"
                            >
                              <span className="text-labelColour">
                                Sub Advisor Fees %
                              </span>
                              <br />
                              <span className="text-[#868686] text-xs">
                                Including GST
                              </span>
                            </label>
                            <div className="relative">
                              <input
                                type="number"
                                value={subadvisorFeesUpdate}
                                disabled={subadvisorId == null ? true : false}
                                onChange={(e) => {
                                  setsubadvisorFeesUpdate(e.target.value);
                                  setisNewChangeFees(false);
                                }}
                                className={`${
                                  subadvisorId == null
                                    ? "bg-gray-200"
                                    : "bg-white"
                                } p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md block`}
                              />
                              <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                                %
                              </span>
                            </div>
                          </div>
                          {/* Investment Manager Fees */}
                          <div>
                            <label
                              htmlFor="investmentFees"
                              className="block mb-1 text-sm"
                            >
                              <span className="text-labelColour">
                                Platform Fees %
                              </span>
                              <br />
                              <span className="text-[#868686] text-xs">
                                Weighted Average
                              </span>
                            </label>
                            <div className="relative">
                              <input
                                type="number"
                                value={platformFeesUpdate}
                                disabled={platformId == null ? true : false}
                                onChange={(e) => {
                                  setplatformFeesUpdate(e.target.value);
                                  setisNewChangeFees(false);
                                }}
                                className={`${
                                  platformId == null
                                    ? "bg-gray-200"
                                    : "bg-white"
                                } p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md block`}
                              />
                              <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                                %
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="space-y-4  md:pr-4">
                          <div>
                            <label
                              htmlFor="subAdvisorFees"
                              className="block mb-1 text-sm"
                            >
                              <span className="text-labelColour">
                                Custodian Fees %
                              </span>
                            </label>
                            <div className="relative">
                              <input
                                type="number"
                                value={custodianFeesUpdate}
                                disabled={custodianId == null ? true : false}
                                onChange={(e) => {
                                  setcustodianFeesUpdate(e.target.value);
                                  setisNewChangeFees(false);
                                }}
                                className={`${
                                  custodianId == null
                                    ? "bg-gray-200"
                                    : "bg-white"
                                } p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md block`}
                              />
                              <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                                %
                              </span>
                            </div>
                          </div>
                          <div>
                            <label
                              htmlFor="subAdvisorFees"
                              className="block mb-1 text-sm"
                            >
                              <span className="text-labelColour">
                                Asset Manager Fees %
                              </span>
                            </label>
                            <div className="relative">
                              <input
                                type="number"
                                value={assetManagerFeesUpdate}
                                disabled={assetManagerId == null ? true : false}
                                onChange={(e) => {
                                  setassetManagerFeesUpdate(e.target.value);
                                  setisNewChangeFees(false);
                                }}
                                className={`${
                                  assetManagerId == null
                                    ? "bg-gray-200"
                                    : "bg-white"
                                } p-2 text-black w-full font-medium border border-gray-300 rounded-md text-md block`}
                              />
                              <span className="absolute inset-y-0 right-3 flex items-center text-gray-600">
                                %
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Modal Footer */}
                      <div className="flex justify-center space-x-4 mt-6">
                        <button
                          onClick={togglePopupEdit}
                          className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                        >
                          Cancel
                        </button>
                        <button
                          disabled={isNewChangeFees}
                          onClick={(e) => {
                            e.preventDefault();
                            if (investmentManagerId == null) {
                              showToast(
                                "Please select Investment Manager",
                                "error"
                              );
                              return;
                            }
                            if (InvestmentManagerAccount == null) {
                              showToast(
                                "Please select Manager account",
                                "error"
                              );
                              return;
                            }
                            if (platformId == null) {
                              showToast("Please select Platform", "error");
                              return;
                            }
                            if (platformAccount == null) {
                              showToast(
                                " Please select Platform account",
                                "error"
                              );
                              return;
                            }
                            if (advisorId != null && advisorAccount == null) {
                              showToast(
                                "Please select Advisor Account",
                                "error"
                              );
                              return;
                            }
                            if (
                              subadvisorId != null &&
                              subAdvisorAccount == null
                            ) {
                              showToast(
                                "Please select Sub Advisor Account",
                                "error"
                              );
                              return;
                            }
                            if (
                              custodianId != null &&
                              custodianAccount == null
                            ) {
                              showToast(
                                "Please select Custodian Account",
                                "error"
                              );
                              return;
                            }
                            if (
                              assetManagerId != null &&
                              assetManagerAccount == null
                            ) {
                              showToast(
                                "Please select Asset Manager Account",
                                "error"
                              );
                              return;
                            }
                            setLoading(true);
                            handleCreateInvestment(e);
                          }}
                          className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                <div className="grid grid-cols-1 sm:grid-cols-2 mb-4 md:grid-cols-3 gap-6">
                  <div className="flex flex-col px-4 pt-4">
                    <label
                      htmlFor="refId"
                      className="mb-1 text-sm text-[#A6A6A6]"
                    >
                      Code
                    </label>
                    <span>{refId}</span>
                    <div className="mt-4">
                      <label
                        htmlFor="investmentType"
                        className="mb-1 text-sm text-[#A6A6A6]"
                      >
                        Investment Product Name
                      </label>
                      <div>{investmentProductName}</div>
                    </div>
                    <div className="mt-4">
                      <label
                        htmlFor="investmentType"
                        className="mb-1  text-sm text-[#A6A6A6]"
                      >
                        Risk Rating
                      </label>
                      <div>{riskRating}</div>
                    </div>
                    <div className="mt-4">
                      <label
                        htmlFor="investmentType"
                        className="mb-1  text-sm text-[#A6A6A6]"
                      >
                        Advisor Fees %
                      </label>
                      <div>{advisorFees.toFixed(2)}</div>
                    </div>
                    <div className="mt-4">
                      <label
                        htmlFor="investmentType"
                        className="mb-1  text-sm text-[#A6A6A6]"
                      >
                        Asset Manager Fees %
                      </label>
                      <div>{assetManagerFees.toFixed(2)}</div>
                    </div>
                  </div>
                  {/* center column */}
                  <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                    <div className="grid grid-cols-2 gap-4">
                      {/* Growth (%) */}
                      <div>
                        <label className="block text-sm text-[#A6A6A6]">
                          Growth (%)
                        </label>
                        <div className="relative">{growth.toFixed(2)}</div>
                      </div>

                      {/* Defensive (%) */}
                      <div>
                        <label className="block text-sm text-[#A6A6A6]">
                          Defensive (%)
                        </label>
                        <div className="relative">{defensive.toFixed(2)}</div>
                      </div>
                    </div>

                    {/* Investments */}
                    <div>
                      <label className="block mb-1 mt-4 text-sm text-[#A6A6A6]">
                        Investments
                      </label>
                      <div className="mt-1   flex flex-wrap gap-2">
                        {investments.map((investment, index) => (
                          <div
                            key={index}
                            className="flex items-center bg-[#FCFCFC] text-gray-700 text-sm px-3 py-1 rounded-lg border shadow-sm"
                          >
                            <span>{investment}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="mt-4">
                      <label
                        htmlFor="investmentType"
                        className="mb-1  text-sm text-[#A6A6A6]"
                      >
                        SMA Fees % | Including GST
                      </label>
                      <div>{smaFees.toFixed(2)}</div>
                    </div>
                    <div className="mt-4">
                      <label
                        htmlFor="investmentType"
                        className="mb-1  text-sm text-[#A6A6A6]"
                      >
                        Custodian Fees %
                      </label>
                      <div>{custodianFees.toFixed(2)}</div>
                    </div>
                    <div className="mt-4">
                      <label
                        htmlFor="investmentType"
                        className="mb-1  text-sm text-[#A6A6A6]"
                      >
                        Platform Fees %
                      </label>
                      <div>{platformFees.toFixed(2)}</div>
                    </div>
                  </div>
                  {/* Left column */}
                  <div className="flex lg:pt-4 pt-0 flex-col px-4">
                    <label
                      htmlFor="investmentManagerFees"
                      className=" mb-1 text-sm"
                    >
                      <span className="text-[#A6A6A6]">
                        Investment Manager Fees % | Weighted Average
                      </span>
                    </label>
                    <div>{managerFees.toFixed(2)}</div>
                    <label
                      htmlFor="investmentManagerFees"
                      className=" mb-1 mt-4 text-sm"
                    >
                      <span className="text-[#A6A6A6]">Sub Advisor Fees %</span>
                    </label>
                    <div>{subadvisorFees.toFixed(2)}</div>
                    <label
                      htmlFor="investmentManagerFees"
                      className=" mb-1 mt-4 text-sm"
                    >
                      <span className="text-[#A6A6A6]">
                        Strategy Inception Date
                      </span>
                    </label>
                    <div>{strategyDate}</div>
                    <label
                      htmlFor="investmentManagerFees"
                      className=" mb-1 mt-4 text-sm"
                    >
                      <span className="text-[#A6A6A6]">
                        Minimum Investment Amount
                      </span>
                    </label>
                    <div>
                      $
                      {(minimumInvestedAmount == null
                        ? 0
                        : minimumInvestedAmount
                      )
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <OtherDetails
              setaddToDashboard={setaddToDashboard}
              setaddMember={setaddMember}
              showAll={false}
              preselectedAddToDashboard={preselectedAddToDashboard}
              preselectedAddUser={preselectedAddUser}
            />
            {addMember && (
              <AccessibleTable IsUpdate={true} investment_id={investment_id} />
            )}
            {investment_id && (
              <DocumentsSection IsUpdate={true} investment_id={investment_id} />
            )}
          </div>
        )}
        <div className="flex items-center mt-6 p-4 bg-[#005A9C]">
          {/* Left Section: Back Button */}
          {filter != "trading" && (
            <div className="flex items-center justify-start w-full space-x-4">
              <div
                onClick={() => navigate("/")}
                className="flex items-center space-x-2 text-sm md:text-md font-medium py-1 px-8 text-white cursor-pointer"
              >
                {/* Image on the left */}
                <img
                  src="/white-arrow-back.svg" // Path to your image
                  alt="Back Icon"
                  className="w-4 h-4"
                />
                <span>Back</span>
              </div>
            </div>
          )}
          {filter == "trading" && (
            <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0 md:space-x-4">
              <div
                onClick={() => navigate("/")}
                className="flex items-center space-x-2 border border-white rounded-full text-sm md:text-md font-medium py-1 px-8 text-white cursor-pointer"
              >
                <span>Cancel</span>
              </div>
            </div>
          )}

          {filter == "trading" && tradingTab == "dda" && (
            <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  if (
                    Object.keys(errors).length !== 0 ||
                    Object.keys(totalErrors).length !== 0
                    //  ||
                    // Object.keys(allowedPercentError).length !== 0 ||
                    // Object.keys(allowedPercentErrorCategory).length !== 0
                  ) {
                    showToast("Please set your allocated stock", "error");
                    return;
                  }
                  if (Object.keys(twoPercentErrors).length !== 0) {
                    showToast("Please set Australian cash atleast 2%", "error");
                    return;
                  }
                  if (parseFloat(Number(totalPortfolio).toFixed(2)) != 100.0) {
                    showToast("Portfolio Allocation should be 100%", "error");
                    return;
                  }

                  setLoading(true);
                  updateDAA(e);
                }}
                className="flex w-full md:w-auto items-center space-x-2 bg-white text-black font-medium py-2 px-4 rounded-full text-sm hover:bg-gray-200"
              >
                <span>Submit to Admin</span>
              </button>
            </div>
          )}

          {/* Right Section: Download Button */}
          {filter == "view" && !isLoading && (
            <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4">
              {/* <button
                onClick={(e) => {
                  e.preventDefault();
                  setLoading(true);
                  downloadValuationReport(e);
                }}
                className="flex w-full md:w-auto items-center space-x-2 bg-white text-black font-medium py-2 px-4 rounded-full text-sm hover:bg-gray-200"
              >
                <span>Download Holding Valuation Report</span>
              </button> */}
              {/* <button
                onClick={(e) => {
                  e.preventDefault();
                  setLoading(true);
                  downloadPDF(e);
                }}
                className="flex w-full md:w-auto items-center space-x-2 bg-white text-black font-medium py-2 px-4 rounded-full text-sm hover:bg-gray-200"
              >
                <span>Download Factsheet</span>
              </button> */}
              <DownloadReportButton
                onContinue={handleContinue}
                onExcel={handleExcel}
                checkDisabled={isLoadingGraph === true}
                buttonText="Download Factsheet"
                confirmTitle="Download Factsheet"
                confirmMessage="You can download the report in PDF or Excel format."
              />
            </div>
          )}
          {!isCurrentInvestorSelected && filter == "investors" && (
            <div className="flex items-center justify-end w-full">
              <button
                disabled={isClientExist && isCreatorExist ? false : true}
                onClick={(e) => {
                  e.preventDefault();
                  if (!clientAccountId) {
                    showToast("Please select account!", "error");
                    return;
                  }
                  if (!investmentAmount) {
                    showToast("Please Enter a Valid Amount!", "error");
                    return;
                  }

                  setLoading(true);
                  handleSubmit(e);
                }}
                className={`flex items-center space-x-2 bg-white text-black font-medium py-2 px-4 rounded-full text-sm ${
                  isClientExist && isCreatorExist
                    ? "bg-white text-black"
                    : "bg-gray-300 text-gray-600"
                }`}
              >
                <span>Purchase Portfolio</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InvestmentDetailsByID;
